import {
  toRatio1hooqit5gulhr as toRatio,
  interpolate27vw5eh8zjnyi as interpolate,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance,
  _Ratio___get_absoluteValue__impl__92ozif22un4a8w9a8ev as _Ratio___get_absoluteValue__impl__92ozif,
  Ratio__times_impl_ucdh7y1eb1bj32n3p46 as Ratio__times_impl_ucdh7y,
  toRatioClampedeq87m2alw3kr as toRatioClamped,
  toRatioa3v13oich5q as toRatio_0,
  Ratio136tf4z2t0p2d as Ratio,
  clamp1qclpmpfxm7xb as clamp,
  _Ratio___init__impl__9mwvn21rjrz0s2y877i as _Ratio___init__impl__9mwvn2,
  Ratio__compareTo_impl_z2ienc1iwi3w3dhe1b7 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg3oqkno1go43tn as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epze3e3zsci3ipwe7 as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7y151ap1tls937r as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli6w7w64hz8t0rv as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default1ua43koqhm6mp as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v7lufr2urxbhm as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate35pbs3ac913y4 as interpolate_1,
  _Ratio___init__impl__9mwvn21qo8ztog8o9ep as _Ratio___init__impl__9mwvn2_0,
  umod164hvijxhfi8p as umod,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  clamp31lhm66c28ic8 as clamp_0,
  interpolate1wglaj6k11c6v as interpolate_2,
  almostEquals13hvojogln91b as almostEquals,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
  Companion_getInstancech3bi94cc2ym as Companion_getInstance_0,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_1,
} from './korlibs-korlibs-math-core.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_1,
  Companion_getInstance1ygiwm9bgjia3 as Companion_getInstance_2,
  _Angle___init__impl__g23q1m1vusxs8sthxgw as _Angle___init__impl__g23q1m,
  adjustFromUp1ak85cceintt4 as adjustFromUp,
  Angle__minus_impl_xeau7k30vsnq3biqxde as Angle__minus_impl_xeau7k,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__plus_impl_26v37k2akkjkyjv8qeu as Angle__plus_impl_26v37k,
  _Angle___get_absoluteValue__impl__4qoakv3gpdj6wpeuir3 as _Angle___get_absoluteValue__impl__4qoakv,
  Angle__umod_impl_4wilf73q48bzoy6t00h as Angle__umod_impl_4wilf7,
  Angle__compareTo_impl_a0hfdsdv09zqotoc4l as Angle__compareTo_impl_a0hfds,
  _Angle___get_ratio__impl__ap3on42zzwqtrc65vpb as _Angle___get_ratio__impl__ap3on4,
  interpolatewhd2sgxffql5 as interpolate_3,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__cosine_impl_bgvzunl3ekczcg3dy9 as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xvmzbai5p75zu2 as Angle__sine_impl_3l11xv,
  interpolateAngleDenormalized1hkwzk523mo1c as interpolateAngleDenormalized,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_3,
  Line2D2pf35pcx71ncp as Line2D,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_4,
  Angle__times_impl_v3s9y2z9k172i2sc9a as Angle__times_impl_v3s9y2,
  _Angle___get_normalized__impl__9s30ys274hpyvbigjus as _Angle___get_normalized__impl__9s30ys,
  _Angle___get_radians__impl__n00yt523wqxa1jdhpa1 as _Angle___get_radians__impl__n00yt5,
  Angle__times_impl_v3s9y213uoamn5n3x7j as Angle__times_impl_v3s9y2_0,
  Angle__div_impl_ut2btdt21di2brbxq0 as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu3fuyxpbgo71fk as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi1kdagydgbnjhl as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdye0u4tzlx2qii as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstance9hqru60m2833 as Companion_getInstance_5,
  MarginInt3jiec8xsxkfd as MarginInt,
  BoundsBuilder__plus_impl_cz7f7x1gtmpkit3llyq as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance3om7tc9mg7edv as Companion_getInstance_6,
  _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5pl3cj7mhzkfb01q as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901frdiuz4dirxfxh as Angle__unaryMinus_impl_7901fr,
  minus35u9jfp5de3x as minus,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o as BoundsBuilder__plus_impl_cz7f7x_0,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance2npyq9n96lvll as Companion_getInstance_7,
  Companion_getInstance145etojj24o8w as Companion_getInstance_8,
} from './korlibs-korlibs-math-vector.mjs';
import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  listOf1jh22dvmctj1r as listOf_0,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  Comparator2b3maoeh98xtg as Comparator,
  toList3jhuyej2anx2q as toList,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  to2cs3ny02qtbcb as to,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  plus310ted5e4i90h as plus,
  distinct10qe1scfdvu5k as distinct,
  toIntArray2d4xwvtjb01mq as toIntArray,
  sortedArray2m4d4tn4pbwoi as sortedArray,
  toList383f556t1dixk as toList_0,
  Paire9pteg33gng7 as Pair,
  step18s9qzr5xwxat as step,
  get_sign1dnxi33u9vk0c as get_sign,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  numberToDouble210hrknaofnhf as numberToDouble,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  uppercaseChar6lahngw3wvwg as uppercaseChar,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  Exceptiondt2hlxn7j7vw as Exception,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  println2shhhgwwt4c61 as println,
  enumEntries20mr21zbe3az4 as enumEntries,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KProperty02ce7r476m8633 as KProperty0,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zamdlvo8rkghxe3 as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3gtiempqu7d21 as _BSearchResult___get_found__impl__om04iz,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5krazm2irv549pugj as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq4312kfva7q1s86i as _BSearchResult___get_nearIndex__impl__s8nq43,
  getCyclic18d9063nmuul as getCyclic_0,
  BVHdgoku170r1rz as BVH,
  BVHIntervals11ladchlo7ig0 as BVHIntervals,
  _BVHRay___init__impl__rrqut1wksan13jo12b as _BVHRay___init__impl__rrqut,
  _BVHRect___init__impl__pawpsv13onfwumlb9kw as _BVHRect___init__impl__pawpsv,
  BVHRect__min_impl_5ss93n2jfqrhkmyl6xm as BVHRect__min_impl_5ss93n,
  BVHRect__size_impl_axghd82vtcbc1dq7n7n as BVHRect__size_impl_axghd8,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-korlibs-datastructure.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var sign = Math.sign;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.d3s_1 = IntArrayList.f31(16);
    this.e3s_1 = IntArrayList.f31(16);
  }
  j1() {
    return this.d3s_1.j1();
  }
  a1() {
    return this.j1() === 0;
  }
  y2k() {
    return this.j1() > 0;
  }
  wh() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.clear.<anonymous>' call
    this.d3s_1.o3();
    this.e3s_1.o3();
    return this;
  }
  f3s() {
    return this.y2k() ? this.d3s_1.h13(0) : 0;
  }
  g3s() {
    return this.y2k() ? this.e3s_1.h13(this.e3s_1.j1() - 1 | 0) : 0;
  }
  h3s(x) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = this.j1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findNearIndex.<anonymous>' call
        var min = this.d3s_1.h13(mid);
        var max = this.e3s_1.h13(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearch.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  i3s(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var toIndex = this.j1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findLeftBound.<anonymous>' call
        var mval = compareTo(this.d3s_1.h13(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchLeft.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$2 = Math.min(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.j1() - 1 | 0);
  }
  j3s(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var toIndex = this.j1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findRightBound.<anonymous>' call
        var mval = compareTo(this.e3s_1.h13(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchRight.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$2 = Math.max(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.j1() - 1 | 0);
  }
  i3f(min, max) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block_0: {
      // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(min <= max)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.m5(toString(message));
      }
      if (this.a1()) {
        insertAt(this, this.j1(), min, max);
      } else if (min === this.g3s()) {
        this.e3s_1.t31(this.e3s_1.j1() - 1 | 0, max);
      } else if (max === this.f3s()) {
        this.d3s_1.t31(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.a1()) {
            break $l$block;
          }
          var nmin = this.i3s(min);
          var nmax = this.j3s(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>.<anonymous>' call
              var n_0 = n;
              var x1 = this.d3s_1.h13(n);
              var x2 = this.e3s_1.h13(n);
              if (this.k3s(x1, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = n_0;
                var tmp = removeStart;
                // Inline function 'kotlin.math.min' call
                var a = this.d3s_1.h13(removeStart);
                // Inline function 'kotlin.math.min' call
                var b = Math.min(x1, min);
                var tmp$ret$3 = Math.min(a, b);
                this.d3s_1.t31(tmp, tmp$ret$3);
                var tmp_0 = removeStart;
                // Inline function 'kotlin.math.max' call
                var a_0 = this.e3s_1.h13(removeStart);
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$5 = Math.max(a_0, b_0);
                this.e3s_1.t31(tmp_0, tmp$ret$5);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.f3s()) {
            insertAt(this, 0, min, max);
          } else if (min > this.g3s()) {
            insertAt(this, this.j1(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.i3s(min), 1);
            var last = this.j3s(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.e3s_1.h13(m - 1 | 0);
                var currMin = this.d3s_1.h13(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message_0 = 'Unexpected';
            throw IllegalStateException.m5(toString(message_0));
          }
      }
    }
    return this;
  }
  dp(v) {
    return _BSearchResult___get_found__impl__om04iz(this.h3s(v));
  }
  l3s(a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>' call
    var aSmaller = a.j1() < b.j1();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.wh();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>' call
        var x1 = av.d3s_1.h13(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.e3s_1.h13(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.a1()) {
            break $l$block;
          }
          var nmin = bv.i3s(x1);
          var nmax = bv.j3s(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.intersection.<anonymous>' call
              var x1_0 = bv.d3s_1.h13(n_0);
              var x2 = bv.e3s_1.h13(n_0);
              if (bv.k3s(x1_0, x2, x1, max)) {
                // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.math.max' call
                var min = Math.max(x1_0, x1);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.i3f(min, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  k3s(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>' call
    this_0.ic('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>.<anonymous>' call
        var min = this.d3s_1.h13(n);
        var max = this.e3s_1.h13(n);
        var first = n === 0;
        if (!first) {
          this_0.ic(', ');
        }
        this_0.ic('' + min + '-' + max);
      }
       while (inductionVariable < last);
    this_0.ic(']');
    return this_0.toString();
  }
}
class StrokePointsMode extends Enum {}
class StrokePointsBuilder {
  constructor(width, mode, generateDebug) {
    mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
    generateDebug = generateDebug === VOID ? false : generateDebug;
    this.w3s_1 = width;
    this.x3s_1 = mode;
    this.y3s_1 = generateDebug;
    this.z3s_1 = 20;
    var tmp = this;
    var tmp_0;
    switch (this.x3s_1.v3_1) {
      case 0:
        tmp_0 = 6;
        break;
      case 1:
        tmp_0 = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.a3t_1 = new DoubleVectorArrayList(tmp_0);
    this.b3t_1 = new PointArrayList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.c3t_1 = ArrayList.m1();
  }
  e3t() {
    return this.a3t_1;
  }
  toString() {
    return 'StrokePointsBuilder(' + this.w3s_1 + ', ' + this.a3t_1.toString() + ')';
  }
  f3t(pos, normal, width, maxWidth) {
    switch (this.x3s_1.v3_1) {
      case 0:
        // Inline function 'kotlin.math.absoluteValue' call

        var tmp$ret$0 = Math.abs(maxWidth);
        this.a3t_1.k32(pos.i2h_1, pos.j2h_1, normal.i2h_1, normal.j2h_1, width, tmp$ret$0);
        break;
      case 1:
        this.a3t_1.h32(pos.i2h_1 + normal.i2h_1 * width, pos.j2h_1 + normal.j2h_1 * width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  g3t(pos, normal, width, maxWidth, $super) {
    maxWidth = maxWidth === VOID ? width : maxWidth;
    var tmp;
    if ($super === VOID) {
      this.f3t(pos, normal, width, maxWidth);
      tmp = Unit_instance;
    } else {
      tmp = $super.f3t.call(this, pos, normal, width, maxWidth);
    }
    return tmp;
  }
  h3t(center, pos, sign) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var dist = Vector2D.k2h(pos.i2h_1 - center.i2h_1, pos.j2h_1 - center.j2h_1);
    var tmp;
    if (sign < 0.0) {
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      tmp = Vector2D.k2h(-dist.i2h_1, -dist.j2h_1);
    } else {
      tmp = dist;
    }
    var normal = tmp;
    this.g3t(center, normal.q2s(), dist.a() * sign);
  }
  i3t(center, pos, sign, $super) {
    sign = sign === VOID ? 1.0 : sign;
    var tmp;
    if ($super === VOID) {
      this.h3t(center, pos, sign);
      tmp = Unit_instance;
    } else {
      tmp = $super.h3t.call(this, center, pos, sign);
    }
    return tmp;
  }
  j3t(pos, normal, width) {
    this.g3t(pos, normal, width);
    this.g3t(pos, normal, -width);
  }
  k3t(curr, next, kind, miterLimitRatio) {
    var commonPoint = curr.l3t(Companion_getInstance().i10_1);
    var currTangent = curr.m3t(Companion_getInstance().i10_1);
    var currNormal = curr.n3t(Companion_getInstance().i10_1);
    var nextTangent = next.m3t(Companion_getInstance().f10_1);
    var nextNormal = next.n3t(Companion_getInstance().f10_1);
    var tmp = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.w3s_1;
    var that = Vector2D.k2h(currNormal.i2h_1 * scale, currNormal.j2h_1 * scale);
    var tmp$ret$1 = Vector2D.k2h(commonPoint.i2h_1 + that.i2h_1, commonPoint.j2h_1 + that.j2h_1);
    var currLine0 = tmp.o3t(tmp$ret$1, currTangent);
    var tmp_0 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_0 = -this.w3s_1;
    var that_0 = Vector2D.k2h(currNormal.i2h_1 * scale_0, currNormal.j2h_1 * scale_0);
    var tmp$ret$3 = Vector2D.k2h(commonPoint.i2h_1 + that_0.i2h_1, commonPoint.j2h_1 + that_0.j2h_1);
    var currLine1 = tmp_0.o3t(tmp$ret$3, currTangent);
    var tmp_1 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_1 = this.w3s_1;
    var that_1 = Vector2D.k2h(nextNormal.i2h_1 * scale_1, nextNormal.j2h_1 * scale_1);
    var tmp$ret$5 = Vector2D.k2h(commonPoint.i2h_1 + that_1.i2h_1, commonPoint.j2h_1 + that_1.j2h_1);
    var nextLine0 = tmp_1.o3t(tmp$ret$5, nextTangent);
    var tmp_2 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_2 = -this.w3s_1;
    var that_2 = Vector2D.k2h(nextNormal.i2h_1 * scale_2, nextNormal.j2h_1 * scale_2);
    var tmp$ret$7 = Vector2D.k2h(commonPoint.i2h_1 + that_2.i2h_1, commonPoint.j2h_1 + that_2.j2h_1);
    var nextLine1 = tmp_2.o3t(tmp$ret$7, nextTangent);
    var intersection0 = lineIntersectionPoint(Companion_instance_19, currLine0, nextLine0);
    var intersection1 = lineIntersectionPoint(Companion_instance_19, currLine1, nextLine1);
    if (intersection0 == null || intersection1 == null) {
      this.j3t(commonPoint, currNormal, this.w3s_1);
      return Unit_instance;
    }
    var direction = Companion_getInstance_1().q2w(currTangent, nextTangent);
    var miterLength = Companion_getInstance_1().n2w(intersection0, intersection1);
    var miterLimit = miterLimitRatio * this.w3s_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_2();
    var up = Companion_getInstance_1().e2i_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x = nextTangent.i2h_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_0 = nextTangent.j2h_1;
    var radians = Math.atan2(x, x_0);
    var tmp$ret$9 = _Angle___init__impl__g23q1m(radians);
    var tmp_3 = adjustFromUp(tmp$ret$9, up);
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_2();
    var up_0 = Companion_getInstance_1().e2i_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x_1 = currTangent.i2h_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_2 = currTangent.j2h_1;
    var radians_0 = Math.atan2(x_1, x_2);
    var tmp$ret$13 = _Angle___init__impl__g23q1m(radians_0);
    var tmp$ret$15 = adjustFromUp(tmp$ret$13, up_0);
    var angle = Angle__minus_impl_xeau7k(tmp_3, tmp$ret$15);
    if (!kind.equals(LineJoin_MITER_getInstance()) || miterLength > miterLimit) {
      var p1 = direction <= 0.0 ? projectedPoint(currLine0, commonPoint) : projectedPoint(nextLine1, commonPoint);
      var p2 = direction <= 0.0 ? projectedPoint(nextLine0, commonPoint) : projectedPoint(currLine1, commonPoint);
      var p3 = direction <= 0.0 ? lineIntersectionPoint(Companion_instance_19, currLine1, nextLine1) : lineIntersectionPoint(Companion_instance_19, currLine0, nextLine0);
      var p4Line = direction < 0.0 ? nextLine1 : nextLine0;
      var p4 = projectedPoint(p4Line, commonPoint);
      if (p3 == null) {
        p3 = p4;
      }
      var angleB = _Angle___get_absoluteValue__impl__4qoakv(Angle__plus_impl_26v37k(angle, get_degrees(180)));
      var angle2 = _Angle___get_absoluteValue__impl__4qoakv(Angle__umod_impl_4wilf7(angle, get_degrees(180)));
      var angle3 = Angle__compareTo_impl_a0hfds(angle2, get_degrees(90)) >= 0 ? Angle__minus_impl_xeau7k(get_degrees(180), angle2) : angle2;
      var ratio = toRatioClamped(Ratio__times_impl_ucdh7y(_Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle3)), 4.0));
      var p5 = interpolate_3(toRatio_0(ratio), p4, ensureNotNull(p3));
      if (this.y3s_1) {
        this.c3t_1.f(nextLine1.r3t(1000.0).j13());
        this.c3t_1.f(currLine1.r3t(1000.0).j13());
        this.c3t_1.f(nextLine0.r3t(1000.0).j13());
        this.c3t_1.f(currLine0.r3t(1000.0).j13());
        this.c3t_1.f(Companion_instance_19.o3t(commonPoint, currTangent).r3t(1000.0).j13());
        this.c3t_1.f(Companion_instance_19.o3t(commonPoint, nextTangent).r3t(1000.0).j13());
        this.b3t_1.s3e(p3);
        this.b3t_1.s3e(p4);
        this.b3t_1.s3e(p5);
      }
      var p6 = p5;
      if (direction < 0.0) {
        this.i3t(commonPoint, p1);
        this.h3t(commonPoint, p6, -1.0);
        this.i3t(commonPoint, p2);
        this.h3t(commonPoint, p6, -1.0);
      } else {
        this.i3t(commonPoint, p6);
        this.h3t(commonPoint, p2, -1.0);
        this.i3t(commonPoint, p6);
        this.h3t(commonPoint, p1, -1.0);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d0 = Vector2D.k2h(intersection0.i2h_1 - commonPoint.i2h_1, intersection0.j2h_1 - commonPoint.j2h_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d1 = Vector2D.k2h(commonPoint.i2h_1 - intersection1.i2h_1, commonPoint.j2h_1 - intersection1.j2h_1);
    var tmp_4 = d0.q2s();
    var tmp_5 = d0.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = d0.a();
    var tmp$ret$18 = Math.abs(this_0);
    this.f3t(commonPoint, tmp_4, tmp_5, tmp$ret$18);
    var tmp_6 = d1.q2s();
    var tmp_7 = -d1.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = d1.a();
    var tmp$ret$19 = Math.abs(this_1);
    this.f3t(commonPoint, tmp_6, tmp_7, tmp$ret$19);
  }
  s3t(curr, ratio, kind) {
    switch (kind.v3_1) {
      case 1:
      case 2:
        // Inline function 'kotlin.let' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCap.<anonymous>' call

        var it = curr.n3t(ratio).y2w();
        var tmp;
        if (equals(ratio, Companion_getInstance().i10_1)) {
          // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
          tmp = Vector2D.k2h(-it.i2h_1, -it.j2h_1);
        } else {
          tmp = it;
        }

        var derivate = tmp;
        switch (kind.v3_1) {
          case 1:
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var this_0 = curr.l3t(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale = this.w3s_1;
            var that = Vector2D.k2h(derivate.i2h_1 * scale, derivate.j2h_1 * scale);
            var tmp$ret$4 = Vector2D.k2h(this_0.i2h_1 + that.i2h_1, this_0.j2h_1 + that.j2h_1);
            this.j3t(tmp$ret$4, curr.n3t(ratio), this.w3s_1);
            break;
          case 2:
            var mid = curr.l3t(ratio);
            var normal = curr.n3t(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_0 = this.w3s_1;
            var that_0 = Vector2D.k2h(normal.i2h_1 * scale_0, normal.j2h_1 * scale_0);
            var p0 = Vector2D.k2h(mid.i2h_1 + that_0.i2h_1, mid.j2h_1 + that_0.j2h_1);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_1 = -this.w3s_1;
            var that_1 = Vector2D.k2h(normal.i2h_1 * scale_1, normal.j2h_1 * scale_1);
            var p3 = Vector2D.k2h(mid.i2h_1 + that_1.i2h_1, mid.j2h_1 + that_1.j2h_1);
            var a = equals(ratio, Companion_getInstance().f10_1) ? p0 : p3;
            var b = equals(ratio, Companion_getInstance().f10_1) ? p3 : p0;
            this.t3t(a, b, ratio, mid);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't happen";
            throw IllegalStateException.m5(toString(message));
        }

        break;
      case 0:
        this.j3t(curr.l3t(ratio), curr.n3t(ratio), this.w3s_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  u3t(p0, p3, ratio, mid, nsteps) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_2();
    var up = Companion_getInstance_1().e2i_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = mid.i2h_1;
    var y0 = mid.j2h_1;
    var x1 = p0.i2h_1;
    var y1 = p0.j2h_1;
    var angleStart = Angle_between(x0, y0, x1, y1, up);
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_2();
    var up_0 = Companion_getInstance_1().e2i_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0_0 = mid.i2h_1;
    var y0_0 = mid.j2h_1;
    var x1_0 = p3.i2h_1;
    var y1_0 = p3.j2h_1;
    var angleEnd = Angle_between(x0_0, y0_0, x1_0, y1_0, up_0);
    if (equals(ratio, Companion_getInstance().i10_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_1 = Companion_getInstance_1().e2i_1;
      var tmp$ret$8 = Vector2D.k2h(0.0 + Angle__cosine_impl_bgvzun(angleEnd, up_1) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleEnd, up_1) * 1.0);
      this.j3t(mid, tmp$ret$8, this.w3s_1);
    }
    var addAngle = Companion_getInstance_1().q2w(p0, p3) <= 0.0 ? Companion_getInstance_2().r2h_1 : Companion_getInstance_2().t2h_1;
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio_0 = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePointsCap.<anonymous>' call
        var it = toRatio(ratio_0);
        var angle = interpolateAngleDenormalized(it, angleStart, angleEnd);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var this_0 = Companion_getInstance_1();
        var angle_0 = Angle__plus_impl_26v37k(angle, addAngle);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var up_2 = this_0.e2i_1;
        var dir = Vector2D.k2h(0.0 + Angle__cosine_impl_bgvzun(angle_0, up_2) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle_0, up_2) * 1.0);
        this.f3t(mid, dir, 0.0, this.w3s_1);
        this.f3t(mid, dir, this.w3s_1, this.w3s_1);
      }
       while (!(n === end));
    if (equals(ratio, Companion_getInstance().f10_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_3 = Companion_getInstance_1().e2i_1;
      var tmp$ret$12 = Vector2D.k2h(0.0 + Angle__cosine_impl_bgvzun(angleStart, up_3) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleStart, up_3) * 1.0);
      this.j3t(mid, tmp$ret$12, this.w3s_1);
    }
  }
  t3t(p0, p3, ratio, mid, nsteps, $super) {
    var tmp;
    if (mid === VOID) {
      // Inline function 'korlibs.math.geom.Companion.middle' call
      Companion_getInstance_1();
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_0 = Vector2D.k2h(p0.i2h_1 + p3.i2h_1, p0.j2h_1 + p3.j2h_1);
      tmp = Vector2D.k2h(this_0.i2h_1 * 0.5, this_0.j2h_1 * 0.5);
    } else {
      tmp = mid;
    }
    mid = tmp;
    nsteps = nsteps === VOID ? this.z3s_1 : nsteps;
    var tmp_0;
    if ($super === VOID) {
      this.u3t(p0, p3, ratio, mid, nsteps);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.u3t.call(this, p0, p3, new Ratio(ratio), mid, nsteps);
    }
    return tmp_0;
  }
  v3t(curr, nsteps) {
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = false ? 0 : 1;
    var end = false ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePoints.<anonymous>' call
        var it = toRatio(ratio);
        this.j3t(curr.l3t(it), curr.n3t(it), this.w3s_1);
      }
       while (!(n === end));
  }
  w3t(curr, nsteps, $super) {
    nsteps = nsteps === VOID ? numberToInt(clamp(curr.a() / 10.0, 10.0, 100.0)) : nsteps;
    var tmp;
    if ($super === VOID) {
      this.v3t(curr, nsteps);
      tmp = Unit_instance;
    } else {
      tmp = $super.v3t.call(this, curr, nsteps);
    }
    return tmp;
  }
  d3t(curves, join, startCap, endCap, miterLimit, forceClosed) {
    var closed = forceClosed == null ? curves.z3t_1 : forceClosed;
    var curves_0 = curves.y3t_1;
    var inductionVariable = 0;
    var last = curves_0.j1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = getCyclic(curves_0, n + 0 | 0);
        var next = getCyclic(curves_0, n + 1 | 0);
        if (n === 0) {
          if (closed) {
            this.k3t(getCyclic(curves_0, n - 1 | 0), curr, join, miterLimit);
          } else {
            this.s3t(curr, Companion_getInstance().f10_1, startCap);
          }
        }
        if (!(curr.p3u() === 1)) {
          this.w3t(curr);
        }
        if (n < (curves_0.j1() - 1 | 0)) {
          this.k3t(curr, next, join, miterLimit);
        } else {
          if (closed) {
            this.k3t(curr, next, join, miterLimit);
          } else {
            this.s3t(curr, Companion_getInstance().i10_1, endCap);
          }
        }
      }
       while (inductionVariable <= last);
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.q3u_1 = index;
    this.r3u_1 = curve;
    this.s3u_1 = startLength;
    this.t3u_1 = endLength;
    this.u3u_1 = bounds;
  }
  k13(length) {
    var containsLower = this.s3u_1;
    return length <= this.t3u_1 ? containsLower <= length : false;
  }
  a() {
    return this.t3u_1 - this.s3u_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.q3u_1 + ', curve=' + this.r3u_1.toString() + ', startLength=' + this.s3u_1 + ', endLength=' + this.t3u_1 + ', bounds=' + this.u3u_1.toString() + ')';
  }
  hashCode() {
    var result = this.q3u_1;
    result = imul(result, 31) + this.r3u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.s3u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t3u_1) | 0;
    result = imul(result, 31) + this.u3u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.q3u_1 === tmp0_other_with_cast.q3u_1))
      return false;
    if (!this.r3u_1.equals(tmp0_other_with_cast.r3u_1))
      return false;
    if (!equals(this.s3u_1, tmp0_other_with_cast.s3u_1))
      return false;
    if (!equals(this.t3u_1, tmp0_other_with_cast.t3u_1))
      return false;
    if (!this.u3u_1.equals(tmp0_other_with_cast.u3u_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.x3t_1 = new Mixin();
    this.y3t_1 = beziers;
    this.z3t_1 = closed;
    this.a3u_1 = false;
    var tmp = this;
    tmp.b3u_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.c3u_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.d3u_1 = lazy(Curves$length$delegate$lambda(this));
  }
  n13(_set____db54di) {
    this.x3t_1.n13(_set____db54di);
  }
  o13() {
    return this.x3t_1.o13();
  }
  w3u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3u_1;
    infos$factory();
    return this_0.b2();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3u_1;
    length$factory();
    return this_0.b2();
  }
  x3u(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.s3u_1 / this.a());
  }
  y3u(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.t3u_1 / this.a());
  }
  z3u(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.w3u();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance().f10_1) < 0)
      return first(this.w3u());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance().i10_1) > 0)
      return last(this.w3u());
    var tmp0_elvis_lhs = getOrNull(this.w3u(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.m5(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  l3t(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.z3u(t);
    var posInCurve = pos - info.s3u_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.calc.<anonymous>' call
    return info.r3u_1.l3t(toRatio_0(ratioInCurve));
  }
  n3t(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.z3u(t);
    var posInCurve = pos - info.s3u_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.normal.<anonymous>' call
    return info.r3u_1.n3t(ratioInCurve);
  }
  m3t(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.z3u(t);
    var posInCurve = pos - info.s3u_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.tangent.<anonymous>' call
    return info.r3u_1.m3t(ratioInCurve);
  }
  a3v(length) {
    if (length <= 0.0)
      return Companion_getInstance().f10_1;
    if (length >= this.a())
      return Companion_getInstance().i10_1;
    var tmp = this.w3u();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance().j10_1;
    }
    var info = this.w3u().i1(index);
    var lengthInCurve = length - info.s3u_1;
    var ratioInCurve = info.r3u_1.a3v(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance().f10_1, Companion_getInstance().i10_1, this.x3u(info), this.y3u(info));
  }
  b3v(len0, len1) {
    return this.c3v(this.a3v(len0), this.a3v(len1));
  }
  c3v(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.c3v(t1, t0);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.m5(toString(message));
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.z3u(t0);
    var posInCurve = pos - info.s3u_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>' call
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.z3u(t1);
    var posInCurve_0 = pos_0 - info_0.s3u_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>' call
    var tmp;
    if (info.q3u_1 === info_0.q3u_1) {
      tmp = listOf(info.r3u_1.c3v(ratioInCurve, ratioInCurve_0).d3v_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.m1();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>.<anonymous>' call
      if (!equals(ratioInCurve, Companion_getInstance().i10_1)) {
        this_0.f(info.r3u_1.h3v(ratioInCurve).d3v_1);
      }
      var inductionVariable = info.q3u_1 + 1 | 0;
      var last = info_0.q3u_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.f(this.w3u().i1(index).r3u_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance().f10_1)) {
        this_0.f(info_0.r3u_1.i3v(ratioInCurve_0).d3v_1);
      }
      tmp = this_0.o8();
    }
    var tmp$ret$7 = tmp;
    return new Curves(tmp$ret$7, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.y3t_1) + ', closed=' + this.z3t_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y3t_1);
    result = imul(result, 31) + getBooleanHashCode(this.z3t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.y3t_1, tmp0_other_with_cast.y3t_1))
      return false;
    if (!(this.z3t_1 === tmp0_other_with_cast.z3t_1))
      return false;
    return true;
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.i2l() : p;
    t = t === VOID ? Companion_getInstance().f10_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.w3v_1 = p;
    this.x3v_1 = t;
    this.y3v_1 = dSq;
  }
  a3w(other, epsilon) {
    return this.w3v_1.s2s(other.w3v_1, epsilon) && isAlmostEquals(this.x3v_1, other.x3v_1, toRatio(epsilon)) && isAlmostEquals_0(this.y3v_1, other.y3v_1, epsilon);
  }
  uz(other, epsilon) {
    return this.a3w(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.w3v_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.x3v_1) + ', dSq=' + this.y3v_1 + ')';
  }
  hashCode() {
    var result = this.w3v_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.x3v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y3v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.w3v_1.equals(tmp0_other_with_cast.w3v_1))
      return false;
    if (!equals(this.x3v_1, tmp0_other_with_cast.x3v_1))
      return false;
    if (!equals(this.y3v_1, tmp0_other_with_cast.y3v_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.j3v_1 = xt;
    this.k3v_1 = yt;
    var tmp = this;
    tmp.l3v_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.m3v_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.n3v_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  b3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m3v_1;
    xt01$factory();
    return this_0.b2();
  }
  c3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n3v_1;
    yt01$factory();
    return this_0.b2();
  }
  u3v(index) {
    return index === 0 ? this.b3w() : this.c3w();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.j3v_1, other.j3v_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.k3v_1, other.k3v_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.j3v_1) + imul(contentHashCode(this.k3v_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.j3v_1) + ', y=' + contentToString(this.k3v_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.o3v_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.p3v_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.q3v_1 = 6.283185307179586;
    this.r3v_1 = Line2D.j2l(0, 0, 1, 0);
    this.s3v_1 = new Float64Array(0);
  }
  d3w(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.i2h_1;
    var y0 = p0.j2h_1;
    var x1 = p1.i2h_1;
    var y1 = p1.j2h_1;
    var x2 = p2.i2h_1;
    var y2 = p2.j2h_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.i2h_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.j2h_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.k2h(x, y);
    return out;
  }
  e3w(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.i2h_1;
    var y0 = p.j2h_1;
    var xc = c.i2h_1;
    var yc = c.j2h_1;
    var x1 = a.i2h_1;
    var y1 = a.j2h_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.k2h(x, y);
    return out;
  }
  f3w(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  g3w(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  static m3w(points, dummy) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.e3u_1 = points;
    if ($this.e3u_1.j1() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.m5(toString(message));
    }
    var tmp = $this;
    tmp.f3u_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.g3u_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.h3u_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.i3u_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.j3u_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.k3u_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.l3u_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.m3u_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.n3u_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.o3u_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static n3w() {
    Companion_getInstance_9();
    return this.o3w(Vector2D.u2n(0.0, 0.0), Vector2D.u2n(0.0, 0.0));
  }
  static o3w(p0, p1) {
    Companion_getInstance_9();
    return this.m3w(pointArrayListOf(p0, p1), Unit_instance);
  }
  static p3w(p0, p1, p2) {
    Companion_getInstance_9();
    return this.m3w(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static q3w(p0, p1, p2, p3) {
    Companion_getInstance_9();
    return this.m3w(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static r3w(points) {
    Companion_getInstance_9();
    return this.m3w(points.q3e(), Unit_instance);
  }
  s3w(other, epsilon) {
    if (!(this.e3u_1.j1() === other.e3u_1.j1()))
      return false;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = until(0, this.e3u_1.j1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.a1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.math.geom.bezier.Bezier.isAlmostEquals.<anonymous>' call
        if (!this.e3u_1.i1(element).s2s(other.e3u_1.i1(element), epsilon)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  uz(other, epsilon) {
    return this.s3w(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  v3v(t) {
    return this.t3w(t);
  }
  v3u() {
    return this.j3w();
  }
  u3w(m) {
    return _getBoundingBox(this, m);
  }
  l3t(t) {
    return this.t3w(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.e3u_1, other.e3u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.e3u_1);
  }
  toString() {
    return 'Bezier(' + toString(this.e3u_1) + ')';
  }
  h3w() {
    return 2;
  }
  p3u() {
    return this.e3u_1.j1() - 1 | 0;
  }
  i3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g3u_1;
    dpoints$factory();
    return this_0.b2();
  }
  t3v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i3u_1;
    extrema$factory();
    return this_0.b2();
  }
  v3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j3u_1;
    outerCircle$factory();
    return this_0.b2();
  }
  j3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k3u_1;
    boundingBox$factory();
    return this_0.b2();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l3u_1;
    length$factory_0();
    return this_0.b2();
  }
  w3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m3u_1;
    lut$factory();
    return this_0.b2();
  }
  a3v(length) {
    return this.w3w().e3x(length).y3w_1;
  }
  f3x(steps, out) {
    out.o3();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance();
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.Bezier.getLUT.<anonymous>' call
        var t = toRatio(ratio);
        out.g3x(t, this.t3w(t));
      }
       while (!(n === end));
    return out;
  }
  l3w(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.h3x(this, steps + 1 | 0) : out;
    return $super === VOID ? this.f3x(steps, out) : $super.f3x.call(this, steps, out);
  }
  i3x(point, out) {
    out.z3v_1 = this;
    if (this.e3u_1.j1() === 2) {
      var p0 = this.e3u_1.i1(0);
      var p1 = this.e3u_1.i1(1);
      return findNearestLine(this, point.i2h_1, point.j2h_1, p0.i2h_1, p0.j2h_1, p1.i2h_1, p1.j2h_1, out);
    }
    var LUT = this.w3w();
    var l = LUT.j3x();
    var closest = LUT.k3x(point);
    var mpos = closest.m3x_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.l3x_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.t3w(toRatio(t));
      var d = Companion_getInstance_1().q2j(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.w3v_1 = p;
      }
      t = t + step;
    }
    out.w3v_1 = this.t3w(toRatio(ft));
    out.x3v_1 = ft < 0 ? Companion_getInstance().f10_1 : ft > 1 ? Companion_getInstance().i10_1 : toRatio(ft);
    out.y3v_1 = mdistSq;
    return out;
  }
  n3x() {
    if (this.e3u_1.j1() < 4)
      return Companion_getInstance_9().s3v_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.i1(1);
    var p2 = p.i1(2);
    var p3 = p.i1(3);
    var a = p2.i2h_1 * p1.j2h_1;
    var b = p3.i2h_1 * p1.j2h_1;
    var c = p1.i2h_1 * p2.j2h_1;
    var d = p3.i2h_1 * p2.j2h_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_9().s3v_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_9().s3v_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_9().s3v_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.c32(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.t2d(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.t2d(out1);
    }
    return out.i13();
  }
  t3w(t) {
    return compute(Companion_getInstance_9(), t, this.e3u_1);
  }
  o3x(t, normalize) {
    var out = compute(Companion_getInstance_9(), t, this.i3w().i1(0));
    if ((equals(t, Companion_getInstance().f10_1) || equals(t, Companion_getInstance().i10_1)) && isAlmostZero(out.v2w())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance().i10_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_9(), _Ratio___init__impl__9mwvn2(nt), this.i3w().i1(0));
          if (!isAlmostZero(out.v2w()))
            break $l$loop;
        }
         while (inductionVariable < 10);
    }
    if (normalize)
      out = out.q2s();
    return out;
  }
  k3w(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.o3x(t, normalize) : $super.o3x.call(this, new Ratio(t), normalize);
  }
  p3x(t, normalize) {
    return this.o3x(t, normalize).y2w();
  }
  n3t(t) {
    return this.p3x(t, true);
  }
  m3t(t) {
    return this.o3x(t, true);
  }
  q3x(t, out) {
    if (this.p3u() < 2)
      return null;
    var p = this.e3u_1;
    out.v3e(p, 0);
    out.v3e(p, 1);
    out.v3e(p, 2);
    if (this.p3u() === 3) {
      out.v3e(p, 3);
    }
    while (p.j1() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.j1() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate_3(toRatio_0(t), p.i1(i), p.i1(i + 1 | 0));
          out.s3e(p_0);
          next.s3e(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  r3x(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.q3x(t, out) : $super.q3x.call(this, new Ratio(t), out);
  }
  c3v(t0, t1) {
    return SubBezier.s3x(this.h3v(t0).i3v(map(Companion_getInstance_9(), t1, t0, Companion_getInstance().i10_1, Companion_getInstance().f10_1, Companion_getInstance().i10_1)).d3v_1, t0, t1, this);
  }
  i3v(t) {
    return SubBezier.t3x(this).i3v(t);
  }
  h3v(t) {
    return SubBezier.t3x(this).h3v(t);
  }
  u3x() {
    return Line2D.g2l(this.e3u_1.i1(0), this.e3u_1.i1(this.p3u()));
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.v3x_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.w3x_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  static s3x(curve, t1, t2, parent) {
    Companion_getInstance_10();
    var $this = createThis(this);
    $this.d3v_1 = curve;
    $this.e3v_1 = t1;
    $this.f3v_1 = t2;
    $this.g3v_1 = parent;
    return $this;
  }
  static t3x(curve) {
    Companion_getInstance_10();
    return this.s3x(curve, Companion_getInstance().f10_1, Companion_getInstance().i10_1, null);
  }
  l3t(t) {
    return this.d3v_1.l3t(convertRange(t, this.e3v_1, this.f3v_1, Companion_getInstance().f10_1, Companion_getInstance().i10_1));
  }
  i3v(t) {
    return _splitLeft$default(this, t);
  }
  h3v(t) {
    return _splitRight$default(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.e3v_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.f3v_1)) + '](' + this.d3v_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.l3x_1 = mdistSq;
    this.m3x_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.i2l() : point;
    ratio = ratio === VOID ? Companion_getInstance().f10_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.x3w_1 = point;
    this.y3w_1 = ratio;
    this.z3w_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.x3w_1.z2w() + ', ratio=' + get_niceStr_1(this.y3w_1) + ', length=' + get_niceStr(this.z3w_1) + ')';
  }
  hashCode() {
    var result = this.x3w_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.y3w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.x3w_1.equals(tmp0_other_with_cast.x3w_1))
      return false;
    if (!equals(this.y3w_1, tmp0_other_with_cast.y3w_1))
      return false;
    if (!equals(this.z3w_1, tmp0_other_with_cast.z3w_1))
      return false;
    return true;
  }
}
class CurveLUT {
  static z3x(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.a3x_1 = curve;
    $this.b3x_1 = points;
    $this.c3x_1 = ts;
    $this.d3x_1 = _estimatedLengths;
    return $this;
  }
  static h3x(curve, capacity) {
    return this.z3x(curve, new PointArrayList(capacity), DoubleArrayList.c32(capacity), DoubleArrayList.c32(capacity));
  }
  y3x() {
    if (this.d3x_1.a1()) {
      this.d3x_1.t2d(0.0);
    }
    while (this.d3x_1.j1() < this.j1()) {
      var pos = this.d3x_1.j1();
      var prev = last_0(this.d3x_1);
      this.d3x_1.t2d(prev + Companion_getInstance_1().n2w(this.b3x_1.i1(pos - 1 | 0), this.b3x_1.i1(pos)));
    }
    return this.d3x_1;
  }
  j3x() {
    return this.b3x_1.j1() - 1 | 0;
  }
  j1() {
    return this.b3x_1.j1();
  }
  o3() {
    this.b3x_1.wh();
    this.c3x_1.o3();
    this.d3x_1.o3();
  }
  g3x(t, p) {
    this.b3x_1.s3e(p);
    this.c3x_1.t2d(Ratio__toDouble_impl_o7epze(t));
  }
  k3x(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance_1().q2j(this.b3x_1.i1(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  x3x(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio(this.c3x_1.i1(index));
    var length0 = this.y3x().i1(index);
    var point0 = this.b3x_1.i1(index);
    if (ratio === 0.0) {
      _this__u8e3s4.y3w_1 = ratio0;
      _this__u8e3s4.z3w_1 = length0;
      _this__u8e3s4.x3w_1 = point0;
    } else {
      var ratio1 = toRatio(this.c3x_1.i1(index + 1 | 0));
      var length1 = this.y3x().i1(index + 1 | 0);
      var point1 = this.b3x_1.i1(index + 1 | 0);
      _this__u8e3s4.y3w_1 = interpolate_0(toRatio(ratio), ratio0, ratio1);
      _this__u8e3s4.z3w_1 = interpolate_1(toRatio(ratio), length0, length1);
      _this__u8e3s4.x3w_1 = interpolate_3(toRatio(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  a3y(length, out) {
    return estimateAt(this, this.y3x(), length, out);
  }
  e3x(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.a3y(length, out) : $super.a3y.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.a3x_1);
    var tmp_0 = until(0, this.j1());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.a3x_1);
    result = imul(result, 31) + this.b3x_1.hashCode() | 0;
    result = imul(result, 31) + this.c3x_1.hashCode() | 0;
    result = imul(result, 31) + this.d3x_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.a3x_1, tmp0_other_with_cast.a3x_1))
      return false;
    if (!this.b3x_1.equals(tmp0_other_with_cast.b3x_1))
      return false;
    if (!this.c3x_1.equals(tmp0_other_with_cast.c3x_1))
      return false;
    if (!this.d3x_1.equals(tmp0_other_with_cast.d3x_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.b3y_1 = 0.5522847498307933;
    this.c3y_1 = 6.283185307179586;
  }
  d3y(out, a, c, r) {
    if (out.a1()) {
      out.e3y(a);
    }
    var b = out.f3y();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AB = Vector2D.k2h(b.i2h_1 - a.i2h_1, b.j2h_1 - a.j2h_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AC = Vector2D.k2h(c.i2h_1 - a.i2h_1, c.j2h_1 - a.j2h_1);
    var angle = Angle__times_impl_v3s9y2(Companion_getInstance_1().k2w(AB, AC), 0.5);
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__minus_impl_xeau7k(Companion_getInstance_2().s2h_1, angle);
    var up = Companion_getInstance_1().e2i_1;
    var tmp = r * Angle__sine_impl_3l11xv(angle_0, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_1().e2i_1;
    var x = tmp / Angle__sine_impl_3l11xv(angle, up_0);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_0 = AB.x2w();
    var that = Vector2D.k2h(this_0.i2h_1 * x, this_0.j2h_1 * x);
    var A = Vector2D.k2h(a.i2h_1 + that.i2h_1, a.j2h_1 + that.j2h_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = AC.x2w();
    var that_0 = Vector2D.k2h(this_1.i2h_1 * x, this_1.j2h_1 * x);
    var B = Vector2D.k2h(a.i2h_1 + that_0.i2h_1, a.j2h_1 + that_0.j2h_1);
    out.g3y(A);
    out.h3y(a, B);
  }
  i3y(out, p, rsize) {
    var x = p.km();
    var y = p.lm();
    var rw = rsize.km();
    var rh = rsize.lm();
    var k = 0.5522847498307933;
    var ox = rw / 2 * k;
    var oy = rh / 2 * k;
    var xe = x + rw;
    var ye = y + rh;
    var xm = x + rw / 2;
    var ym = y + rh / 2;
    out.e3y(Vector2D.k2h(x, ym));
    out.j3y(Vector2D.k2h(x, ym - oy), Vector2D.k2h(xm - ox, y), Vector2D.k2h(xm, y));
    out.j3y(Vector2D.k2h(xm + ox, y), Vector2D.k2h(xe, ym - oy), Vector2D.k2h(xe, ym));
    out.j3y(Vector2D.k2h(xe, ym + oy), Vector2D.k2h(xm + ox, ye), Vector2D.k2h(xm, ye));
    out.j3y(Vector2D.k2h(xm - ox, ye), Vector2D.k2h(x, ym + oy), Vector2D.k2h(x, ym));
    out.u6();
  }
  k3y(out, center, r, start, end, counterclockwise) {
    var x = center.km();
    var y = center.lm();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_2().v2h_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_2().v2h_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_2().q2h_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_2().v2h_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_2().v2h_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_2().q2h_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_2().v2h_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_2().q2h_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_2().s2h_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2_0(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.e3y(Vector2D.k2h(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.j3y(Vector2D.k2h(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.k2h(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.k2h(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.u6();
    }
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.x3y_1 = function_0;
  }
  rj(a, b) {
    return this.x3y_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class Result {
  constructor(maxWidth, maxHeight, items) {
    this.z3y_1 = maxWidth;
    this.a3z_1 = maxHeight;
    this.b3z_1 = items;
    var tmp = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.b3z_1;
    var destination = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.math.geom.binpack.Result.rectanglesNotNull.<anonymous>' call
      var tmp0_safe_receiver = element.jm_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    tmp.c3z_1 = destination;
    var tmp_0 = this;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.c3z_1.f1();
      if (!iterator.g1()) {
        tmp$ret$4 = null;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.binpack.Result.width.<anonymous>' call
      var maxValue = iterator.h1().q2i();
      while (iterator.g1()) {
        // Inline function 'korlibs.math.geom.binpack.Result.width.<anonymous>' call
        var v = iterator.h1().q2i();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp$ret$4 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$4;
    tmp_0.d3z_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator_0 = this.c3z_1.f1();
      if (!iterator_0.g1()) {
        tmp$ret$8 = null;
        break $l$block_0;
      }
      // Inline function 'korlibs.math.geom.binpack.Result.height.<anonymous>' call
      var maxValue_0 = iterator_0.h1().s2i();
      while (iterator_0.g1()) {
        // Inline function 'korlibs.math.geom.binpack.Result.height.<anonymous>' call
        var v_0 = iterator_0.h1().s2i();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a_0 = maxValue_0;
        maxValue_0 = Math.max(a_0, v_0);
      }
      tmp$ret$8 = maxValue_0;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$8;
    tmp_1.e3z_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
}
class Companion_1 {
  f3z(width, height, algo) {
    return new BinPacker(Size2D.k2t(width, height), algo);
  }
  y3y(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.h3z(width, height) : algo;
    return $super === VOID ? this.f3z(width, height, algo) : $super.f3z.call(this, width, height, algo);
  }
  i3z(width, height, algo) {
    return Companion_instance_1.f3z(width, height, algo);
  }
  j3z(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.h3z(width, height) : algo;
    return $super === VOID ? this.i3z(width, height, algo) : $super.i3z.call(this, width, height, algo);
  }
  k3z(maxSize, items, getSize) {
    var maxWidth = maxSize.km();
    var maxHeight = maxSize.lm();
    var currentBinPacker = {_v: Companion_instance_1.y3y(maxWidth, maxHeight)};
    var currentPairs = {_v: FastArrayList.g14()};
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = BinPacker$Companion$packSeveral$lambda(getSize);
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var sortedItems = sortedWith(items, tmp$ret$0);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < sortedItems.j1()) {
      // Inline function 'korlibs.math.geom.binpack.Companion.packSeveral.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var size = getSize(sortedItems.i1(_unary__edvuaz));
      if (size.d2j_1 > maxWidth || size.e2j_1 > maxHeight) {
        throw ImageDoNotFitException.p3z(size.d2j_1, size.e2j_1, currentBinPacker._v);
      }
    }
    var out = FastArrayList.g14();
    var _iterator__ex2g4s = items.f1();
    while (_iterator__ex2g4s.g1()) {
      var item = _iterator__ex2g4s.h1();
      var done = false;
      while (!done) {
        var size_0 = getSize(item);
        var rect = currentBinPacker._v.t3z(size_0.d2j_1, size_0.e2j_1);
        if (!(rect == null)) {
          currentPairs._v.f(to(item, rect));
          done = true;
        } else {
          packSeveral$emit(currentPairs, out, maxWidth, maxHeight, currentBinPacker);
        }
      }
    }
    packSeveral$emit(currentPairs, out, maxWidth, maxHeight, currentBinPacker);
    return out;
  }
}
class ImageDoNotFitException extends Error {
  static p3z(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.j2y() + 'x' + packer.k2y() + "'");
    captureStack($this, $this.o3z_1);
    $this.l3z_1 = width;
    $this.m3z_1 = height;
    $this.n3z_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.u3z(size) : algo;
    this.q3z_1 = size;
    this.r3z_1 = algo;
    this.s3z_1 = FastArrayList.g14();
  }
  j2y() {
    return this.q3z_1.d2j_1;
  }
  k2y() {
    return this.q3z_1.e2j_1;
  }
  r3e(width, height) {
    var tmp0_elvis_lhs = this.t3z(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.p3z(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  t3z(width, height) {
    var tmp0_elvis_lhs = this.r3z_1.v3z(Size2D.k2t(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.s3z_1.f(rect);
    return rect;
  }
}
class MaxRects {
  static u3z(maxSize) {
    var $this = createThis(this);
    $this.g3z_1 = fastArrayListOf([Companion_getInstance_3().g2j(Companion_getInstance_1().a2i_1, maxSize)]);
    return $this;
  }
  static h3z(width, height) {
    return this.u3z(Size2D.k2t(width, height));
  }
  v3z(size) {
    return this.w3z(size);
  }
  w3z(size) {
    var width = size.km();
    var height = size.lm();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_3().d2t(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.l2i_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.g3z_1.j1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.g3z_1.i1(i), newNode)) {
        this.g3z_1.q3(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  w3y(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.x3z(points);
  }
  x3z(vertices) {
    var base = 0;
    var n = vertices.j1();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.v2k(base) === vertices.v2k(n - 1 | 0) && vertices.w2k(base) === vertices.w2k(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.v2k(n - 2 | 0);
    var old_y = vertices.w2k(n - 2 | 0);
    var new_x = vertices.v2k(n - 1 | 0);
    var new_y = vertices.w2k(n - 1 | 0);
    // Inline function 'kotlin.math.atan2' call
    var y = new_y - old_y;
    var x = new_x - old_x;
    var new_direction = Math.atan2(y, x);
    var old_direction;
    var angle_sum = Companion_getInstance_2().r2h_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.v2k(p);
        new_y = vertices.w2k(p);
        // Inline function 'kotlin.math.atan2' call
        var y_0 = new_y - old_y;
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(y_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        Companion_getInstance_2();
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance().i10_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class BVH2D {
  constructor(allowUpdateObjects) {
    allowUpdateObjects = allowUpdateObjects === VOID ? true : allowUpdateObjects;
    this.y3z_1 = allowUpdateObjects;
    this.z3z_1 = new BVH(2, VOID, this.y3z_1);
  }
  a40() {
    return toRectangle(this.z3z_1.i3d());
  }
  b40(ray, return_array) {
    return this.z3z_1.j3d(toBVH(ray), return_array);
  }
  c40(ray, return_array, $super) {
    return_array = return_array === VOID ? fastArrayListOf([]) : return_array;
    return $super === VOID ? this.b40(ray, return_array) : $super.b40.call(this, ray, return_array);
  }
  d40(rect, return_array) {
    return this.z3z_1.l3d(toBVH_0(rect), return_array);
  }
  e40(rect, return_array, $super) {
    return_array = return_array === VOID ? fastArrayListOf([]) : return_array;
    return $super === VOID ? this.d40(rect, return_array) : $super.d40.call(this, rect, return_array);
  }
  f40(rect, obj) {
    return this.z3z_1.m3d(toBVH_0(rect), obj);
  }
}
class AbstractShape2D {}
class BaseShape2D {
  constructor(base, genVector) {
    this.k40_1 = base;
    this.l40_1 = genVector;
    var tmp = this;
    tmp.m40_1 = lazy(BaseShape2D$cachedPath$delegate$lambda(this));
  }
  toString() {
    return 'Shape2D(' + toString(this.k40_1) + ')';
  }
}
class CircleShape2D extends BaseShape2D {
  constructor(circle) {
    super(circle, CircleShape2D$_init_$lambda_c1uoso);
    this.j40_1 = circle;
  }
  toString() {
    return 'Shape2D(' + this.k40_1.toString() + ')';
  }
  hashCode() {
    return this.j40_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CircleShape2D))
      return false;
    var tmp0_other_with_cast = other instanceof CircleShape2D ? other : THROW_CCE();
    if (!this.j40_1.equals(tmp0_other_with_cast.j40_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.n40_1 = values();
  }
  i1(index) {
    return this.n40_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.q40_1 = imul(this.v3_1, 90);
  }
  r40(offset) {
    return Companion_getInstance_13().i1(umod(this.v3_1 + offset | 0, 4));
  }
  s40() {
    return Companion_getInstance_13().i1(umod(-this.v3_1 | 0, 4));
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).v3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.t40_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.h();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.ic(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.oh(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).q40_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.u40_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.v40_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.w40_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.x40_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.y40_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.z40_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.a41_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.b41_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.c41_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.d41_1 = listOf_0([new SliceOrientation(this.v40_1), new SliceOrientation(this.w40_1), new SliceOrientation(this.x40_1), new SliceOrientation(this.y40_1), new SliceOrientation(this.z40_1), new SliceOrientation(this.a41_1), new SliceOrientation(this.b41_1), new SliceOrientation(this.c41_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_14();
    this.e41_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.e41_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.e41_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.e41_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.b43();
    case 1:
      return this.d43();
    case 2:
      return this.f43();
    case 3:
      return this.h43();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.c43();
    case 1:
      return this.e43();
    case 2:
      return this.g43();
    case 3:
      return this.i43();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.p42().d2m_1;
}
function get_frameOffsetY() {
  return this.p42().a2m_1;
}
function get_frameWidth() {
  return this.j2y() + this.p42().x2l() | 0;
}
function get_frameHeight() {
  return this.k2y() + this.p42().y2l() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.o42().p2i();
}
function get_top() {
  return this.o42().r2i();
}
function get_right() {
  return this.o42().q2i();
}
function get_bottom() {
  return this.o42().s2i();
}
function get_area() {
  return this.o42().x2u();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_14().v40_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_5().z2l_1 : padding;
    name = name === VOID ? null : name;
    this.f41_1 = base;
    this.g41_1 = rect;
    this.h41_1 = orientation;
    this.i41_1 = padding;
    this.j41_1 = name;
    this.k41_1 = this.f41_1.j1().a2v_1;
    this.l41_1 = this.f41_1.j1().b2v_1;
    this.m41_1 = this.g41_1.b2u_1;
    this.n41_1 = this.g41_1.c2u_1;
    this.o41_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.h41_1) ? this.g41_1.b2u_1 : this.g41_1.c2u_1;
    this.p41_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.h41_1) ? this.g41_1.c2u_1 : this.g41_1.b2u_1;
    this.q41_1 = this.o41_1 + this.i41_1.x2l() | 0;
    this.r41_1 = this.p41_1 + this.i41_1.y2l() | 0;
    this.s41_1 = this.g41_1.p2i() / this.k41_1;
    this.t41_1 = this.g41_1.q2i() / this.k41_1;
    this.u41_1 = this.g41_1.r2i() / this.l41_1;
    this.v41_1 = this.g41_1.s2i() / this.l41_1;
    this.w41_1 = new RectCoords(this.s41_1, this.u41_1, this.t41_1, this.u41_1, this.t41_1, this.v41_1, this.s41_1, this.v41_1);
    this.x41_1 = transformed_1(this.w41_1, this.h41_1);
    this.y41_1 = this.x41_1.g42_1;
    this.z41_1 = this.x41_1.h42_1;
    this.a42_1 = this.x41_1.i42_1;
    this.b42_1 = this.x41_1.j42_1;
    this.c42_1 = this.x41_1.k42_1;
    this.d42_1 = this.x41_1.l42_1;
    this.e42_1 = this.x41_1.m42_1;
    this.f42_1 = this.x41_1.n42_1;
  }
  o33() {
    return this.f41_1;
  }
  o42() {
    return this.g41_1;
  }
  p42() {
    return this.i41_1;
  }
  j2y() {
    return this.o41_1;
  }
  k2y() {
    return this.p41_1;
  }
  q42() {
    return this.q41_1;
  }
  r42() {
    return this.r41_1;
  }
  s42(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.g41_1.y2u(left, top, right, bottom, clamped);
    return new RectSlice(this.f41_1, tmp, orientation, this.i41_1, name == null ? this.j41_1 : name);
  }
  t42(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.h41_1 : orientation;
    return $super === VOID ? this.s42(left, top, right, bottom, name, clamped, orientation) : $super.s42.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  u42(x, y, width, height, name, clamped, orientation) {
    return this.s42(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  v42(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.h41_1 : orientation;
    return $super === VOID ? this.u42(x, y, width, height, name, clamped, orientation) : $super.u42.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  w42(rect, name, clamped, orientation) {
    return this.s42(rect.p2i(), rect.r2i(), rect.q2i(), rect.s2i(), name, clamped, orientation);
  }
  x42(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.h41_1 : orientation;
    return $super === VOID ? this.w42(rect, name, clamped, orientation) : $super.w42.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  y42(x, y, width, height) {
    return this.z42(VOID, VOID, VOID, MarginInt.e2m(y, (width - this.o41_1 | 0) - x | 0, (height - this.p41_1 | 0) - y | 0, x));
  }
  a43(frame) {
    return frame == null ? this.z42(VOID, VOID, VOID, Companion_getInstance_5().z2l_1) : this.y42(frame.z2t_1, frame.a2u_1, frame.b2u_1, frame.c2u_1);
  }
  b43() {
    return this.y41_1;
  }
  c43() {
    return this.z41_1;
  }
  d43() {
    return this.a42_1;
  }
  e43() {
    return this.b42_1;
  }
  f43() {
    return this.c42_1;
  }
  g43() {
    return this.d42_1;
  }
  h43() {
    return this.e42_1;
  }
  i43() {
    return this.f42_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.ic('RectSlice(');
    this_0.ic(this.j41_1);
    this_0.ic(':');
    this_0.hc(this.g41_1);
    if (!(this.h41_1 === Companion_getInstance_14().v40_1)) {
      this_0.ic(':');
      this_0.hc(new SliceOrientation(this.h41_1));
    }
    if (this.i41_1.h2m()) {
      this_0.ic(':');
      this_0.hc(this.i41_1);
    }
    this_0.ic(')');
    return this_0.toString();
  }
  j43(base, rect, orientation, padding, name) {
    return new RectSlice(base, rect, orientation, padding, name);
  }
  z42(base, rect, orientation, padding, name, $super) {
    base = base === VOID ? this.f41_1 : base;
    rect = rect === VOID ? this.g41_1 : rect;
    orientation = orientation === VOID ? this.h41_1 : orientation;
    padding = padding === VOID ? this.i41_1 : padding;
    name = name === VOID ? this.j41_1 : name;
    return $super === VOID ? this.j43(base, rect, orientation, padding, name) : $super.j43.call(this, base, rect, new SliceOrientation(orientation), padding, name);
  }
  hashCode() {
    var result = hashCode(this.f41_1);
    result = imul(result, 31) + this.g41_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.h41_1) | 0;
    result = imul(result, 31) + this.i41_1.hashCode() | 0;
    result = imul(result, 31) + (this.j41_1 == null ? 0 : getStringHashCode(this.j41_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.f41_1, tmp0_other_with_cast.f41_1))
      return false;
    if (!this.g41_1.equals(tmp0_other_with_cast.g41_1))
      return false;
    if (!(this.h41_1 === tmp0_other_with_cast.h41_1))
      return false;
    if (!this.i41_1.equals(tmp0_other_with_cast.i41_1))
      return false;
    if (!(this.j41_1 == tmp0_other_with_cast.j41_1))
      return false;
    return true;
  }
}
class Companion_5 {
  o43(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  p43(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.o43(base, coords, name, flippedWidthHeight) : $super.o43.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.q43_1 = base;
    this.r43_1 = coords;
    this.s43_1 = name;
    this.t43_1 = flippedWidthHeight;
    this.u43_1 = Companion_getInstance_5().z2l_1;
    this.v43_1 = !this.t43_1 ? this.q43_1.j1().a2v_1 : this.q43_1.j1().b2v_1;
    this.w43_1 = !this.t43_1 ? this.q43_1.j1().b2v_1 : this.q43_1.j1().a2v_1;
    this.x43_1 = numberToInt(Companion_getInstance_1().l2w(this.r43_1.b43(), this.r43_1.c43(), this.r43_1.d43(), this.r43_1.e43()) * this.v43_1);
    this.y43_1 = numberToInt(Companion_getInstance_1().l2w(this.r43_1.b43(), this.r43_1.c43(), this.r43_1.h43(), this.r43_1.i43()) * this.w43_1);
    this.z43_1 = this.x43_1 + this.u43_1.x2l() | 0;
    this.a44_1 = this.y43_1 + this.u43_1.y2l() | 0;
  }
  o33() {
    return this.q43_1;
  }
  p42() {
    return this.u43_1;
  }
  j2y() {
    return this.x43_1;
  }
  k2y() {
    return this.y43_1;
  }
  q42() {
    return this.z43_1;
  }
  r42() {
    return this.a44_1;
  }
  b43() {
    return this.r43_1.b43();
  }
  c43() {
    return this.r43_1.c43();
  }
  d43() {
    return this.r43_1.d43();
  }
  e43() {
    return this.r43_1.e43();
  }
  f43() {
    return this.r43_1.f43();
  }
  g43() {
    return this.r43_1.g43();
  }
  h43() {
    return this.r43_1.h43();
  }
  i43() {
    return this.r43_1.i43();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.q43_1) + ', coords=' + toString(this.r43_1) + ', name=' + this.s43_1 + ', flippedWidthHeight=' + this.t43_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q43_1);
    result = imul(result, 31) + hashCode(this.r43_1) | 0;
    result = imul(result, 31) + (this.s43_1 == null ? 0 : getStringHashCode(this.s43_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t43_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.q43_1, tmp0_other_with_cast.q43_1))
      return false;
    if (!equals(this.r43_1, tmp0_other_with_cast.r43_1))
      return false;
    if (!(this.s43_1 == tmp0_other_with_cast.s43_1))
      return false;
    if (!(this.t43_1 === tmp0_other_with_cast.t43_1))
      return false;
    return true;
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.g42_1 = tlX;
    this.h42_1 = tlY;
    this.i42_1 = trX;
    this.j42_1 = trY;
    this.k42_1 = brX;
    this.l42_1 = brY;
    this.m42_1 = blX;
    this.n42_1 = blY;
  }
  b43() {
    return this.g42_1;
  }
  c43() {
    return this.h42_1;
  }
  d43() {
    return this.i42_1;
  }
  e43() {
    return this.j42_1;
  }
  f43() {
    return this.k42_1;
  }
  g43() {
    return this.l42_1;
  }
  h43() {
    return this.m42_1;
  }
  i43() {
    return this.n42_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.g42_1 + ', tlY=' + this.h42_1 + ', trX=' + this.i42_1 + ', trY=' + this.j42_1 + ', brX=' + this.k42_1 + ', brY=' + this.l42_1 + ', blX=' + this.m42_1 + ', blY=' + this.n42_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.g42_1);
    result = imul(result, 31) + getNumberHashCode(this.h42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m42_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n42_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.g42_1, tmp0_other_with_cast.g42_1))
      return false;
    if (!equals(this.h42_1, tmp0_other_with_cast.h42_1))
      return false;
    if (!equals(this.i42_1, tmp0_other_with_cast.i42_1))
      return false;
    if (!equals(this.j42_1, tmp0_other_with_cast.j42_1))
      return false;
    if (!equals(this.k42_1, tmp0_other_with_cast.k42_1))
      return false;
    if (!equals(this.l42_1, tmp0_other_with_cast.l42_1))
      return false;
    if (!equals(this.m42_1, tmp0_other_with_cast.m42_1))
      return false;
    if (!equals(this.n42_1, tmp0_other_with_cast.n42_1))
      return false;
    return true;
  }
}
class Companion_6 {}
class Item {
  constructor(index) {
    this.b44_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6(this.b44_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p(this.b44_1);
  }
  equals(other) {
    return Item__equals_impl_qczid(this.b44_1, other);
  }
}
class FTrapezoidsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.c44_1 = false;
    this.d44_1 = IntArrayList.f31(imul(capacity, 7));
  }
  j1() {
    return this.d44_1.j1() / 6 | 0;
  }
  e44(index) {
    return _Item___init__impl__hhk1le(index);
  }
  toString() {
    return 'FTrapezoidsInt[' + this.j1() + ']';
  }
  f44(x, y, assumeSorted) {
    // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside' call
    var iterations = 0;
    var iterations2 = 0;
    var found = false;
    if (assumeSorted) {
      var size = this.j1();
      // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
      var toIndex = size - 1 | 0;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.genericBinarySearch' call
        var low = 0;
        var high = toIndex - 1 | 0;
        while (low <= high) {
          var mid = (low + high | 0) / 2 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside.<anonymous>' call
          iterations2 = iterations2 + 1 | 0;
          var mval = compareTo(this.h44(_Item___init__impl__hhk1le(mid)), y);
          if (mval < 0)
            low = mid + 1 | 0;
          else if (mval > 0)
            high = mid - 1 | 0;
          else {
            tmp$ret$1 = mid;
            break $l$block;
          }
        }
        // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
        tmp$ret$1 = (-low | 0) - 1 | 0;
      }
      var result = _BSearchResult___init__impl__em6zam(tmp$ret$1);
      var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
      $l$loop: while (0 <= index ? index < size : false) {
        var item = _Item___init__impl__hhk1le(index);
        if (y > this.i44(item))
          break $l$loop;
        iterations = iterations + 1 | 0;
        index = index - 1 | 0;
      }
      index = index + 1 | 0;
      var inductionVariable = index;
      if (inductionVariable < size)
        $l$loop_1: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          iterations = iterations + 1 | 0;
          var item_0 = _Item___init__impl__hhk1le(n);
          var inside = this.g44(item_0, x, y);
          if (inside) {
            found = true;
            break $l$loop_1;
          }
          if (this.h44(item_0) > y)
            break $l$loop_1;
        }
         while (inductionVariable < size);
    } else {
      var inductionVariable_0 = 0;
      var last = this.j1();
      if (inductionVariable_0 < last)
        $l$loop_2: do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          iterations = iterations + 1 | 0;
          var it = this.e44(n_0);
          if (this.g44(it, x, y)) {
            found = true;
            // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside.<anonymous>' call
            break $l$loop_2;
          }
        }
         while (inductionVariable_0 < last);
    }
    if (!(null == null)) {
      null.k44_1 = iterations;
      null.l44_1 = iterations2;
      null.m44_1 = this.j1();
      null.j44_1 = found;
    }
    return found;
  }
  n44(x, y, assumeSorted, $super) {
    assumeSorted = assumeSorted === VOID ? this.c44_1 : assumeSorted;
    return $super === VOID ? this.f44(x, y, assumeSorted) : $super.f44.call(this, x, y, assumeSorted);
  }
  o44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 0 | 0);
  }
  p44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 1 | 0);
  }
  h44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 2 | 0);
  }
  q44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 3 | 0);
  }
  r44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 4 | 0);
  }
  i44(_this__u8e3s4) {
    return this.d44_1.i1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 5 | 0);
  }
  g44(_this__u8e3s4, x, y) {
    return Companion_instance_8.s44(this.o44(_this__u8e3s4), this.p44(_this__u8e3s4), this.h44(_this__u8e3s4), this.q44(_this__u8e3s4), this.r44(_this__u8e3s4), this.i44(_this__u8e3s4), x, y);
  }
  t44(x0a, x0b, y0, x1a, x1b, y1) {
    // Inline function 'kotlin.also' call
    var this_0 = new Item(_Item___init__impl__hhk1le(this.j1()));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.add.<anonymous>' call
    this_0.b44_1;
    this.d44_1.n31(x0a, x0b, y0, x1a, x1b, y1);
    return this_0.b44_1;
  }
}
class Companion_7 {}
class SortOps_0 extends SortOps {
  constructor(gen) {
    super();
    this.v44_1 = gen;
  }
  w44(subject, l, r) {
    // Inline function 'kotlin.compareTo' call
    var this_0 = this.v44_1(subject, new Item_0(_Item___init__impl__hhk1le_0(l)));
    var other = this.v44_1(subject, new Item_0(_Item___init__impl__hhk1le_0(r)));
    return compareTo(this_0, other);
  }
  b33(subject, l, r) {
    return this.w44(subject instanceof FSegmentsInt ? subject : THROW_CCE(), l, r);
  }
  x44(subject, indexL, indexR) {
    return subject.z44(_Item___init__impl__hhk1le_0(indexL), _Item___init__impl__hhk1le_0(indexR));
  }
  d33(subject, indexL, indexR) {
    return this.x44(subject instanceof FSegmentsInt ? subject : THROW_CCE(), indexL, indexR);
  }
}
class Item_0 {
  constructor(index) {
    this.u44_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6_0(this.u44_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p_0(this.u44_1);
  }
  equals(other) {
    return Item__equals_impl_qczid_0(this.u44_1, other);
  }
}
class FSegmentsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.y44_1 = IntArrayList.f31(imul(capacity, 4));
  }
  j1() {
    return this.y44_1.j1() / 4 | 0;
  }
  j13() {
    // Inline function 'kotlin.also' call
    var this_0 = new FSegmentsInt(this.j1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.clone.<anonymous>' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.clone.<anonymous>.<anonymous>' call
        var it = this.a45(n);
        this_0.f45(this.b45(it), this.c45(it), this.d45(it), this.e45(it));
      }
       while (inductionVariable < last);
    return this_0;
  }
  g45(gen) {
    // Inline function 'kotlin.also' call
    var this_0 = this.j13();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.sortedBy.<anonymous>' call
    this_0.h45(gen);
    return this_0;
  }
  h45(gen) {
    genericSort(this, 0, this.j1() - 1 | 0, new SortOps_0(gen));
  }
  z44(a, b) {
    var ax0 = this.b45(a);
    var ay0 = this.c45(a);
    var ax1 = this.d45(a);
    var ay1 = this.e45(a);
    this.i45(a, this.b45(b), this.c45(b), this.d45(b), this.e45(b));
    this.i45(b, ax0, ay0, ax1, ay1);
  }
  a45(index) {
    return _Item___init__impl__hhk1le_0(index);
  }
  j45(index) {
    return (0 <= index ? index < this.j1() : false) ? this.a45(index) : null;
  }
  k45(_this__u8e3s4, value) {
    this.y44_1.t31(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0, value);
  }
  b45(_this__u8e3s4) {
    return this.y44_1.i1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0);
  }
  l45(_this__u8e3s4, value) {
    this.y44_1.t31(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0, value);
  }
  c45(_this__u8e3s4) {
    return this.y44_1.i1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0);
  }
  m45(_this__u8e3s4, value) {
    this.y44_1.t31(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0, value);
  }
  d45(_this__u8e3s4) {
    return this.y44_1.i1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0);
  }
  n45(_this__u8e3s4, value) {
    this.y44_1.t31(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0, value);
  }
  e45(_this__u8e3s4) {
    return this.y44_1.i1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0);
  }
  i45(_this__u8e3s4, x0, y0, x1, y1) {
    this.k45(_this__u8e3s4, x0);
    this.l45(_this__u8e3s4, y0);
    this.m45(_this__u8e3s4, x1);
    this.n45(_this__u8e3s4, y1);
  }
  o45(_this__u8e3s4) {
    return this.d45(_this__u8e3s4) - this.b45(_this__u8e3s4) | 0;
  }
  p45(_this__u8e3s4) {
    return this.e45(_this__u8e3s4) - this.c45(_this__u8e3s4) | 0;
  }
  q45(_this__u8e3s4) {
    return this.o45(_this__u8e3s4) / this.p45(_this__u8e3s4);
  }
  r45(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.b45(_this__u8e3s4);
    var b = this.d45(_this__u8e3s4);
    return Math.min(a, b);
  }
  s45(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.c45(_this__u8e3s4);
    var b = this.e45(_this__u8e3s4);
    return Math.min(a, b);
  }
  t45(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = this.c45(_this__u8e3s4);
    var b = this.e45(_this__u8e3s4);
    return Math.max(a, b);
  }
  u45(_this__u8e3s4, y) {
    return this.b45(_this__u8e3s4) + toIntRound((y - this.c45(_this__u8e3s4) | 0) * this.q45(_this__u8e3s4)) | 0;
  }
  v45(_this__u8e3s4, y) {
    var containsLower = this.s45(_this__u8e3s4);
    return y <= this.t45(_this__u8e3s4) ? containsLower <= y : false;
  }
  w45(_this__u8e3s4, other) {
    return Companion_instance_9.x45(this.b45(_this__u8e3s4), this.c45(_this__u8e3s4), this.d45(_this__u8e3s4), this.e45(_this__u8e3s4), this.b45(other), this.c45(other), this.d45(other), this.e45(other));
  }
  f45(x0, y0, x1, y1) {
    var index = this.j1();
    this.y44_1.m31(x0, y0, x1, y1);
    return _Item___init__impl__hhk1le_0(index);
  }
  y45(v, segments) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.add.<anonymous>' call
    return this.f45(segments.b45(v), segments.c45(v), segments.d45(v), segments.e45(v));
  }
}
class SegmentIntToTrapezoidIntList {
  z45(segments, winding, trapezoids) {
    var _destruct__k2r9zo = segmentLookups(this, segments);
    var allY = _destruct__k2r9zo.km();
    var allSegmentsInY = _destruct__k2r9zo.lm();
    var inductionVariable = 0;
    var last = allY.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y0 = allY[n];
        var y1 = allY[n + 1 | 0];
        var segs = allSegmentsInY.i1(n);
        // Inline function 'kotlin.collections.arrayListOf' call
        var chunks = ArrayList.m1();
        switch (winding.v3_1) {
          case 0:
            var progression = step(until(0, segs.j1()), 2);
            var inductionVariable_0 = progression.k2_1;
            var last_0 = progression.l2_1;
            var step_0 = progression.m2_1;
            if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
              $l$loop_1: do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_0 | 0;
                var tmp0_elvis_lhs = segs.j45(m + 0 | 0);
                var tmp;
                var tmp_0 = tmp0_elvis_lhs;
                if ((tmp_0 == null ? null : new Item_0(tmp_0)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                var s0 = tmp;
                var tmp1_elvis_lhs = segs.j45(m + 1 | 0);
                var tmp_1;
                var tmp_2 = tmp1_elvis_lhs;
                if ((tmp_2 == null ? null : new Item_0(tmp_2)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp_1 = tmp1_elvis_lhs;
                }
                var s1 = tmp_1;
                var tmp_3;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                if (!segs.v45(s0, y1)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                  tmp_3 = !segs.v45(s1, y1);
                }
                if (tmp_3)
                  continue $l$loop_1;
                // Inline function 'kotlin.collections.plusAssign' call
                var element = new Pair(new Item_0(s0), new Item_0(s1));
                chunks.f(element);
              }
               while (!(m === last_0));
            break;
          case 1:
            var sign = 0;
            var inductionVariable_1 = 0;
            var last_1 = segs.j1();
            if (inductionVariable_1 < last_1)
              $l$loop_2: do {
                var m_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var seg = segs.a45(m_0);
                if (!(sign === 0) && m_0 > 0) {
                  var s0_0 = segs.a45(m_0 - 1 | 0);
                  var s1_0 = seg;
                  var tmp_4;
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                  if (!segs.v45(s0_0, y1)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                    // Inline function 'kotlin.run' call
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                    tmp_4 = !segs.v45(s1_0, y1);
                  }
                  if (tmp_4)
                    continue $l$loop_2;
                  // Inline function 'kotlin.collections.plusAssign' call
                  var element_0 = new Pair(new Item_0(s0_0), new Item_0(s1_0));
                  chunks.f(element_0);
                }
                var tmp_5 = sign;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                sign = tmp_5 + get_sign(segs.p45(seg)) | 0;
              }
               while (inductionVariable_1 < last_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var _iterator__ex2g4s = chunks.f1();
        while (_iterator__ex2g4s.g1()) {
          var _destruct__k2r9zo_0 = _iterator__ex2g4s.h1();
          var s0_1 = _destruct__k2r9zo_0.km().u44_1;
          var s1_1 = _destruct__k2r9zo_0.lm().u44_1;
          // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
          // Inline function 'kotlin.run' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
          var x0a = segs.u45(s0_1, y0);
          var x0b = segs.u45(s1_1, y0);
          var x1a = segs.u45(s0_1, y1);
          var x1b = segs.u45(s1_1, y1);
          var tmp_6;
          if (x1b < x1a) {
            var intersectY = segs.w45(s0_1, s1_1);
            var intersectX = segs.u45(s0_1, intersectY);
            trapezoids.t44(x0a, x0b, y0, intersectX, intersectX, intersectY);
            tmp_6 = trapezoids.t44(intersectX, intersectX, intersectY, x1a, x1b, y1);
          } else {
            tmp_6 = trapezoids.t44(x0a, x0b, y0, x1a, x1b, y1);
          }
        }
      }
       while (inductionVariable < last);
    return trapezoids;
  }
  a46(segments, winding, trapezoids, $super) {
    winding = winding === VOID ? Winding_EVEN_ODD_getInstance() : winding;
    trapezoids = trapezoids === VOID ? new FTrapezoidsInt() : trapezoids;
    return $super === VOID ? this.z45(segments, winding, trapezoids) : $super.z45.call(this, segments, winding, trapezoids);
  }
}
class Companion_8 {
  s44(x0a, x0b, y0, x1a, x1b, y1, x, y) {
    if (y < y0 || y > y1)
      return false;
    if (x < x0a && x < x1a || (x > x0b && x > x1b))
      return false;
    var sign1 = get_sign(det(this, x1a - x | 0, y1 - y | 0, x0a - x | 0, y0 - y | 0));
    var sign2 = get_sign(det(this, x1b - x | 0, y1 - y | 0, x0b - x | 0, y0 - y | 0));
    return !(sign1 === sign2);
  }
}
class Companion_9 {
  x45(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var outY = -2147483648;
    $l$block: {
      // Inline function 'korlibs.math.geom.trapezoid.Companion.getIntersectXY' call
      var a1 = By - Ay | 0;
      var b1 = Ax - Bx | 0;
      var c1 = imul(a1, Ax) + imul(b1, Ay) | 0;
      var a2 = Dy - Cy | 0;
      var b2 = Cx - Dx | 0;
      var c2 = imul(a2, Cx) + imul(b2, Cy) | 0;
      var determinant = imul(a1, b2) - imul(a2, b1) | 0;
      if (determinant === 0) {
        break $l$block;
      }
      var x = (imul(b2, c1) - imul(b1, c2) | 0) / determinant | 0;
      var y = (imul(a1, c2) - imul(a2, c1) | 0) / determinant | 0;
      // Inline function 'korlibs.math.geom.trapezoid.Companion.getIntersectY.<anonymous>' call
      outY = y;
    }
    return outY;
  }
}
class Bucket {
  constructor() {
    this.b46_1 = FastArrayList.g14();
  }
  wh() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.Bucket.clear.<anonymous>' call
    this.b46_1.o3();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.c46_1 = pool;
    this.d46_1 = ySize;
    this.e46_1 = FastIntMap();
  }
  j1() {
    return get_size(this.e46_1);
  }
  f46(y) {
    return y / this.d46_1 | 0;
  }
  g46(index) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.e46_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(index);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.vector.Buckets.getForIndex.<anonymous>' call
      var out = this.c46_1.g39();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(index, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  h46(y) {
    // Inline function 'korlibs.datastructure.get' call
    var this_0 = this.e46_1;
    var key = this.f46(y);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.get(key);
  }
  o3() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.e46_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.math.geom.vector.Buckets.clear.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$2);
      this.c46_1.h39(value.wh());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.e46_1.clear();
  }
  i46(edge, threshold) {
    var min = this.f46(edge.t46());
    var max = this.f46(edge.u46());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.g46(n).b46_1.f(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  v46(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.i46(edge, threshold) : $super.i46.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.w46_1 = Pool.c39(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.x46_1 = new Buckets(this.w46_1, 80);
    this.y46_1 = new Buckets(this.w46_1, 320);
    this.z46_1 = new Buckets(this.w46_1, 1280);
  }
  a47(edge) {
    if (this.x46_1.i46(edge, 4))
      return Unit_instance;
    if (this.y46_1.i46(edge, 4))
      return Unit_instance;
    this.z46_1.v46(edge);
  }
  o3() {
    this.x46_1.o3();
    this.y46_1.o3();
    this.z46_1.o3();
  }
}
class XWithWind {
  constructor() {
    this.v47_1 = IntArrayList.f31(1024);
    this.w47_1 = IntArrayList.f31(1024);
  }
  j1() {
    return this.v47_1.j1();
  }
  x47(x, wind) {
    this.v47_1.l31(x);
    this.w47_1.l31(wind);
  }
  o3() {
    this.v47_1.o3();
    this.w47_1.o3();
  }
  toString() {
    return 'XWithWind(' + this.v47_1.toString() + ', ' + this.w47_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  y47(subject, l, r) {
    return compareTo(subject.v47_1.h13(l), subject.v47_1.h13(r));
  }
  b33(subject, l, r) {
    return this.y47(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  z47(subject, indexL, indexR) {
    subject.v47_1.x31(indexL, indexR);
    subject.w47_1.x31(indexL, indexR);
  }
  d33(subject, indexL, indexR) {
    return this.z47(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  l48() {
    return 20;
  }
  m48() {
    return 0;
  }
  t47(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.l48()) + this.m48() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.b47_1 = -1;
    this.c47_1 = Winding_NON_ZERO_getInstance();
    this.d47_1 = Companion_getInstance_6().y2i();
    var tmp = this;
    tmp.e47_1 = Pool.e39(VOID, PolygonScanline$edgesPool$lambda);
    this.f47_1 = FastArrayList.g14();
    this.g47_1 = FastArrayList.g14();
    this.h47_1 = FastArrayList.g14();
    this.i47_1 = new AllBuckets();
    this.j47_1 = true;
    this.k47_1 = new PointArrayList();
    this.l47_1 = 0.0;
    this.m47_1 = 0.0;
    this.n47_1 = 0.0;
    this.o47_1 = 0.0;
    this.p47_1 = false;
    this.q47_1 = new XWithWind();
    this.r47_1 = 0;
    this.s47_1 = new IntSegmentSet();
  }
  v3u() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.d47_1);
  }
  z33() {
    this.j47_1 = true;
    this.d47_1 = Companion_getInstance_6().t2i_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.f47_1.e14_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.e47_1.h39(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.g47_1.e14_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.e47_1.h39(it_0);
    }
    this.f47_1.o3();
    this.g47_1.o3();
    this.h47_1.o3();
    this.k47_1.wh();
    this.i47_1.o3();
    this.l47_1 = 0.0;
    this.m47_1 = 0.0;
    this.n47_1 = 0.0;
    this.o47_1 = 0.0;
    this.p47_1 = false;
  }
  a48() {
    return this.f47_1.j1();
  }
  y2k() {
    return this.a48() > 0;
  }
  b48(x, y) {
    this.n47_1 = x;
    this.o47_1 = y;
    this.l47_1 = x;
    this.m47_1 = y;
    this.p47_1 = true;
  }
  c48(x, y) {
    if (this.p47_1) {
      addPoint(this, this.n47_1, this.o47_1);
    }
    addEdge(this, this.n47_1, this.o47_1, x, y);
    addPoint(this, x, y);
    this.n47_1 = x;
    this.o47_1 = y;
    this.p47_1 = false;
  }
  e3y(p) {
    return this.b48(p.i2h_1, p.j2h_1);
  }
  g3y(p) {
    return this.c48(p.i2h_1, p.j2h_1);
  }
  d48(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i2l();
    var l = Vector2D.i2l();
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.u6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.e48(it, true);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.e48(it_0, false);
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
          var sum = Companion_getInstance_1().n2w(l, c) + Companion_getInstance_1().n2w(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.i2l()};
          var prevPos = {_v: Vector2D.i2l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_9().e3w(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_9().e3w(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.e48(it_1, false);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_1().n2w(l, c0) + Companion_getInstance_1().n2w(c0, c1) + Companion_getInstance_1().n2w(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.i2l()};
          var prevPos_0 = {_v: Vector2D.i2l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.e48(it_2, false);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          var p = i;
          this.e48(p, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          if (true) {
            this.u6();
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.u6();
    }
  }
  e48(p, move) {
    var tmp;
    if (move) {
      this.e3y(p);
      tmp = Unit_instance;
    } else {
      this.g3y(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  f48(x, y, move) {
    var tmp;
    if (move) {
      this.b48(x, y);
      tmp = Unit_instance;
    } else {
      this.c48(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  u6() {
    this.c48(this.l47_1, this.m47_1);
  }
  g48(y, winding, out) {
    this.r47_1 = 0;
    this.q47_1.o3();
    out.wh();
    var tmp = this;
    var tmp_0 = this.r47_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = this.i47_1;
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.x46_1;
    if (this_1.j1() > 0) {
      var tmp47_safe_receiver = this_1.h46(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.b46_1.e14_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.i48(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge.q46_1) {
              this.q47_1.x47(edge.h48(y), edge.n46_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.y46_1;
    if (this_2.j1() > 0) {
      var tmp47_safe_receiver_0 = this_2.h46(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.b46_1.e14_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.i48(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_0.q46_1) {
              this.q47_1.x47(edge_0.h48(y), edge_0.n46_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.z46_1;
    if (this_3.j1() > 0) {
      var tmp47_safe_receiver_1 = this_3.h46(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.b46_1.e14_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.i48(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_1.q46_1) {
              this.q47_1.x47(edge_1.h48(y), edge_1.n46_1);
            }
          }
        }
      }
    }
    tmp.r47_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.q47_1, 0, this.q47_1.j1() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.q47_1.v47_1;
    var tempW = this.q47_1.w47_1;
    if (this.q47_1.j1() >= 2) {
      switch (winding.v3_1) {
        case 0:
          var progression = step(until(0, tempX.j1() - 1 | 0), 2);
          var inductionVariable = progression.k2_1;
          var last = progression.l2_1;
          var step_0 = progression.m2_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.h13(i);
              var b = tempX.h13(i + 1 | 0);
              out.i3f(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.j1() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.h13(i_0);
              count = count + tempW.h13(i_0) | 0;
              var b_0 = tempX.h13(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.i3f(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.i3f(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  j48(x, y, winding) {
    return this.k48(this.t47(x), this.t47(y), winding);
  }
  k48(x, y, winding) {
    var ss = this.s47_1;
    this.g48(y, winding, ss.wh());
    return ss.dp(x);
  }
}
class Companion_10 {
  constructor() {
    this.n48_1 = 20;
    this.o48_1 = 0;
    this.p48_1 = 80;
    this.q48_1 = 320;
    this.r48_1 = 1280;
  }
}
class Companion_11 {
  s48(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.j46_1;
    var Ay = a.k46_1;
    var Bx = a.l46_1;
    var By = a.m46_1;
    var Cx = b.j46_1;
    var Cy = b.k46_1;
    var Dx = b.l46_1;
    var Dy = b.m46_1;
    var tmp52_safe_receiver = this.t48(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY.<anonymous>' call
      tmp = Vector2I.v2u(numberToInt(floorCeil(tmp52_safe_receiver.i2h_1)), numberToInt(floorCeil(tmp52_safe_receiver.j2h_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion.getIntersectXY.<anonymous>' call
      tmp_0 = Vector2D.k2l(tmp51_safe_receiver.s2u_1, tmp51_safe_receiver.t2u_1);
    }
    return tmp_0;
  }
  u48(a, b) {
    return Angle__minus_impl_xeau7k(b.o2s(), a.o2s());
  }
  t48(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_19.t48(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.j46_1 = 0;
    this.k46_1 = 0;
    this.l46_1 = 0;
    this.m46_1 = 0;
    this.n46_1 = 0;
    this.o46_1 = 0;
    this.p46_1 = 0;
    this.q46_1 = false;
    this.r46_1 = false;
    this.s46_1 = 0;
  }
  v2k(n) {
    return n === 0 ? this.j46_1 : this.l46_1;
  }
  w2k(n) {
    return n === 0 ? this.k46_1 : this.m46_1;
  }
  v48(other) {
    return this.u47(other.j46_1, other.k46_1, other.l46_1, other.m46_1, other.n46_1);
  }
  u47(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.MEdge.setTo.<anonymous>' call
    this.j46_1 = ax;
    this.k46_1 = ay;
    this.l46_1 = bx;
    this.m46_1 = by;
    this.p46_1 = bx - ax | 0;
    this.o46_1 = by - ay | 0;
    this.q46_1 = ay === by;
    this.r46_1 = ax === bx;
    this.n46_1 = wind;
    this.s46_1 = this.r46_1 ? 0 : ay - (imul(ax, this.o46_1) / this.p46_1 | 0) | 0;
    return this;
  }
  t46() {
    // Inline function 'kotlin.math.min' call
    var a = this.k46_1;
    var b = this.m46_1;
    return Math.min(a, b);
  }
  u46() {
    // Inline function 'kotlin.math.max' call
    var a = this.k46_1;
    var b = this.m46_1;
    return Math.max(a, b);
  }
  i48(y) {
    return y >= this.k46_1 && y < this.m46_1;
  }
  h48(y) {
    return this.r46_1 || this.o46_1 === 0 ? this.j46_1 : imul(y - this.s46_1 | 0, this.p46_1) / this.o46_1 | 0;
  }
  o2s() {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_2();
    var x0 = this.j46_1;
    var y0 = this.k46_1;
    var x1 = this.l46_1;
    var y1 = this.m46_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance_1().e2i_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  toString() {
    return 'Edge([' + this.j46_1 + ',' + this.k46_1 + ']-[' + this.l46_1 + ',' + this.m46_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.p49_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.w48_1 = 1;
    this.y48_1 = LineCap_BUTT_getInstance();
    this.z48_1 = LineCap_BUTT_getInstance();
    this.a49_1 = LineJoin_BEVEL_getInstance();
    this.b49_1 = 4.0;
    this.c49_1 = new PointIntArrayList(1024);
    this.d49_1 = IntArrayList.f31(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(2), null);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e49_1 = tmp_1;
    this.f49_1 = this.e49_1[0];
    this.g49_1 = this.e49_1[1];
    this.h49_1 = new MEdge();
    this.i49_1 = new MEdge();
    this.j49_1 = new MEdge();
    this.k49_1 = new MEdge();
    this.l49_1 = new MEdge();
    this.m49_1 = new MEdge();
  }
  q49(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.setEdgeDisplaced.<anonymous>' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.u47(numberToInt(edge.j46_1 + ldx), numberToInt(edge.k46_1 + ldy), numberToInt(edge.l46_1 + ldx), numberToInt(edge.m46_1 + ldy), edge.n46_1);
    return _this__u8e3s4;
  }
  r49(_this__u8e3s4, e) {
    return _this__u8e3s4.i3f(e.j46_1, e.k46_1);
  }
  s49(_this__u8e3s4, e) {
    return _this__u8e3s4.i3f(e.l46_1, e.m46_1);
  }
  t49(_this__u8e3s4, e) {
    _this__u8e3s4.i3f(numberToInt(e.i2h_1), numberToInt(e.j2h_1));
  }
  u49(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.v3_1) {
      case 2:
        var intersection2 = Vector2D.k2l(mainPrev.l46_1, mainPrev.m46_1);
        var intersection = Companion_instance_11.s48(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance_1().n2w(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.j3f(toInt(intersection));
          } else {
            this.s49(out, prev);
            this.r49(out, curr);
          }
        }

        break;
      case 0:
        this.s49(out, prev);
        this.r49(out, curr);
        break;
      case 1:
        var i = Companion_instance_11.s48(prev, curr);
        if (!(i == null)) {
          var count = clamp_0(numberToInt(Companion_getInstance_1().m2w(prev.l46_1, prev.m46_1, curr.j46_1, curr.k46_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.t49(out, Companion_getInstance_9().e3w(Vector2D.k2h(prev.l46_1, prev.m46_1), Vector2D.k2h(i.i2h_1, i.j2h_1), Vector2D.k2h(curr.j46_1, curr.k46_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.s49(out, prev);
          this.r49(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  v49(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.o2s()) : Angle__unaryPlus_impl_eyi5pl(left.o2s());
    var lx = left.v2k(epoint.p49_1);
    var ly = left.w2k(epoint.p49_1);
    var rx = right.v2k(epoint.p49_1);
    var ry = right.w2k(epoint.p49_1);
    switch (cap.v3_1) {
      case 0:
        l.i3f(lx, ly);
        r.i3f(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.w48_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.w48_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.i3f(lx2, ly2);
          r.i3f(rx2, ry2);
        } else {
          var count = clamp_0(numberToInt(Companion_getInstance_27().m2w(lx, ly, rx, ry) * scale), 4, 64);
          l.i3f(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.t49(r, Companion_getInstance_9().d3w(Vector2D.k2h(lx, ly), Vector2D.k2h(lx2, ly2), Vector2D.k2h(rx2, ry2), Vector2D.k2h(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  d4a(scale, closed) {
    if (this.c49_1.a1())
      return Unit_instance;
    var weightD2 = this.w48_1 / 2 | 0;
    this.f49_1.o3();
    this.g49_1.o3();
    var sp = this.c49_1;
    var nstrokePoints = sp.j1();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.h49_1.v48(this.k49_1);
        this.i49_1.v48(this.l49_1);
        this.j49_1.v48(this.m49_1);
        var doJoin = !(this.d49_1.h13(n) === 0);
        this.k49_1.u47(sp.v2k(n), sp.w2k(n), sp.v2k(n1), sp.w2k(n1), 1);
        this.q49(this.l49_1, this.k49_1, weightD2, Angle__minus_impl_xeau7k(this.k49_1.o2s(), get_degrees(90)));
        this.q49(this.m49_1, this.k49_1, weightD2, Angle__plus_impl_26v37k(this.k49_1.o2s(), get_degrees(90)));
        if (isFirst) {
          this.v49(this.f49_1, this.g49_1, this.l49_1, this.m49_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.y48_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_11.u48(this.h49_1, this.k49_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.u49(this.f49_1, this.h49_1, this.k49_1, this.i49_1, this.l49_1, this.a49_1, this.b49_1, scale, leftAngle);
            this.u49(this.g49_1, this.h49_1, this.k49_1, this.j49_1, this.m49_1, this.a49_1, this.b49_1, scale, !leftAngle);
          } else {
            this.r49(this.f49_1, this.l49_1);
            this.r49(this.g49_1, this.m49_1);
          }
        } else if (isLast) {
          if (closed) {
            this.v49(this.f49_1, this.g49_1, this.l49_1, this.m49_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.v49(this.f49_1, this.g49_1, this.i49_1, this.j49_1, EdgePoint_B_getInstance(), this.z48_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.f49_1.j1();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.f49_1.v2k(n_0);
        var y = this.f49_1.w2k(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).e3y(Vector2D.k2h(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).g3y(Vector2D.k2h(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.g49_1.j1();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.g49_1.j1() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).g3y(Vector2D.k2h(this.g49_1.v2k(m) * scale, this.g49_1.w2k(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).u6();
    _get_outFill__zcv64g(this).o3y_1 = Winding_NON_ZERO_getInstance();
    this.c49_1.o3();
    this.d49_1.o3();
  }
  e4a(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.x48_1 = outFill;
    this.w48_1 = weight;
    this.y48_1 = startCap;
    this.z48_1 = endCap;
    this.a49_1 = joins;
    this.b49_1 = miterLimit * weight;
  }
  f4a(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.e4a(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i2l();
    var l = Vector2D.i2l();
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.d4a(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2h(tmp, stroke.n3y_1.i1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.d4a(iscale, false);
          }

          this.c49_1.i3f(numberToInt(it.i2h_1 * scale), numberToInt(it.j2h_1 * scale));
          this.d49_1.l31(0);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2h(tmp_0, stroke.n3y_1.i1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (false) {
            this.d4a(iscale, false);
          }

          this.c49_1.i3f(numberToInt(it_0.i2h_1 * scale), numberToInt(it_0.j2h_1 * scale));
          this.d49_1.l31(0);
          l = it_0;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.d49_1.t31(this.d49_1.j1() - 1 | 0, 1);
          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2h(tmp_1, stroke.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2h(tmp_2, stroke.n3y_1.i1(_unary__edvuaz_7));
          var sum = Companion_getInstance_1().n2w(l, c) + Companion_getInstance_1().n2w(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.i2l()};
          var prevPos = {_v: Vector2D.i2l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_9().e3w(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_9().e3w(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.d4a(iscale, false);
              }
              this.c49_1.i3f(numberToInt(it_1.i2h_1 * scale), numberToInt(it_1.j2h_1 * scale));
              this.d49_1.l31(0);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.d49_1.t31(this.d49_1.j1() - 1 | 0, 1);
          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2h(tmp_3, stroke.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2h(tmp_4, stroke.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2h(tmp_5, stroke.n3y_1.i1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_1().n2w(l, c0) + Companion_getInstance_1().n2w(c0, c1) + Companion_getInstance_1().n2w(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.i2l()};
          var prevPos_0 = {_v: Vector2D.i2l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.d4a(iscale, false);
              }
              this.c49_1.i3f(numberToInt(it_2.i2h_1 * scale), numberToInt(it_2.j2h_1 * scale));
              this.d49_1.l31(0);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.d49_1.t31(this.d49_1.j1() - 1 | 0, 1);
          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          var p = i;
          if (false) {
            this.d4a(iscale, false);
          }

          this.c49_1.i3f(numberToInt(p.i2h_1 * scale), numberToInt(p.j2h_1 * scale));
          this.d49_1.l31(0);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.d49_1.t31(this.d49_1.j1() - 1 | 0, 1);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.d4a(iscale, true);
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.d4a(iscale, true);
    }
    this.d4a(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var this_0 = Companion_getInstance_9();
  var x0 = this.f3y().i2h_1;
  var y0 = this.f3y().j2h_1;
  var xc = c.i2h_1;
  var yc = c.j2h_1;
  var x1 = a.i2h_1;
  var y1 = a.j2h_1;
  var cx1 = this_0.f3w(x0, xc);
  var cy1 = this_0.f3w(y0, yc);
  var cx2 = this_0.g3w(xc, x1);
  var cy2 = this_0.g3w(yc, y1);
  this.j3y(Vector2D.k2h(cx1, cy1), Vector2D.k2h(cx2, cy2), Vector2D.k2h(x1, y1));
}
function moveTo(x, y) {
  return this.e3y(Vector2D.k2h(x, y));
}
function lineTo(x, y) {
  return this.g3y(Vector2D.k2h(x, y));
}
function quadTo_0(cx, cy, ax, ay) {
  return this.h3y(Vector2D.k2h(cx, cy), Vector2D.k2h(ax, ay));
}
function line(p0, p1) {
  this.e3y(p0);
  this.g3y(p1);
}
function arcTo(a, c, r) {
  return Arc_instance.d3y(this, a, c, r);
}
function isEmpty() {
  return this.k4a() === 0;
}
function isNotEmpty() {
  return !(this.k4a() === 0);
}
function rect(rect) {
  return this.p4a(rect.i2i_1, rect.j2i_1, rect.k2i_1, rect.l2i_1);
}
function rect_0(pos, size) {
  this.p4a(pos.i2h_1, pos.j2h_1, size.d2j_1, size.e2j_1);
}
function rect_1(x, y, width, height) {
  this.e3y(Vector2D.k2h(x, y));
  this.g3y(Vector2D.k2h(x + width, y));
  this.g3y(Vector2D.k2h(x + width, y + height));
  this.g3y(Vector2D.k2h(x, y + height));
  this.u6();
}
function rect_2(x, y, width, height) {
  return this.p4a(x, y, width, height);
}
function roundRect(x, y, w, h, rtl, rtr, rbr, rbl) {
  if (rtl === 0.0 && rtr === 0.0 && rbr === 0.0 && rbl === 0.0) {
    this.p4a(x, y, w, h);
  } else {
    this.e3y(Vector2D.k2h(x + rtl, y));
    this.m4a(Vector2D.k2h(x + w, y), Vector2D.k2h(x + w, y + h), rtr);
    this.m4a(Vector2D.k2h(x + w, y + h), Vector2D.k2h(x, y + h), rbr);
    this.m4a(Vector2D.k2h(x, y + h), Vector2D.k2h(x, y), rbl);
    this.m4a(Vector2D.k2h(x, y), Vector2D.k2h(x + w, y), rtl);
    this.u6();
  }
}
function roundRect_0(x, y, w, h, rx, ry) {
  var r = w < 2 * rx ? w / 2.0 : h < 2 * rx ? h / 2.0 : rx;
  this.q4a(x, y, w, h, r, r, r, r);
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.k3y(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.r4a(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.s4a(center, radius, Companion_getInstance_2().r2h_1, Companion_getInstance_2().v2h_1);
}
function ellipse(center, radius) {
  return Arc_instance.i3y(this, minus(center, radius), radius.y2v(2));
}
function lineToH(x) {
  return this.g3y(Vector2D.k2h(x, this.f3y().j2h_1));
}
function lineToV(y) {
  return this.g3y(Vector2D.k2h(this.f3y().i2h_1, y));
}
function rLineToH(x) {
  return this.y4a(Vector2D.k2h(x, 0.0));
}
function rLineToV(y) {
  return this.y4a(Vector2D.k2h(0.0, y));
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.f3y();
  var tmp$ret$0 = Vector2D.k2h(this_0.i2h_1 + delta.i2h_1, this_0.j2h_1 + delta.j2h_1);
  return this.e3y(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.f3y();
  var tmp$ret$0 = Vector2D.k2h(this_0.i2h_1 + delta.i2h_1, this_0.j2h_1 + delta.j2h_1);
  return this.g3y(tmp$ret$0);
}
function rLineTo_0(a, relative) {
  var tmp;
  if (relative) {
    this.y4a(a);
    tmp = Unit_instance;
  } else {
    this.g3y(a);
    tmp = Unit_instance;
  }
  return tmp;
}
function rMoveTo_0(a, relative) {
  var tmp;
  if (relative) {
    this.x4a(a);
    tmp = Unit_instance;
  } else {
    this.e3y(a);
    tmp = Unit_instance;
  }
  return tmp;
}
function rLineToH_0(x, relative) {
  var tmp;
  if (relative) {
    this.v4a(x);
    tmp = Unit_instance;
  } else {
    this.t4a(x);
    tmp = Unit_instance;
  }
  return tmp;
}
function rLineToV_0(y, relative) {
  var tmp;
  if (relative) {
    this.w4a(y);
    tmp = Unit_instance;
  } else {
    this.u4a(y);
    tmp = Unit_instance;
  }
  return tmp;
}
function transformed(m) {
  var im = m.y2n();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.j2u(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.h4a_1 = $parent;
    this.i4a_1 = $im;
    this.j4a_1 = $m;
    this.g4a_1 = $parent.k4a();
  }
  f3y() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.i4a_1;
      var p = this.h4a_1.f3y();
      if (this_0.n2i()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2h(this_0.d2n(p.i2h_1, p.j2h_1), this_0.g2n(p.i2h_1, p.j2h_1));
    }
    return tmp$ret$0;
  }
  k4a() {
    return this.g4a_1;
  }
  u6() {
    return this.h4a_1.u6();
  }
  g3y(p) {
    return this.h4a_1.g3y(t(this, p));
  }
  e3y(p) {
    return this.h4a_1.g3y(t(this, p));
  }
  h3y(c, a) {
    return this.h4a_1.h3y(t(this, c), t(this, a));
  }
  j3y(c1, c2, a) {
    return this.h4a_1.j3y(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_12 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo_0(p) {
  return Unit_instance;
}
function lineTo_0(p) {
  return Unit_instance;
}
function quadTo_1(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.f31() : commands;
    data = data === VOID ? DoubleArrayList.c32() : data;
    winding = winding === VOID ? Companion_instance_13.i4b() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.l3y_1 = new Mixin();
    this.m3y_1 = commands;
    this.n3y_1 = data;
    this.o3y_1 = winding;
    this.p3y_1 = optimize;
    this.q3y_1 = false;
    this.r3y_1 = 0;
    this.s3y_1 = Vector2D.i2l();
    this.t3y_1 = Vector2D.i2l();
    this.u3y_1 = null;
    this.v3y_1 = null;
  }
  n13(_set____db54di) {
    this.l3y_1.n13(_set____db54di);
  }
  o13() {
    return this.l3y_1.o13();
  }
  j13() {
    return new VectorPath(IntArrayList.h31(this.m3y_1), DoubleArrayList.d32(this.n3y_1), this.o3y_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.m3y_1.equals(other.m3y_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n3y_1.equals(other.n3y_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.o3y_1.equals(other.o3y_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.m3y_1.hashCode() + imul(this.n3y_1.hashCode(), 13) | 0) + imul(this.o3y_1.v3_1, 111) | 0;
  }
  j4b(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          visitor.e3y(Vector2D.k2h(tmp, this.n3y_1.i1(_unary__edvuaz_1)));
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          visitor.g3y(Vector2D.k2h(tmp_0, this.n3y_1.i1(_unary__edvuaz_3)));
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp_2 = Vector2D.k2h(tmp_1, this.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_3 = this.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          visitor.h3y(tmp_2, Vector2D.k2h(tmp_3, this.n3y_1.i1(_unary__edvuaz_7)));
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_4 = this.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp_5 = Vector2D.k2h(tmp_4, this.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_6 = this.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp_7 = Vector2D.k2h(tmp_6, this.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_8 = this.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          visitor.j3y(tmp_5, tmp_7, Vector2D.k2h(tmp_8, this.n3y_1.i1(_unary__edvuaz_13)));
          break;
        case 4:
          visitor.u6();
          break;
      }
    }
  }
  o3() {
    this.m3y_1.o3();
    this.n3y_1.o3();
    this.s3y_1 = Vector2D.i2l();
    this.r3y_1 = 0;
    this.k4b().b47_1 = this.r3y_1 - 1 | 0;
  }
  f3y() {
    return this.s3y_1;
  }
  e3y(p) {
    if (this.m3y_1.y2k() && this.m3y_1.v31() === 0) {
      if (this.s3y_1.equals(p))
        return Unit_instance;
    }
    this.m3y_1.l31(0);
    this.n3y_1.h32(p.i2h_1, p.j2h_1);
    this.s3y_1 = p;
    this.t3y_1 = p;
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  g3y(p) {
    if (ensureMoveTo(this, p) && this.p3y_1)
      return Unit_instance;
    if (p.equals(this.s3y_1) && this.p3y_1)
      return Unit_instance;
    this.m3y_1.l31(1);
    this.n3y_1.h32(p.i2h_1, p.j2h_1);
    this.s3y_1 = p;
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  h3y(c, a) {
    ensureMoveTo(this, c);
    this.m3y_1.l31(2);
    this.n3y_1.j32(c.i2h_1, c.j2h_1, a.i2h_1, a.j2h_1);
    this.s3y_1 = a;
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  j3y(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.m3y_1.l31(3);
    this.n3y_1.k32(c1.i2h_1, c1.j2h_1, c2.i2h_1, c2.j2h_1, a.i2h_1, a.j2h_1);
    this.s3y_1 = a;
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  u6() {
    this.m3y_1.l31(4);
    this.s3y_1 = this.t3y_1;
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  k4a() {
    return this.n3y_1.j1() / 2 | 0;
  }
  v3u() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus_0(Companion_getInstance_6().y2i(), this));
  }
  l4b(x, y) {
    return this.m4b().j48(x, y, this.o3y_1);
  }
  u4b(p) {
    return this.j48(p.i2h_1, p.j2h_1, this.o3y_1);
  }
  m4b() {
    if (this.u3y_1 == null || !(ensureNotNull(this.u3y_1).n4b_1 === this.r3y_1)) {
      this.u3y_1 = new VectorPathTrapezoids(this.r3y_1, this);
    }
    return ensureNotNull(this.u3y_1);
  }
  k4b() {
    if (this.v3y_1 == null)
      this.v3y_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.v3y_1);
    if (!(scanline.b47_1 === this.r3y_1)) {
      scanline.z33();
      scanline.d48(this);
      scanline.b47_1 = this.r3y_1;
    }
    return ensureNotNull(this.v3y_1);
  }
  j48(x, y, winding) {
    return this.k4b().j48(x, y, winding);
  }
  v4b(path, transform) {
    this.m3y_1.p31(path.m3y_1);
    if (transform.a2n()) {
      this.n3y_1.m32(path.n3y_1);
      this.s3y_1 = path.s3y_1;
    } else {
      var progression = step(until(0, path.n3y_1.j1()), 2);
      var inductionVariable = progression.k2_1;
      var last = progression.l2_1;
      var step_0 = progression.m2_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            var p = Vector2D.k2h(path.n3y_1.i1(n + 0 | 0), path.n3y_1.i1(n + 1 | 0));
            if (transform.n2i()) {
              tmp$ret$0 = p;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.k2h(transform.d2n(p.i2h_1, p.j2h_1), transform.g2n(p.i2h_1, p.j2h_1));
          }
          var p_0 = tmp$ret$0;
          this.n3y_1.h32(p_0.i2h_1, p_0.j2h_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = path.s3y_1;
        if (transform.n2i()) {
          tmp$ret$1 = p_1;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.k2h(transform.d2n(p_1.i2h_1, p_1.j2h_1), transform.g2n(p_1.i2h_1, p_1.j2h_1));
      }
      tmp.s3y_1 = tmp$ret$1;
    }
    this.r3y_1 = this.r3y_1 + 1 | 0;
  }
  w4b(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.v4b(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.v4b.call(this, path, transform);
    }
    return tmp;
  }
  x4b() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.m3y_1;
    var n_0 = 0;
    while (n_0 < this_1.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2h(tmp, this.n3y_1.i1(_unary__edvuaz_1));
          var x = destruct.km();
          var y = destruct.lm();
          this_0.ic('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2h(tmp_0, this.n3y_1.i1(_unary__edvuaz_3));
          var x_0 = destruct_0.km();
          var y_0 = destruct_0.lm();
          this_0.ic('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2h(tmp_1, this.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2h(tmp_2, this.n3y_1.i1(_unary__edvuaz_7));
          var x1 = destruct_1.km();
          var y1 = destruct_1.lm();
          var x2 = destruct_2.km();
          var y2 = destruct_2.lm();
          this_0.ic('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2h(tmp_3, this.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2h(tmp_4, this.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2h(tmp_5, this.n3y_1.i1(_unary__edvuaz_13));
          var x1_0 = destruct_3.km();
          var y1_0 = destruct_3.lm();
          var x2_0 = destruct_4.km();
          var y2_0 = destruct_4.lm();
          var x3 = destruct_5.km();
          var y3 = destruct_5.lm();
          this_0.ic('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.ic('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.x4b() + ')';
  }
  y4b(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.n3y_1.j1()), 2);
    var inductionVariable = progression.k2_1;
    var last = progression.l2_1;
    var step_0 = progression.m2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.VectorPath.scale.<anonymous>' call
        var it = Vector2D.k2h(this.n3y_1.i1(n + 0 | 0), this.n3y_1.i1(n + 1 | 0));
        var p = Vector2D.k2h(it.i2h_1 * sx, it.j2h_1 * sy);
        this.n3y_1.p32(n + 0 | 0, p.i2h_1);
        this.n3y_1.p32(n + 1 | 0, p.j2h_1);
      }
       while (!(n === last));
    this.r3y_1 = this.r3y_1 + 1 | 0;
    return this;
  }
}
class VectorPathTrapezoids {
  constructor(version, path, scale) {
    scale = scale === VOID ? 100 : scale;
    this.n4b_1 = version;
    this.o4b_1 = path;
    this.p4b_1 = scale;
    this.q4b_1 = imul(this.p4b_1, this.p4b_1);
    this.r4b_1 = toSegments(this.o4b_1, this.p4b_1);
    var tmp = this;
    tmp.s4b_1 = lazy(VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.t4b_1 = lazy(VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this));
  }
  z4b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s4b_1;
    trapezoidsEvenOdd$factory();
    return this_0.b2();
  }
  a4c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t4b_1;
    trapezoidsNonZero$factory();
    return this_0.b2();
  }
  b4c(winding) {
    var tmp;
    switch (winding.v3_1) {
      case 0:
        tmp = this.z4b();
        break;
      case 1:
        tmp = this.a4c();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  j48(x, y, winding) {
    return this.b4c(winding).n44(toIntRound(x * this.p4b_1), toIntRound(y * this.p4b_1));
  }
}
class with$1 {
  constructor($bb) {
    this.c4c_1 = $bb;
  }
  e3y(p) {
    this.c4c_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.c4c_1._v.l2j_1, p));
  }
}
class Companion_13 {
  i4b() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.f4c_1 = str;
  }
}
class Companion_14 {
  g4c(str) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (str == null || charSequenceLength(str) === 0) {
      tmp = LineJoin_MITER_getInstance();
    } else {
      var tmp61_subject = uppercaseChar(charSequenceGet(str, 0));
      tmp = tmp61_subject === _Char___init__impl__6a9atx(77) ? LineJoin_MITER_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(66) ? LineJoin_BEVEL_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(83) ? LineJoin_BEVEL_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(82) ? LineJoin_ROUND_getInstance() : LineJoin_MITER_getInstance();
    }
    return tmp;
  }
}
class LineJoin extends Enum {}
class Companion_15 {
  g4c(str) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (str == null || charSequenceLength(str) === 0) {
      tmp = LineCap_BUTT_getInstance();
    } else {
      var tmp60_subject = uppercaseChar(charSequenceGet(str, 0));
      tmp = tmp60_subject === _Char___init__impl__6a9atx(66) ? LineCap_BUTT_getInstance() : tmp60_subject === _Char___init__impl__6a9atx(83) ? LineCap_SQUARE_getInstance() : tmp60_subject === _Char___init__impl__6a9atx(82) ? LineCap_ROUND_getInstance() : LineCap_BUTT_getInstance();
    }
    return tmp;
  }
}
class LineCap extends Enum {}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.j4c_1 = hScale;
    this.k4c_1 = vScale;
    this.l4c_1 = this.j4c_1 || this.k4c_1;
    this.m4c_1 = (this.j4c_1 && this.k4c_1);
  }
}
class Companion_16 {
  n4c(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    return new StrokeInfo(numberToDouble(thickness), pixelHinting, scaleMode, startCap, endCap, join, numberToDouble(miterLimit), dash, numberToDouble(dashOffset));
  }
  o4c(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset, $super) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    return $super === VOID ? this.n4c(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) : $super.n4c.call(this, thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset);
  }
}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.n3s_1 = thickness;
    this.o3s_1 = pixelHinting;
    this.p3s_1 = scaleMode;
    this.q3s_1 = startCap;
    this.r3s_1 = endCap;
    this.s3s_1 = join;
    this.t3s_1 = miterLimit;
    this.u3s_1 = dash;
    this.v3s_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.n3s_1 + ', pixelHinting=' + this.o3s_1 + ', scaleMode=' + this.p3s_1.toString() + ', startCap=' + this.q3s_1.toString() + ', endCap=' + this.r3s_1.toString() + ', join=' + this.s3s_1.toString() + ', miterLimit=' + this.t3s_1 + ', dash=' + toString_0(this.u3s_1) + ', dashOffset=' + this.v3s_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.n3s_1);
    result = imul(result, 31) + getBooleanHashCode(this.o3s_1) | 0;
    result = imul(result, 31) + this.p3s_1.hashCode() | 0;
    result = imul(result, 31) + this.q3s_1.hashCode() | 0;
    result = imul(result, 31) + this.r3s_1.hashCode() | 0;
    result = imul(result, 31) + this.s3s_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.t3s_1) | 0;
    result = imul(result, 31) + (this.u3s_1 == null ? 0 : hashCode(this.u3s_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.n3s_1, tmp0_other_with_cast.n3s_1))
      return false;
    if (!(this.o3s_1 === tmp0_other_with_cast.o3s_1))
      return false;
    if (!this.p3s_1.equals(tmp0_other_with_cast.p3s_1))
      return false;
    if (!this.q3s_1.equals(tmp0_other_with_cast.q3s_1))
      return false;
    if (!this.r3s_1.equals(tmp0_other_with_cast.r3s_1))
      return false;
    if (!this.s3s_1.equals(tmp0_other_with_cast.s3s_1))
      return false;
    if (!equals(this.t3s_1, tmp0_other_with_cast.t3s_1))
      return false;
    if (!equals(this.u3s_1, tmp0_other_with_cast.u3s_1))
      return false;
    if (!equals(this.v3s_1, tmp0_other_with_cast.v3s_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.w49_1 = ConcurrentPool.s39(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.x49_1 = MPoint.s4c(0.0, 0.0);
    this.y49_1 = MPoint.s4c(1.0, 1.0);
    this.z49_1 = MPoint.s4c(0.0, -1.0);
    this.a4a_1 = MPoint.s4c(0.0, +1.0);
    this.b4a_1 = MPoint.s4c(-1.0, 0.0);
    this.c4a_1 = MPoint.s4c(+1.0, 0.0);
  }
  l2m() {
    return MPoint.s4c(0.0, 0.0);
  }
  t4c(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  l2u(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  m2w(x1, y1, x2, y2) {
    return this.l2u(x1, y1, x2, y2);
  }
  u4c(aX, aY, bX, bY) {
    return aX * bX + aY * bY;
  }
}
class MPoint {
  static s4c(x, y) {
    Companion_getInstance_27();
    var $this = createThis(this);
    $this.p4c_1 = x;
    $this.q4c_1 = y;
    return $this;
  }
  static v4c(x, y) {
    Companion_getInstance_27();
    return this.s4c(x, y);
  }
  w4c(other, epsilon) {
    return isAlmostEquals_0(this.p4c_1, other.p4c_1, epsilon) && isAlmostEquals_0(this.q4c_1, other.q4c_1, epsilon);
  }
  uz(other, epsilon) {
    return this.w4c(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  r4c(x, y) {
    this.p4c_1 = x;
    this.q4c_1 = y;
    return this;
  }
  x4c(x, y) {
    this.p4c_1 = x;
    this.q4c_1 = y;
    return this;
  }
  y4c(mat, p) {
    return this.z4c(mat, p.p4c_1, p.q4c_1);
  }
  z4c(mat, x, y) {
    return this.r4c(mat.d2n(x, y), mat.g2n(x, y));
  }
  g4d(a, b) {
    return this.r4c(a.p4c_1 + b.p4c_1, a.q4c_1 + b.q4c_1);
  }
  h4d(a, b) {
    return this.r4c(a.p4c_1 - b.p4c_1, a.q4c_1 - b.q4c_1);
  }
  i4d(a, s) {
    return this.r4c(a.p4c_1 * s, a.q4c_1 * s);
  }
  j4d(ratio, other) {
    return Companion_getInstance_27().l2m().k4d(ratio, this, other);
  }
  d10(ratio, other) {
    return this.j4d(ratio, other instanceof MPoint ? other : THROW_CCE());
  }
  k4d(ratio, l, r) {
    return this.l4d(ratio, l.p4c_1, l.q4c_1, r.p4c_1, r.q4c_1);
  }
  l4d(ratio, lx, ly, rx, ry) {
    return this.r4c(interpolate_1(ratio, lx, rx), interpolate_1(ratio, ly, ry));
  }
  m4d(other) {
    return Companion_getInstance_27().t4c(this.p4c_1, this.q4c_1, other.p4c_1, other.q4c_1);
  }
  d(other) {
    return this.m4d(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.p4c_1) + ', ' + get_niceStr(this.q4c_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p4c_1);
    result = imul(result, 31) + getNumberHashCode(this.q4c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.p4c_1, tmp0_other_with_cast.p4c_1))
      return false;
    if (!equals(this.q4c_1, tmp0_other_with_cast.q4c_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.o4d_1 = ConcurrentPool.s39(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_28();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.a4d_1 = a;
    this.b4d_1 = b;
    this.c4d_1 = c;
    this.d4d_1 = d;
    this.e4d_1 = tx;
    this.f4d_1 = ty;
  }
  j2t() {
    return new Matrix(this.a4d_1, this.b4d_1, this.c4d_1, this.d4d_1, this.e4d_1, this.f4d_1);
  }
  p4d(a, b, c, d, tx, ty) {
    this.a4d_1 = a;
    this.b4d_1 = b;
    this.c4d_1 = c;
    this.d4d_1 = d;
    this.e4d_1 = tx;
    this.f4d_1 = ty;
    return this;
  }
  q4d(that) {
    return this.p4d(that.n2m_1, that.o2m_1, that.p2m_1, that.q2m_1, that.r2m_1, that.s2m_1);
  }
  r4d(that) {
    if (!(that == null)) {
      this.p4d(that.a4d_1, that.b4d_1, that.c4d_1, that.d4d_1, that.e4d_1, that.f4d_1);
    } else {
      this.n4d();
    }
    return this;
  }
  s4d(sx, sy) {
    return this.p4d(this.a4d_1 * sx, this.b4d_1 * sx, this.c4d_1 * sy, this.d4d_1 * sy, this.e4d_1, this.f4d_1);
  }
  t4d(dx, dy) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix.pretranslate.<anonymous>' call
    this.e4d_1 = this.e4d_1 + (this.a4d_1 * dx + this.c4d_1 * dy);
    this.f4d_1 = this.f4d_1 + (this.b4d_1 * dx + this.d4d_1 * dy);
    return this;
  }
  u4d(point, out) {
    return this.v4d(point.p4c_1, point.q4c_1, out);
  }
  w4d(point, out, $super) {
    out = out === VOID ? Companion_getInstance_27().l2m() : out;
    return $super === VOID ? this.u4d(point, out) : $super.u4d.call(this, point, out);
  }
  v4d(x, y, out) {
    out.p4c_1 = this.x4d(x, y);
    out.q4c_1 = this.y4d(x, y);
    return out;
  }
  x4d(x, y) {
    return x * this.a4d_1 + y * this.c4d_1;
  }
  y4d(x, y) {
    return x * this.b4d_1 + y * this.d4d_1;
  }
  n4d() {
    return this.p4d(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  j13() {
    return new MMatrix(this.a4d_1, this.b4d_1, this.c4d_1, this.d4d_1, this.e4d_1, this.f4d_1);
  }
  d2n(px, py) {
    return this.a4d_1 * px + this.c4d_1 * py + this.e4d_1;
  }
  g2n(px, py) {
    return this.d4d_1 * py + this.b4d_1 * px + this.f4d_1;
  }
  z4d(ratio, l, r) {
    return this.p4d(interpolate_1(ratio, l.a4d_1, r.a4d_1), interpolate_1(ratio, l.b4d_1, r.b4d_1), interpolate_1(ratio, l.c4d_1, r.c4d_1), interpolate_1(ratio, l.d4d_1, r.d4d_1), interpolate_1(ratio, l.e4d_1, r.e4d_1), interpolate_1(ratio, l.f4d_1, r.f4d_1));
  }
  a4e(ratio, other) {
    return (new MMatrix()).z4d(ratio, this, other);
  }
  d10(ratio, other) {
    return this.a4e(ratio, other instanceof MMatrix ? other : THROW_CCE());
  }
  toString() {
    return 'Matrix(a=' + this.a4d_1 + ', b=' + this.b4d_1 + ', c=' + this.c4d_1 + ', d=' + this.d4d_1 + ', tx=' + this.e4d_1 + ', ty=' + this.f4d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.a4d_1);
    result = imul(result, 31) + getNumberHashCode(this.b4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.a4d_1, tmp0_other_with_cast.a4d_1))
      return false;
    if (!equals(this.b4d_1, tmp0_other_with_cast.b4d_1))
      return false;
    if (!equals(this.c4d_1, tmp0_other_with_cast.c4d_1))
      return false;
    if (!equals(this.d4d_1, tmp0_other_with_cast.d4d_1))
      return false;
    if (!equals(this.e4d_1, tmp0_other_with_cast.e4d_1))
      return false;
    if (!equals(this.f4d_1, tmp0_other_with_cast.f4d_1))
      return false;
    return true;
  }
}
class Companion_19 {
  b4e(point, direction, scale, out) {
    return out.c4e(point.i2h_1, point.j2h_1, point.i2h_1 + direction.i2h_1 * scale, point.j2h_1 + direction.j2h_1 * scale);
  }
  o3t(point, direction, scale, out, $super) {
    scale = scale === VOID ? 1.0 : scale;
    out = out === VOID ? MLine.d4e() : out;
    return $super === VOID ? this.b4e(point, direction, scale, out) : $super.b4e.call(this, point, direction, scale, out);
  }
  t48(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.k2h(x, y);
  }
}
class MLine {
  static e4e(a, b) {
    var $this = createThis(this);
    $this.p3t_1 = a;
    $this.q3t_1 = b;
    return $this;
  }
  j13() {
    return MLine.e4e(this.p3t_1, this.q3t_1);
  }
  c4e(x0, y0, x1, y1) {
    this.p3t_1 = Vector2D.k2h(x0, y0);
    this.q3t_1 = Vector2D.k2h(x1, y1);
    return this;
  }
  r3t(scale) {
    var tmp = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.p3t_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = this.f4e();
    var that = Vector2D.k2h(this_1.i2h_1 * scale, this_1.j2h_1 * scale);
    tmp.p3t_1 = Vector2D.k2h(this_0.i2h_1 - that.i2h_1, this_0.j2h_1 - that.j2h_1);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_2 = this.q3t_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_3 = this.f4e();
    var that_0 = Vector2D.k2h(this_3.i2h_1 * scale, this_3.j2h_1 * scale);
    tmp_0.q3t_1 = Vector2D.k2h(this_2.i2h_1 - that_0.i2h_1, this_2.j2h_1 - that_0.j2h_1);
    return this;
  }
  static d4e() {
    return this.e4e(Vector2D.i2l(), Vector2D.i2l());
  }
  l2l() {
    return this.p3t_1.i2h_1;
  }
  m2l() {
    return this.p3t_1.j2h_1;
  }
  n2l() {
    return this.q3t_1.i2h_1;
  }
  o2l() {
    return this.q3t_1.j2h_1;
  }
  f4e() {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.q3t_1;
    var that = this.p3t_1;
    return Vector2D.k2h(this_0.i2h_1 - that.i2h_1, this_0.j2h_1 - that.j2h_1);
  }
  toString() {
    return 'Line(' + this.p3t_1.toString() + ', ' + this.q3t_1.toString() + ')';
  }
  g4e(line) {
    return Companion_instance_19.t48(this.l2l(), this.m2l(), this.n2l(), this.o2l(), line.l2l(), line.m2l(), line.n2l(), line.o2l());
  }
  hashCode() {
    var result = this.p3t_1.hashCode();
    result = imul(result, 31) + this.q3t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MLine))
      return false;
    var tmp0_other_with_cast = other instanceof MLine ? other : THROW_CCE();
    if (!this.p3t_1.equals(tmp0_other_with_cast.p3t_1))
      return false;
    if (!this.q3t_1.equals(tmp0_other_with_cast.q3t_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.l4e_1 = ConcurrentPool.s39(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  l2m() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
  d2t(x, y, width, height) {
    return new MRectangle(x, y, width, height);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_30();
    this.h4e_1 = x;
    this.i4e_1 = y;
    this.j4e_1 = width;
    this.k4e_1 = height;
  }
  m4e() {
    return !(this.j4e_1 === 0.0) || !(this.k4e_1 === 0.0);
  }
  n4e(other, epsilon) {
    return isAlmostEquals_0(this.h4e_1, other.h4e_1, epsilon) && isAlmostEquals_0(this.i4e_1, other.i4e_1, epsilon) && isAlmostEquals_0(this.j4e_1, other.j4e_1, epsilon) && isAlmostEquals_0(this.k4e_1, other.k4e_1, epsilon);
  }
  uz(other, epsilon) {
    return this.n4e(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  o4e(value) {
    this.j4e_1 = this.j4e_1 + (this.h4e_1 - value);
    this.h4e_1 = value;
  }
  p2i() {
    return this.h4e_1;
  }
  p4e(value) {
    this.k4e_1 = this.k4e_1 + (this.i4e_1 - value);
    this.i4e_1 = value;
  }
  r2i() {
    return this.i4e_1;
  }
  q4e(value) {
    this.j4e_1 = value - this.h4e_1;
  }
  q2i() {
    return this.h4e_1 + this.j4e_1;
  }
  r4e(value) {
    this.k4e_1 = value - this.i4e_1;
  }
  s2i() {
    return this.i4e_1 + this.k4e_1;
  }
  s4e() {
    return Companion_instance_21.t4e(this.j4e_1, this.k4e_1);
  }
  c4e(x, y, width, height) {
    this.h4e_1 = x;
    this.i4e_1 = y;
    this.j4e_1 = width;
    this.k4e_1 = height;
    return this;
  }
  u4e(that) {
    return this.c4e(that.h4e_1, that.i4e_1, that.j4e_1, that.k4e_1);
  }
  v4e(left, top, right, bottom) {
    return this.c4e(left, top, right - left, bottom - top);
  }
  w4e(left, top, right, bottom) {
    return this.v4e(left, top, right, bottom);
  }
  x4e(left, top, right, bottom) {
    return this.v4e(this.p2i() - left, this.r2i() - top, this.q2i() + right, this.s2i() + bottom);
  }
  y4e(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.x4e(left, top, right, bottom) : $super.x4e.call(this, left, top, right, bottom);
  }
  wh() {
    return this.c4e(0.0, 0.0, 0.0, 0.0);
  }
  z4e(item, anchor, container) {
    return this.a4f(item.s4e(), anchor, container);
  }
  a4f(item, anchor, container) {
    return this.b4f(get_immutable(item), anchor, container);
  }
  b4f(item, anchor, container) {
    return this.c4e(container.h4e_1 + anchor.y2g_1 * (container.j4e_1 - item.d2j_1), container.i4e_1 + anchor.z2g_1 * (container.k4e_1 - item.e2j_1), item.d2j_1, item.e2j_1);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.h4e_1) + ', y=' + get_niceStr(this.i4e_1) + ', width=' + get_niceStr(this.j4e_1) + ', height=' + get_niceStr(this.k4e_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.h4e_1, other.h4e_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.i4e_1, other.i4e_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.j4e_1, other.j4e_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.k4e_1, other.k4e_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  c4f(ratio, other) {
    return Companion_getInstance_30().l2m().d4f(ratio, this, other);
  }
  d10(ratio, other) {
    return this.c4f(ratio, other instanceof MRectangle ? other : THROW_CCE());
  }
  d4f(ratio, l, r) {
    return this.c4e(interpolate_1(ratio, l.h4e_1, r.h4e_1), interpolate_1(ratio, l.i4e_1, r.i4e_1), interpolate_1(ratio, l.j4e_1, r.j4e_1), interpolate_1(ratio, l.k4e_1, r.k4e_1));
  }
  j2t() {
    return new Rectangle(this.h4e_1, this.i4e_1, this.j4e_1, this.k4e_1);
  }
  k2u(x, y, width, height) {
    return new MRectangle(x, y, width, height);
  }
  e4f(x, y, width, height, $super) {
    x = x === VOID ? this.h4e_1 : x;
    y = y === VOID ? this.i4e_1 : y;
    width = width === VOID ? this.j4e_1 : width;
    height = height === VOID ? this.k4e_1 : height;
    return $super === VOID ? this.k2u(x, y, width, height) : $super.k2u.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.h4e_1);
    result = imul(result, 31) + getNumberHashCode(this.i4e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4e_1) | 0;
    return result;
  }
}
class Companion_21 {
  t4e(width, height) {
    return _MSize___init__impl__75ig0l(MPoint.s4c(width, height));
  }
}
class Companion_22 {
  e2t(x, y, z, w) {
    return (new MVector4()).g4f(x, y, z, w);
  }
  h4f(x, y, z, w, $super) {
    w = w === VOID ? 1.0 : w;
    return $super === VOID ? this.e2t(x, y, z, w) : $super.e2t.call(this, x, y, z, w);
  }
  d2t(x, y, z, w) {
    return (new MVector4()).i4f(x, y, z, w);
  }
  j4f(x, y, z, w, $super) {
    w = w === VOID ? 1 : w;
    return $super === VOID ? this.d2t(x, y, z, w) : $super.d2t.call(this, x, y, z, w);
  }
  k4f(x, y, z) {
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = this.l4f(x, y, z);
    return Math.sqrt(x_0);
  }
  l4f(x, y, z) {
    return x * x + y * y + z * z;
  }
}
class MVector4 {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.f4f_1 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
  }
  m4f(value) {
    this.f4f_1[0] = value;
  }
  n4f() {
    return this.f4f_1[0];
  }
  o4f(value) {
    this.f4f_1[1] = value;
  }
  p4f() {
    return this.f4f_1[1];
  }
  q4f(value) {
    this.f4f_1[2] = value;
  }
  r4f() {
    return this.f4f_1[2];
  }
  s4f(value) {
    this.f4f_1[3] = value;
  }
  t4f() {
    return this.f4f_1[3];
  }
  u4f() {
    return this.n4f() * this.n4f() + this.p4f() * this.p4f() + this.r4f() * this.r4f();
  }
  v4f() {
    // Inline function 'kotlin.math.sqrt' call
    var x = this.u4f();
    return Math.sqrt(x);
  }
  i1(index) {
    return this.f4f_1[index];
  }
  g4f(x, y, z, w) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MVector4.setTo.<anonymous>' call
    this.m4f(x);
    this.o4f(y);
    this.q4f(z);
    this.s4f(w);
    return this;
  }
  c4e(x, y, z, w) {
    return this.g4f(x, y, z, w);
  }
  i4f(x, y, z, w) {
    return this.g4f(x, y, z, w);
  }
  w4f(x, y, z) {
    return this.g4f(x, y, z, 1.0);
  }
  x4f(x, y, z) {
    return this.c4e(x, y, z, 1.0);
  }
  y4f(left, right, t) {
    // Inline function 'korlibs.math.geom.MVector4.setToFunc' call
    // Inline function 'korlibs.math.geom.MVector4.setToInterpolated.<anonymous>' call
    var tmp = interpolate_2(toRatio(t), left.i1(0), right.i1(0));
    // Inline function 'korlibs.math.geom.MVector4.setToInterpolated.<anonymous>' call
    var tmp_0 = interpolate_2(toRatio(t), left.i1(1), right.i1(1));
    // Inline function 'korlibs.math.geom.MVector4.setToInterpolated.<anonymous>' call
    var tmp_1 = interpolate_2(toRatio(t), left.i1(2), right.i1(2));
    // Inline function 'korlibs.math.geom.MVector4.setToInterpolated.<anonymous>' call
    var tmp$ret$3 = interpolate_2(toRatio(t), left.i1(3), right.i1(3));
    return this.g4f(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  z4f(scale) {
    return this.g4f(this.n4f() * scale, this.p4f() * scale, this.r4f() * scale, this.t4f() * scale);
  }
  a4g(vector) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MVector4.normalize.<anonymous>' call
    var norm = 1.0 / vector.v4f();
    this.c4e(vector.n4f() * norm, vector.p4f() * norm, vector.r4f() * norm, 1.0);
    return this;
  }
  b4g(vector, $super) {
    vector = vector === VOID ? this : vector;
    return $super === VOID ? this.a4g(vector) : $super.a4g.call(this, vector);
  }
  c4g(l, r) {
    return this.g4f(l.n4f() - r.n4f(), l.p4f() - r.p4f(), l.r4f() - r.r4f(), l.t4f() - r.t4f());
  }
  d4g(a, b) {
    return this.g4f(a.p4f() * b.r4f() - a.r4f() * b.p4f(), a.r4f() * b.n4f() - a.n4f() * b.r4f(), a.n4f() * b.p4f() - a.p4f() * b.n4f(), 1.0);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MVector4) {
      tmp_2 = almostEquals(this.n4f(), other.n4f());
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = almostEquals(this.p4f(), other.p4f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = almostEquals(this.r4f(), other.r4f());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = almostEquals(this.t4f(), other.t4f());
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_0(this.f4f_1);
  }
  toString() {
    return this.t4f() === 1.0 ? '(' + get_niceStr_0(this.n4f()) + ', ' + get_niceStr_0(this.p4f()) + ', ' + get_niceStr_0(this.r4f()) + ')' : '(' + get_niceStr_0(this.n4f()) + ', ' + get_niceStr_0(this.p4f()) + ', ' + get_niceStr_0(this.r4f()) + ', ' + get_niceStr_0(this.t4f()) + ')';
  }
}
class Companion_23 {
  constructor() {
    this.e4g_1 = 0;
    this.f4g_1 = 1;
    this.g4g_1 = 2;
    this.h4g_1 = 3;
    this.i4g_1 = 4;
    this.j4g_1 = 5;
    this.k4g_1 = 6;
    this.l4g_1 = 7;
    this.m4g_1 = 8;
    this.n4g_1 = 9;
    this.o4g_1 = 10;
    this.p4g_1 = 11;
    this.q4g_1 = 12;
    this.r4g_1 = 13;
    this.s4g_1 = 14;
    this.t4g_1 = 15;
  }
  u4g(row, column) {
    return imul(column, 4) + row | 0;
  }
}
class MMatrix4 {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.v4g_1 = new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0]);
  }
  z2k(row, column) {
    return this.f46(Companion_instance_23.u4g(row, column));
  }
  f46(index) {
    return this.v4g_1[index];
  }
  w4g(v) {
    this.v4g_1[0] = v;
  }
  l2q() {
    return this.v4g_1[0];
  }
  x4g(v) {
    this.v4g_1[4] = v;
  }
  m2q() {
    return this.v4g_1[4];
  }
  y4g(v) {
    this.v4g_1[8] = v;
  }
  o2q() {
    return this.v4g_1[8];
  }
  z4g(v) {
    this.v4g_1[12] = v;
  }
  q2q() {
    return this.v4g_1[12];
  }
  a4h(v) {
    this.v4g_1[1] = v;
  }
  n2q() {
    return this.v4g_1[1];
  }
  b4h(v) {
    this.v4g_1[5] = v;
  }
  s2q() {
    return this.v4g_1[5];
  }
  c4h(v) {
    this.v4g_1[9] = v;
  }
  v2q() {
    return this.v4g_1[9];
  }
  d4h(v) {
    this.v4g_1[13] = v;
  }
  y2q() {
    return this.v4g_1[13];
  }
  e4h(v) {
    this.v4g_1[2] = v;
  }
  p2q() {
    return this.v4g_1[2];
  }
  f4h(v) {
    this.v4g_1[6] = v;
  }
  t2q() {
    return this.v4g_1[6];
  }
  g4h(v) {
    this.v4g_1[10] = v;
  }
  w2q() {
    return this.v4g_1[10];
  }
  h4h(v) {
    this.v4g_1[14] = v;
  }
  z2q() {
    return this.v4g_1[14];
  }
  i4h(v) {
    this.v4g_1[3] = v;
  }
  r2q() {
    return this.v4g_1[3];
  }
  j4h(v) {
    this.v4g_1[7] = v;
  }
  u2q() {
    return this.v4g_1[7];
  }
  k4h(v) {
    this.v4g_1[11] = v;
  }
  x2q() {
    return this.v4g_1[11];
  }
  l4h(v) {
    this.v4g_1[15] = v;
  }
  a2r() {
    return this.v4g_1[15];
  }
  m4h(a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix4.setRows.<anonymous>' call
    this.w4g(a00);
    this.x4g(a01);
    this.y4g(a02);
    this.z4g(a03);
    this.a4h(a10);
    this.b4h(a11);
    this.c4h(a12);
    this.d4h(a13);
    this.e4h(a20);
    this.f4h(a21);
    this.g4h(a22);
    this.h4h(a23);
    this.i4h(a30);
    this.j4h(a31);
    this.k4h(a32);
    this.l4h(a33);
    return this;
  }
  n4h(a00, a10, a20, a30, a01, a11, a21, a31, a02, a12, a22, a32, a03, a13, a23, a33) {
    this.w4g(a00);
    this.x4g(a01);
    this.y4g(a02);
    this.z4g(a03);
    this.a4h(a10);
    this.b4h(a11);
    this.c4h(a12);
    this.d4h(a13);
    this.e4h(a20);
    this.f4h(a21);
    this.g4h(a22);
    this.h4h(a23);
    this.i4h(a30);
    this.j4h(a31);
    this.k4h(a32);
    this.l4h(a33);
    return this;
  }
  o4h(f, offset) {
    return this.n4h(f[offset + 0 | 0], f[offset + 1 | 0], f[offset + 2 | 0], f[offset + 3 | 0], f[offset + 4 | 0], f[offset + 5 | 0], f[offset + 6 | 0], f[offset + 7 | 0], f[offset + 8 | 0], f[offset + 9 | 0], f[offset + 10 | 0], f[offset + 11 | 0], f[offset + 12 | 0], f[offset + 13 | 0], f[offset + 14 | 0], f[offset + 15 | 0]);
  }
  p4h() {
    return 0.0 + this.r2q() * this.t2q() * this.v2q() * this.q2q() - this.p2q() * this.u2q() * this.v2q() * this.q2q() - this.r2q() * this.s2q() * this.w2q() * this.q2q() + this.n2q() * this.u2q() * this.w2q() * this.q2q() + this.p2q() * this.s2q() * this.x2q() * this.q2q() - this.n2q() * this.t2q() * this.x2q() * this.q2q() - this.r2q() * this.t2q() * this.o2q() * this.y2q() + this.p2q() * this.u2q() * this.o2q() * this.y2q() + this.r2q() * this.m2q() * this.w2q() * this.y2q() - this.l2q() * this.u2q() * this.w2q() * this.y2q() - this.p2q() * this.m2q() * this.x2q() * this.y2q() + this.l2q() * this.t2q() * this.x2q() * this.y2q() + this.r2q() * this.s2q() * this.o2q() * this.z2q() - this.n2q() * this.u2q() * this.o2q() * this.z2q() - this.r2q() * this.m2q() * this.v2q() * this.z2q() + this.l2q() * this.u2q() * this.v2q() * this.z2q() + this.n2q() * this.m2q() * this.x2q() * this.z2q() - this.l2q() * this.s2q() * this.x2q() * this.z2q() - this.p2q() * this.s2q() * this.o2q() * this.a2r() + this.n2q() * this.t2q() * this.o2q() * this.a2r() + this.p2q() * this.m2q() * this.v2q() * this.a2r() - this.l2q() * this.t2q() * this.v2q() * this.a2r() - this.n2q() * this.m2q() * this.w2q() * this.a2r() + this.l2q() * this.s2q() * this.w2q() * this.a2r();
  }
  n4d() {
    return this.n4h(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  q4h(x, y, z, w) {
    return this.m4h(1.0, 0.0, 0.0, x, 0.0, 1.0, 0.0, y, 0.0, 0.0, 1.0, z, 0.0, 0.0, 0.0, w);
  }
  r4h(x, y, z, w, $super) {
    w = w === VOID ? 1.0 : w;
    return $super === VOID ? this.q4h(x, y, z, w) : $super.q4h.call(this, x, y, z, w);
  }
  s4h(l, r) {
    return this.m4h(l.l2q() * r.l2q() + l.m2q() * r.n2q() + l.o2q() * r.p2q() + l.q2q() * r.r2q(), l.l2q() * r.m2q() + l.m2q() * r.s2q() + l.o2q() * r.t2q() + l.q2q() * r.u2q(), l.l2q() * r.o2q() + l.m2q() * r.v2q() + l.o2q() * r.w2q() + l.q2q() * r.x2q(), l.l2q() * r.q2q() + l.m2q() * r.y2q() + l.o2q() * r.z2q() + l.q2q() * r.a2r(), l.n2q() * r.l2q() + l.s2q() * r.n2q() + l.v2q() * r.p2q() + l.y2q() * r.r2q(), l.n2q() * r.m2q() + l.s2q() * r.s2q() + l.v2q() * r.t2q() + l.y2q() * r.u2q(), l.n2q() * r.o2q() + l.s2q() * r.v2q() + l.v2q() * r.w2q() + l.y2q() * r.x2q(), l.n2q() * r.q2q() + l.s2q() * r.y2q() + l.v2q() * r.z2q() + l.y2q() * r.a2r(), l.p2q() * r.l2q() + l.t2q() * r.n2q() + l.w2q() * r.p2q() + l.z2q() * r.r2q(), l.p2q() * r.m2q() + l.t2q() * r.s2q() + l.w2q() * r.t2q() + l.z2q() * r.u2q(), l.p2q() * r.o2q() + l.t2q() * r.v2q() + l.w2q() * r.w2q() + l.z2q() * r.x2q(), l.p2q() * r.q2q() + l.t2q() * r.y2q() + l.w2q() * r.z2q() + l.z2q() * r.a2r(), l.r2q() * r.l2q() + l.u2q() * r.n2q() + l.x2q() * r.p2q() + l.a2r() * r.r2q(), l.r2q() * r.m2q() + l.u2q() * r.s2q() + l.x2q() * r.t2q() + l.a2r() * r.u2q(), l.r2q() * r.o2q() + l.u2q() * r.v2q() + l.x2q() * r.w2q() + l.a2r() * r.x2q(), l.r2q() * r.q2q() + l.u2q() * r.y2q() + l.x2q() * r.z2q() + l.a2r() * r.a2r());
  }
  t4h(that) {
    var inductionVariable = 0;
    if (inductionVariable < 16)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v4g_1[n] = that.v4g_1[n];
      }
       while (inductionVariable < 16);
    return this;
  }
  u4h(left, right, bottom, top, zNear, zFar) {
    if (zNear <= 0.0 || zFar <= zNear) {
      throw Exception.f6('Error: Required zNear > 0 and zFar > zNear, but zNear ' + zNear + ', zFar ' + zFar);
    }
    if (left === right || top === bottom) {
      throw Exception.f6('Error: top,bottom and left,right must not be equal');
    }
    var zNear2 = 2.0 * zNear;
    var dx = right - left;
    var dy = top - bottom;
    var dz = zFar - zNear;
    var A = (right + left) / dx;
    var B = (top + bottom) / dy;
    var C = -1.0 * (zFar + zNear) / dz;
    var D = -2.0 * (zFar * zNear) / dz;
    return this.m4h(zNear2 / dx, 0.0, A, 0.0, 0.0, zNear2 / dy, B, 0.0, 0.0, 0.0, C, D, 0.0, 0.0, -1.0, 0.0);
  }
  v4h(fovy, aspect, zNear, zFar) {
    // Inline function 'kotlin.math.tan' call
    var x = _Angle___get_radians__impl__n00yt5(fovy) / 2.0;
    var top = Math.tan(x) * zNear;
    var bottom = -1.0 * top;
    var left = aspect * bottom;
    var right = aspect * top;
    return this.u4h(left, right, bottom, top, zNear, zFar);
  }
  equals(other) {
    var tmp;
    if (other instanceof MMatrix4) {
      tmp = contentEquals_0(this.v4g_1, other.v4g_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_0(this.v4g_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix4.toString.<anonymous>' call
    this_0.ic('Matrix3D(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ic('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.ic(', ');
            }
            var v = this.z2k(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.oh(numberToInt(v));
            else {
              this_0.qh(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.ic(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.ic(')');
    return this_0.toString();
  }
  w4h(eye, target, up) {
    var tempVec1 = new MVector4();
    var tempVec2 = new MVector4();
    var tempVec3 = new MVector4();
    var z = tempVec1.c4g(eye, target);
    if (z.u4f() === 0.0) {
      z.q4f(1.0);
    }
    z.b4g();
    var x = tempVec2.d4g(up, z);
    if (x.u4f() === 0.0) {
      // Inline function 'kotlin.math.abs' call
      var x_0 = up.r4f();
      if (Math.abs(x_0) === 1.0) {
        z.m4f(z.n4f() + 1.0E-4);
      } else {
        z.q4f(z.r4f() + 1.0E-4);
      }
      z.b4g();
      x.d4g(up, z);
    }
    x.b4g();
    var y = tempVec3.d4g(z, x);
    return this.m4h(x.n4f(), y.n4f(), z.n4f(), 0.0, x.p4f(), y.p4f(), z.p4f(), 0.0, x.r4f(), y.r4f(), z.r4f(), 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  x4h(translation, rotation, scale) {
    var rx = rotation.w2r_1;
    var ry = rotation.x2r_1;
    var rz = rotation.y2r_1;
    var rw = rotation.z2r_1;
    var xt = rx + rx;
    var yt = ry + ry;
    var zt = rz + rz;
    var xx = rx * xt;
    var xy = rx * yt;
    var xz = rx * zt;
    var yy = ry * yt;
    var yz = ry * zt;
    var zz = rz * zt;
    var wx = rw * xt;
    var wy = rw * yt;
    var wz = rw * zt;
    return this.m4h((1 - (yy + zz)) * scale.n4f(), (xy - wz) * scale.p4f(), (xz + wy) * scale.r4f(), translation.n4f(), (xy + wz) * scale.n4f(), (1 - (xx + zz)) * scale.p4f(), (yz - wx) * scale.r4f(), translation.p4f(), (xz - wy) * scale.n4f(), (yz + wx) * scale.p4f(), (1 - (xx + yy)) * scale.r4f(), translation.r4f(), 0.0, 0.0, 0.0, 1.0);
  }
  y4h(position, rotation, scale) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix4.getTRS.<anonymous>' call
    var tempMat1 = new MMatrix4();
    var det = this.p4h();
    position.g4f(this.q2q(), this.y2q(), this.z2q(), 1.0);
    var tmp = Companion_instance_22.k4f(this.l2q(), this.n2q(), this.p2q());
    // Inline function 'kotlin.math.sign' call
    var tmp$ret$0 = sign(det);
    scale.g4f(tmp * tmp$ret$0, Companion_instance_22.k4f(this.m2q(), this.s2q(), this.t2q()), Companion_instance_22.k4f(this.o2q(), this.v2q(), this.w2q()), 1.0);
    var invSX = 1.0 / scale.n4f();
    var invSY = 1.0 / scale.p4f();
    var invSZ = 1.0 / scale.r4f();
    rotation.n3a(Companion_getInstance_8().h2s(get_immutable_1(tempMat1.m4h(this.l2q() * invSX, this.m2q() * invSY, this.o2q() * invSZ, this.q2q(), this.n2q() * invSX, this.s2q() * invSY, this.v2q() * invSZ, this.y2q(), this.p2q() * invSX, this.t2q() * invSY, this.w2q() * invSZ, this.z2q(), this.r2q(), this.u2q(), this.x2q(), this.a2r()))));
    return this;
  }
  z4h(m) {
    var target = this;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix4.invert.<anonymous>' call
    var t11 = m.v2q() * m.z2q() * m.u2q() - m.y2q() * m.w2q() * m.u2q() + m.y2q() * m.t2q() * m.x2q() - m.s2q() * m.z2q() * m.x2q() - m.v2q() * m.t2q() * m.a2r() + m.s2q() * m.w2q() * m.a2r();
    var t12 = m.q2q() * m.w2q() * m.u2q() - m.o2q() * m.z2q() * m.u2q() - m.q2q() * m.t2q() * m.x2q() + m.m2q() * m.z2q() * m.x2q() + m.o2q() * m.t2q() * m.a2r() - m.m2q() * m.w2q() * m.a2r();
    var t13 = m.o2q() * m.y2q() * m.u2q() - m.q2q() * m.v2q() * m.u2q() + m.q2q() * m.s2q() * m.x2q() - m.m2q() * m.y2q() * m.x2q() - m.o2q() * m.s2q() * m.a2r() + m.m2q() * m.v2q() * m.a2r();
    var t14 = m.q2q() * m.v2q() * m.t2q() - m.o2q() * m.y2q() * m.t2q() - m.q2q() * m.s2q() * m.w2q() + m.m2q() * m.y2q() * m.w2q() + m.o2q() * m.s2q() * m.z2q() - m.m2q() * m.v2q() * m.z2q();
    var det = m.l2q() * t11 + m.n2q() * t12 + m.p2q() * t13 + m.r2q() * t14;
    if (det === 0.0) {
      println("Matrix doesn't have inverse");
      return m.n4d();
    }
    var detInv = 1 / det;
    return target.m4h(t11 * detInv, t12 * detInv, t13 * detInv, t14 * detInv, (m.y2q() * m.w2q() * m.r2q() - m.v2q() * m.z2q() * m.r2q() - m.y2q() * m.p2q() * m.x2q() + m.n2q() * m.z2q() * m.x2q() + m.v2q() * m.p2q() * m.a2r() - m.n2q() * m.w2q() * m.a2r()) * detInv, (m.o2q() * m.z2q() * m.r2q() - m.q2q() * m.w2q() * m.r2q() + m.q2q() * m.p2q() * m.x2q() - m.l2q() * m.z2q() * m.x2q() - m.o2q() * m.p2q() * m.a2r() + m.l2q() * m.w2q() * m.a2r()) * detInv, (m.q2q() * m.v2q() * m.r2q() - m.o2q() * m.y2q() * m.r2q() - m.q2q() * m.n2q() * m.x2q() + m.l2q() * m.y2q() * m.x2q() + m.o2q() * m.n2q() * m.a2r() - m.l2q() * m.v2q() * m.a2r()) * detInv, (m.o2q() * m.y2q() * m.p2q() - m.q2q() * m.v2q() * m.p2q() + m.q2q() * m.n2q() * m.w2q() - m.l2q() * m.y2q() * m.w2q() - m.o2q() * m.n2q() * m.z2q() + m.l2q() * m.v2q() * m.z2q()) * detInv, (m.s2q() * m.z2q() * m.r2q() - m.y2q() * m.t2q() * m.r2q() + m.y2q() * m.p2q() * m.u2q() - m.n2q() * m.z2q() * m.u2q() - m.s2q() * m.p2q() * m.a2r() + m.n2q() * m.t2q() * m.a2r()) * detInv, (m.q2q() * m.t2q() * m.r2q() - m.m2q() * m.z2q() * m.r2q() - m.q2q() * m.p2q() * m.u2q() + m.l2q() * m.z2q() * m.u2q() + m.m2q() * m.p2q() * m.a2r() - m.l2q() * m.t2q() * m.a2r()) * detInv, (m.m2q() * m.y2q() * m.r2q() - m.q2q() * m.s2q() * m.r2q() + m.q2q() * m.n2q() * m.u2q() - m.l2q() * m.y2q() * m.u2q() - m.m2q() * m.n2q() * m.a2r() + m.l2q() * m.s2q() * m.a2r()) * detInv, (m.q2q() * m.s2q() * m.p2q() - m.m2q() * m.y2q() * m.p2q() - m.q2q() * m.n2q() * m.t2q() + m.l2q() * m.y2q() * m.t2q() + m.m2q() * m.n2q() * m.z2q() - m.l2q() * m.s2q() * m.z2q()) * detInv, (m.v2q() * m.t2q() * m.r2q() - m.s2q() * m.w2q() * m.r2q() - m.v2q() * m.p2q() * m.u2q() + m.n2q() * m.w2q() * m.u2q() + m.s2q() * m.p2q() * m.x2q() - m.n2q() * m.t2q() * m.x2q()) * detInv, (m.m2q() * m.w2q() * m.r2q() - m.o2q() * m.t2q() * m.r2q() + m.o2q() * m.p2q() * m.u2q() - m.l2q() * m.w2q() * m.u2q() - m.m2q() * m.p2q() * m.x2q() + m.l2q() * m.t2q() * m.x2q()) * detInv, (m.o2q() * m.s2q() * m.r2q() - m.m2q() * m.v2q() * m.r2q() - m.o2q() * m.n2q() * m.u2q() + m.l2q() * m.v2q() * m.u2q() + m.m2q() * m.n2q() * m.x2q() - m.l2q() * m.s2q() * m.x2q()) * detInv, (m.m2q() * m.v2q() * m.p2q() - m.o2q() * m.s2q() * m.p2q() + m.o2q() * m.n2q() * m.t2q() - m.l2q() * m.v2q() * m.t2q() - m.m2q() * m.n2q() * m.w2q() + m.l2q() * m.s2q() * m.w2q()) * detInv);
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = MBoundsBuilder$Companion$POOL$lambda;
    tmp.g4i_1 = ConcurrentPool.s39(tmp_0, VOID, MBoundsBuilder$Companion$POOL$lambda_0);
    this.h4i_1 = -Infinity;
    this.i4i_1 = Infinity;
  }
}
class MBoundsBuilder {
  constructor() {
    Companion_getInstance_34();
    this.a4i_1 = Companion_getInstance_30().l2m();
    this.b4i_1 = 0;
    this.c4i_1 = Companion_getInstance_34().i4i_1;
    this.d4i_1 = Companion_getInstance_34().h4i_1;
    this.e4i_1 = Companion_getInstance_34().i4i_1;
    this.f4i_1 = Companion_getInstance_34().h4i_1;
  }
  z33() {
    this.c4i_1 = Companion_getInstance_34().i4i_1;
    this.d4i_1 = Companion_getInstance_34().h4i_1;
    this.e4i_1 = Companion_getInstance_34().i4i_1;
    this.f4i_1 = Companion_getInstance_34().h4i_1;
    this.b4i_1 = 0;
  }
  r3e(x, y) {
    if (x < this.c4i_1)
      this.c4i_1 = x;
    if (x > this.d4i_1)
      this.d4i_1 = x;
    if (y < this.e4i_1)
      this.e4i_1 = y;
    if (y > this.f4i_1)
      this.f4i_1 = y;
    this.b4i_1 = this.b4i_1 + 1 | 0;
    return this;
  }
  j4i(x, y) {
    return this.r3e(x, y);
  }
  k4i(rect) {
    if (rect.m4e()) {
      this.l4i(rect);
    }
    return this;
  }
  l4i(rect) {
    if (rect == null)
      return this;
    this.r3e(rect.p2i(), rect.r2i());
    this.r3e(rect.q2i(), rect.s2i());
    return this;
  }
  m4i(out) {
    return this.b4i_1 === 0 ? null : out.v4e(this.c4i_1, this.e4i_1, this.d4i_1, this.f4i_1);
  }
  n4i(out) {
    if (this.m4i(out) == null) {
      out.w4e(0, 0, 0, 0);
    }
    return out;
  }
  o4i(out, $super) {
    out = out === VOID ? Companion_getInstance_30().l2m() : out;
    return $super === VOID ? this.n4i(out) : $super.n4i.call(this, out);
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  xz(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  xz(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  xz(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  xz(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  xz(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.b4j_1 = EasingCubic.i4j(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  xz(it) {
    return this.b4j_1.xz(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.l4j_1 = EasingCubic.i4j(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  xz(it) {
    return this.l4j_1.xz(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.o4j_1 = EasingCubic.i4j(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  xz(it) {
    return this.o4j_1.xz(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.r4j_1 = EasingCubic.i4j(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  xz(it) {
    return this.r4j_1.xz(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  xz(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  xz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  xz(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  xz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  xz(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().xz(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  xz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.xz(it * 2.0) : 0.5 * end.xz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  xz(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  xz(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  xz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  xz(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  xz(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  xz(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  xz(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static i4l(x, y) {
    var $this = createThis(this);
    $this.g4l_1 = x;
    $this.h4l_1 = y;
    return $this;
  }
  static j4l(x, y) {
    return this.i4l(x, y);
  }
  c2t(that) {
    return P.i4l(this.g4l_1 * that, this.h4l_1 * that);
  }
  k4l(that) {
    return P.i4l(this.g4l_1 + that.g4l_1, this.h4l_1 + that.h4l_1);
  }
  toString() {
    return 'P(x=' + this.g4l_1 + ', y=' + this.h4l_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.g4l_1);
    result = imul(result, 31) + getNumberHashCode(this.h4l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.g4l_1, tmp0_other_with_cast.g4l_1))
      return false;
    if (!equals(this.h4l_1, tmp0_other_with_cast.h4l_1))
      return false;
    return true;
  }
}
class EasingCubic {
  static i4j(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    var $this = createThis(this);
    $this.c4j_1 = x1;
    $this.d4j_1 = y1;
    $this.e4j_1 = x2;
    $this.f4j_1 = y2;
    $this.g4j_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h4j_1 = [P.j4l(0.0, 0.0), P.j4l(clamp_1($this.c4j_1, 0.0, 1.0), $this.d4j_1), P.j4l(clamp_1($this.e4j_1, 0.0, 1.0), $this.f4j_1), P.j4l(1.0, 1.0)];
    return $this;
  }
  static l4l(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    return this.i4j(x1, y1, x2, y2, name);
  }
  toString() {
    var tmp0_elvis_lhs = this.g4j_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.c4j_1 + ', ' + this.d4j_1 + ', ' + this.e4j_1 + ', ' + this.f4j_1 + ')' : tmp0_elvis_lhs;
  }
  xz(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.g4l_1;
        lastY = res.h4l_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function get(_this__u8e3s4, l, r) {
  return interpolate(toRatio(nextDoubleInclusive(_this__u8e3s4)), l, r);
}
function get_0(_this__u8e3s4, rectangle) {
  return Vector2D.k2h(get_1(_this__u8e3s4, rectangle.p2i(), rectangle.q2i()), get_1(_this__u8e3s4, rectangle.r2i(), rectangle.s2i()));
}
function nextDoubleInclusive(_this__u8e3s4) {
  return _this__u8e3s4.t1(16777217) / 16777216;
}
function get_1(_this__u8e3s4, min, max) {
  return min + _this__u8e3s4.to() * (max - min);
}
function insertAt($this, n, min, max) {
  $this.d3s_1.w31(n, min);
  $this.e3s_1.w31(n, max);
}
function removeAt($this, n, count) {
  $this.d3s_1.y31(n, count);
  $this.e3s_1.y31(n, count);
}
function toVectorPath(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
  // Inline function 'kotlin.apply' call
  var this_0 = new VectorPath();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.toVectorPath.<anonymous>' call
  this_0.m3s(_this__u8e3s4.m2j_1, _this__u8e3s4.n2j_1);
  return this_0;
}
function toStrokePointsList(_this__u8e3s4, info, mode, generateDebug, forceClosed) {
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  return toStrokePointsList_0(_this__u8e3s4, info.n3s_1, info.s3s_1, info.q3s_1, info.r3s_1, info.t3s_1, mode, info.u3s_1, info.v3s_1, generateDebug, forceClosed);
}
var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
var StrokePointsMode_NON_SCALABLE_POS_instance;
var StrokePointsMode_entriesInitialized;
function StrokePointsMode_initEntries() {
  if (StrokePointsMode_entriesInitialized)
    return Unit_instance;
  StrokePointsMode_entriesInitialized = true;
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance = new StrokePointsMode('SCALABLE_POS_NORMAL_WIDTH', 0);
  StrokePointsMode_NON_SCALABLE_POS_instance = new StrokePointsMode('NON_SCALABLE_POS', 1);
}
function toStrokePointsList_0(_this__u8e3s4, width, join, startCap, endCap, miterLimit, mode, lineDash, lineDashOffset, generateDebug, forceClosed) {
  join = join === VOID ? LineJoin_MITER_getInstance() : join;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
  miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.m1();
    var tmp0_iterator = _this__u8e3s4.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
      var list = toDashes(element, lineDash.i13(), lineDashOffset);
      addAll(destination, list);
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  var curvesList = tmp;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator_0 = curvesList.f1();
  while (tmp0_iterator_0.g1()) {
    var item = tmp0_iterator_0.h1();
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new StrokePointsBuilder(width / 2.0, mode, generateDebug);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>.<anonymous>' call
    this_0.d3t(item, join, startCap, endCap, miterLimit, forceClosed);
    destination_0.f(this_0);
  }
  return destination_0;
}
function StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
}
function StrokePointsMode_NON_SCALABLE_POS_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_NON_SCALABLE_POS_instance;
}
function get_isConvex(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = isConvex$delegate;
    var property = isConvex$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var isConvex$delegate;
function Curves$contiguous$delegate$lambda(this$0) {
  return function () {
    var inductionVariable = 1;
    var last = this$0.y3t_1.j1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.y3t_1.i1(n - 1 | 0);
        var next = this$0.y3t_1.i1(n);
        if (!curr.e3u_1.w34().vz(next.e3u_1.v34()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return function () {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.y3t_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.math.geom.bezier.Curves.infos$delegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$0 = new CurveInfo(index_0, item, start, pos, item.v3u());
      destination.f(tmp$ret$0);
    }
    return destination;
  };
}
function Curves$length$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.w3u().f1();
    while (_iterator__ex2g4s.g1()) {
      var element = _iterator__ex2g4s.h1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Curves.length$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$findInfo$lambda($pos) {
  return function (it) {
    return it.k13($pos) ? 0 : it.t3u_1 < $pos ? -1 : 1;
  };
}
function Curves$ratioFromLength$lambda($length) {
  return function (it) {
    return it.t3u_1 < $length ? -1 : it.s3u_1 > $length ? 1 : 0;
  };
}
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return function () {
    return combineSmallDistinctSorted(Companion_getInstance_9(), this$0.j3v_1, this$0.k3v_1);
  };
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.j3v_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.k3v_1, new Float64Array([1.0])]);
  };
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.i2h_1 - o.i2h_1;
  var dy1 = v1.j2h_1 - o.j2h_1;
  var dx2 = v2.i2h_1 - o.i2h_1;
  var dy2 = v2.j2h_1 - o.j2h_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.j1() - 1 | 0;
  if (equals(t, Companion_getInstance().f10_1))
    return p.i1(0);
  if (equals(t, Companion_getInstance().i10_1))
    return p.i1(order);
  if (order === 0)
    return p.i1(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance().i10_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.i1(0);
      var this_1 = Vector2D.k2h(this_0.i2h_1 * mt, this_0.j2h_1 * mt);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.i1(1);
      var scale = Ratio__toDouble_impl_o7epze(t);
      var that = Vector2D.k2h(this_2.i2h_1 * scale, this_2.j2h_1 * scale);
      tmp = Vector2D.k2h(this_1.i2h_1 + that.i2h_1, this_1.j2h_1 + that.j2h_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.i1(0);
      var this_4 = Vector2D.k2h(this_3.i2h_1 * a, this_3.j2h_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.i1(1);
      var that_0 = Vector2D.k2h(this_5.i2h_1 * b, this_5.j2h_1 * b);
      var this_6 = Vector2D.k2h(this_4.i2h_1 + that_0.i2h_1, this_4.j2h_1 + that_0.j2h_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.i1(2);
      var that_1 = Vector2D.k2h(this_7.i2h_1 * c, this_7.j2h_1 * c);
      tmp = Vector2D.k2h(this_6.i2h_1 + that_1.i2h_1, this_6.j2h_1 + that_1.j2h_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_8 = p.i1(0);
      var this_9 = Vector2D.k2h(this_8.i2h_1 * a_0, this_8.j2h_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_10 = p.i1(1);
      var that_2 = Vector2D.k2h(this_10.i2h_1 * b_0, this_10.j2h_1 * b_0);
      var this_11 = Vector2D.k2h(this_9.i2h_1 + that_2.i2h_1, this_9.j2h_1 + that_2.j2h_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_12 = p.i1(2);
      var that_3 = Vector2D.k2h(this_12.i2h_1 * c_0, this_12.j2h_1 * c_0);
      var this_13 = Vector2D.k2h(this_11.i2h_1 + that_3.i2h_1, this_11.j2h_1 + that_3.j2h_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_14 = p.i1(3);
      var that_4 = Vector2D.k2h(this_14.i2h_1 * d, this_14.j2h_1 * d);
      tmp = Vector2D.k2h(this_13.i2h_1 + that_4.i2h_1, this_13.j2h_1 + that_4.j2h_1);
      break;
    default:
      var reason = 'higher order curves';
      throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.m1();
  var current = points;
  while (current.j1() >= 2) {
    var new_0 = new PointArrayList(current.j1() - 1 | 0);
    var c = current.j1() - 1 | 0;
    var inductionVariable = 0;
    var last = current.j1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var this_0 = current.i1(n + 1 | 0);
        var that = current.i1(n);
        var this_1 = Vector2D.k2h(this_0.i2h_1 - that.i2h_1, this_0.j2h_1 - that.j2h_1);
        var tmp$ret$2 = Vector2D.k2h(this_1.i2h_1 * c, this_1.j2h_1 * c);
        new_0.s3e(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.f(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  var p1 = line.e2l_1;
  var p2 = line.f2l_1;
  var tx = p1.i2h_1;
  var ty = p1.j2h_1;
  // Inline function 'kotlin.math.atan2' call
  var y = p2.j2h_1 - ty;
  var x = p2.i2h_1 - tx;
  var a = -Math.atan2(y, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.j1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.Companion.align.<anonymous>' call
      var destruct = points.i1(n);
      var x_0 = destruct.km();
      var y_0 = destruct.lm();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y_0 - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y_0 - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$4 = Math.cos(a);
      out.r3e(tmp_2, tmp_4 + tmp_5 * tmp$ret$4);
    }
     while (inductionVariable < last);
  return out;
}
function align$default($this, points, line, out, $super) {
  out = out === VOID ? new PointArrayList() : out;
  return align($this, points, line, out);
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01$default($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01$default($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01$default($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01$default($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.s3v_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function doubleArrayOfValid01$default($this, v1, v2, v3, $super) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  return doubleArrayOfValid01($this, v1, v2, v3);
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.c32(a.length + b.length | 0);
  out.g32(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    // Inline function 'korlibs.math.geom.bezier.Companion.combineSmallDistinctSorted.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.k13(it)) {
      out.t2d(it);
    }
  }
  sort(out);
  return out.i13();
}
function _get_aligned__7fjidv($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.f3u_1;
  aligned$factory();
  return this_0.b2();
}
function _getBoundingBox($this, m) {
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.t3v().u3v(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        // Inline function 'korlibs.math.geom.bezier.Bezier._getBoundingBox.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.v3v(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_3().g2t(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out.z3v_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.w3v_1 = Vector2D.k2h(tmp_0, aY + tmp$ret$3);
  out.x3v_1 = t;
  out.y3v_1 = Companion_getInstance_1().o2w(out.w3v_1.i2h_1, out.w3v_1.j2h_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_9() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return function () {
    return align$default(Companion_getInstance_9(), this$0.e3u_1, Line2D.g2l(this$0.e3u_1.v34(), this$0.e3u_1.w34()));
  };
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return function () {
    return derive(Companion_getInstance_9(), this$0.e3u_1);
  };
}
function Bezier$direction$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_2();
    var p0 = this$0.e3u_1.i1(0);
    var p1 = this$0.e3u_1.i1(this$0.p3u());
    var up = this$0.e3u_1.i1(1);
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = p0.i2h_1;
    var y0 = p0.j2h_1;
    var x1 = p1.i2h_1;
    var y1 = p1.j2h_1;
    var tmp$ret$1 = Angle_between(x0, y0, x1, y1, up);
    return new Angle(tmp$ret$1);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.h3w());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>' call
      var tmp = Companion_getInstance_9();
      // Inline function 'korlibs.datastructure.mapDouble' call
      var this_1 = this$0.i3w().i1(0).k3e(item);
      // Inline function 'kotlin.also' call
      var this_2 = new Float64Array(this_1.length);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
      var inductionVariable = 0;
      var last = this_1.length;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>.<anonymous>' call
          this_2[n] = this_1[n];
        }
         while (inductionVariable < last);
      var out = droots(tmp, this_2);
      if (this$0.p3u() === 3)
        out = combineSmallDistinctSorted(Companion_getInstance_9(), out, droots(Companion_getInstance_9(), this$0.i3w().i1(1).k3e(item)));
      var tmp$ret$3 = out;
      destination.f(tmp$ret$3);
    }
    var out_0 = destination;
    return new Extrema(out_0.i1(0), out_0.i1(1));
  };
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return function () {
    return outerCircle(this$0.j3w());
  };
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return function () {
    return _getBoundingBox(this$0, Companion_getInstance_4().j2m_1);
  };
}
function Bezier$length$delegate$lambda(this$0) {
  return function () {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_9().o3v_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_9().o3v_1[i] + z);
        var temp = this$0.k3w(t);
        sum = sum + Companion_getInstance_9().p3v_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$lut$delegate$lambda(this$0) {
  return function () {
    return this$0.l3w();
  };
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this$0.e3u_1.i1(this$0.p3u());
    var that = this$0.e3u_1.i1(0);
    var baseLength = Vector2D.k2h(this_0.i2h_1 - that.i2h_1, this_0.j2h_1 - that.j2h_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = until(0, _get_aligned__7fjidv(this$0).j1()).f1();
    while (_iterator__ex2g4s.g1()) {
      var element = _iterator__ex2g4s.h1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Bezier.isLinear$delegate.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = _get_aligned__7fjidv(this$0).w2k(element);
      sum = tmp + Math.abs(this_1);
    }
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.p3u() === 3) {
      var a1 = angle(Companion_getInstance_9(), this$0.e3u_1.i1(0), this$0.e3u_1.i1(3), this$0.e3u_1.i1(1));
      var a2 = angle(Companion_getInstance_9(), this$0.e3u_1.i1(0), this$0.e3u_1.i1(3), this$0.e3u_1.i1(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.n3t(Companion_getInstance().f10_1);
    var n2 = this$0.n3t(Companion_getInstance().i10_1);
    var s = n1.i2h_1 * n2.i2h_1 + n1.j2h_1 * n2.j2h_1;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.acos' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.v3e(points, index);
  }
  return Bezier.r3w(p);
}
var Companion_instance_0;
function Companion_getInstance_10() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance().f10_1, Companion_getInstance().i10_1, $this.e3v_1, $this.f3v_1);
  var rt1 = left ? $this.e3v_1 : rt;
  var rt2 = left ? rt : $this.f3v_1;
  var tmp;
  if ($this.d3v_1.p3u() < 2) {
    var p1 = $this.l3t(rt1);
    var p2 = $this.l3t(rt2);
    tmp = Bezier.o3w(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_10().v3x_1 : Companion_getInstance_10().w3x_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_10(), ensureNotNull(indices.i1($this.d3v_1.p3u())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.s3x(curve, rt1, rt2, $this.g3v_1);
}
function _splitLeft($this, t, hull) {
  return _split($this, t, hull, true);
}
function _splitLeft$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.d3v_1.r3x(t) : hull;
  return _splitLeft($this, t, hull);
}
function _splitRight($this, t, hull) {
  return _split($this, t, hull, false);
}
function _splitRight$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.d3v_1.r3x(t) : hull;
  return _splitRight($this, t, hull);
}
function estimateAt($this, values, value, out) {
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.x3x(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.x3x(out, 0, 0.0);
  if (index >= (values.j1() - 1 | 0))
    return $this.x3x(out, $this.b3x_1.j1() - 1 | 0, 0.0);
  var ratio0 = values.i1(index);
  var ratio1 = values.i1(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.x3x(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return function (it) {
    return '' + this$0.c3x_1.i1(it) + ',len=' + this$0.y3x().i1(it) + ': ' + this$0.b3x_1.i1(it).toString();
  };
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.y3t_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.j1()) {
    // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.i1(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.n3x().length === 0))
      return null;
    var points = bezier.e3u_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.j1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>.<anonymous>' call
        var p = points.i1(n_0);
        if (out.a1() || !out.w34().s2s(p, epsilon)) {
          out.s3e(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.w34().s2s(out.v34(), epsilon)) {
    out.w3e(out.j1() - 1 | 0);
  }
  return out;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.j1()) {
    // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.i1(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.y3t_1;
      var n_0 = 0;
      while (n_0 < this_0.j1()) {
        // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.i1(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.z3t_1) {
        out.u6();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        throw NotImplementedError.oe();
      }
    }
  }
  return out;
}
function toVectorPath_1(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath_0(listOf(_this__u8e3s4), out);
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.o3w(Vector2D.k2h(_this__u8e3s4.l2l(), _this__u8e3s4.m2l()), Vector2D.k2h(_this__u8e3s4.n2l(), _this__u8e3s4.o2l()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.toDashes.<anonymous>' call
      if (!(element <= 0.0)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!tmp$ret$1) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.m5(toString(message));
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.m1();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic_0(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.b3v(current, current + len);
      out.f(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.e3u_1;
  if (first._v) {
    $out.e3y(points.v34());
    first._v = false;
  }
  switch (bezier.p3u()) {
    case 1:
      $out.g3y(points.i1(1));
      break;
    case 2:
      $out.h3y(points.i1(1), points.i1(2));
      break;
    case 3:
      $out.j3y(points.i1(1), points.i1(2), points.i1(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.oe();
  }
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.a3u_1 || Convex_instance.w3y($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function isConvex$factory() {
  return getPropertyCallableRef('isConvex', 1, KProperty1, function (receiver) {
    return get_isConvex(receiver);
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.w3u();
  }, null);
}
function length$factory() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function aligned$factory() {
  return getPropertyCallableRef('aligned', 1, KProperty1, function (receiver) {
    return _get_aligned__7fjidv(receiver);
  }, null);
}
function dpoints$factory() {
  return getPropertyCallableRef('dpoints', 1, KProperty1, function (receiver) {
    return receiver.i3w();
  }, null);
}
function extrema$factory() {
  return getPropertyCallableRef('extrema', 1, KProperty1, function (receiver) {
    return receiver.t3v();
  }, null);
}
function outerCircle$factory() {
  return getPropertyCallableRef('outerCircle', 1, KProperty1, function (receiver) {
    return receiver.v3w();
  }, null);
}
function boundingBox$factory() {
  return getPropertyCallableRef('boundingBox', 1, KProperty1, function (receiver) {
    return receiver.j3w();
  }, null);
}
function length$factory_0() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function lut$factory() {
  return getPropertyCallableRef('lut', 1, KProperty1, function (receiver) {
    return receiver.w3w();
  }, null);
}
function xt01$factory() {
  return getPropertyCallableRef('xt01', 1, KProperty1, function (receiver) {
    return receiver.b3w();
  }, null);
}
function yt01$factory() {
  return getPropertyCallableRef('yt01', 1, KProperty1, function (receiver) {
    return receiver.c3w();
  }, null);
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = isConvex$delegate$lambda;
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.t13_1 = transform;
    isConvex$delegate = this_0;
  }
}
function packSeveral$emit(currentPairs, out, maxWidth, maxHeight, currentBinPacker) {
  if (currentPairs._v.a1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var element = new Result(maxWidth, maxHeight, toList(currentPairs._v));
  out.f(element);
  currentPairs._v = FastArrayList.g14();
  currentBinPacker._v = Companion_instance_1.y3y(maxWidth, maxHeight);
}
function BinPacker$Companion$packSeveral$lambda($getSize) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.math.geom.binpack.Companion.packSeveral.<anonymous>' call
    var tmp = $getSize(b).x2u();
    // Inline function 'korlibs.math.geom.binpack.Companion.packSeveral.<anonymous>' call
    var tmp$ret$1 = $getSize(a).x2u();
    return compareValues(tmp, tmp$ret$1);
  };
}
var Companion_instance_1;
function Companion_getInstance_11() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_3().l2m();
  var _iterator__ex2g4s = $this.g3z_1.f1();
  while (_iterator__ex2g4s.g1()) {
    var r = _iterator__ex2g4s.h1();
    if (r.k2i_1 >= width && r.l2i_1 >= height) {
      areaFit = r.k2i_1 * r.l2i_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.i2i_1, r.j2i_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.p2i() >= freeNode.q2i() || usedNode.q2i() <= freeNode.i2i_1 || usedNode.r2i() >= freeNode.s2i() || usedNode.s2i() <= freeNode.r2i()) {
    return false;
  }
  if (usedNode.i2i_1 < freeNode.q2i() && usedNode.q2i() > freeNode.i2i_1) {
    if (usedNode.j2i_1 > freeNode.j2i_1 && usedNode.j2i_1 < freeNode.s2i()) {
      newNode = freeNode.i2u(VOID, VOID, VOID, usedNode.j2i_1 - freeNode.j2i_1);
      $this.g3z_1.f(newNode);
    }
    if (usedNode.s2i() < freeNode.s2i()) {
      newNode = freeNode.i2u(VOID, usedNode.s2i(), VOID, freeNode.s2i() - usedNode.s2i());
      $this.g3z_1.f(newNode);
    }
  }
  if (usedNode.j2i_1 < freeNode.s2i() && usedNode.s2i() > freeNode.j2i_1) {
    if (usedNode.i2i_1 > freeNode.i2i_1 && usedNode.i2i_1 < freeNode.q2i()) {
      newNode = freeNode.i2u(VOID, VOID, usedNode.i2i_1 - freeNode.i2i_1);
      $this.g3z_1.f(newNode);
    }
    if (usedNode.q2i() < freeNode.q2i()) {
      newNode = freeNode.i2u(usedNode.q2i(), VOID, freeNode.q2i() - usedNode.q2i());
      $this.g3z_1.f(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.g3z_1.j1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.g3z_1.i1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.g3z_1.i1(j);
      if (Companion_getInstance_3().i2t(tmpRect, tmpRect2)) {
        $this.g3z_1.q3(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_3().i2t(tmpRect2, tmpRect)) {
        $this.g3z_1.q3(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_12() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
function toBVH(_this__u8e3s4, out) {
  out = out === VOID ? BVHIntervals.e3d(2) : out;
  out.t3d(_this__u8e3s4.l2s_1.i2h_1, _this__u8e3s4.m2s_1.i2h_1, _this__u8e3s4.l2s_1.j2h_1, _this__u8e3s4.m2s_1.j2h_1);
  return _BVHRay___init__impl__rrqut(out);
}
function toBVH_0(_this__u8e3s4, out) {
  out = out === VOID ? BVHIntervals.e3d(2) : out;
  out.t3d(_this__u8e3s4.i2i_1, _this__u8e3s4.k2i_1, _this__u8e3s4.j2i_1, _this__u8e3s4.l2i_1);
  return _BVHRect___init__impl__pawpsv(out);
}
function toRectangle(_this__u8e3s4) {
  return new Rectangle(BVHRect__min_impl_5ss93n(_this__u8e3s4, 0), BVHRect__min_impl_5ss93n(_this__u8e3s4, 1), BVHRect__size_impl_axghd8(_this__u8e3s4, 0), BVHRect__size_impl_axghd8(_this__u8e3s4, 1));
}
function get_cachedPoints(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = cachedPoints$delegate;
    var property = cachedPoints$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cachedPoints$delegate;
function getPoints2(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.i2l();
  var l = Vector2D.i2l();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.m3y_1;
  var n_0 = 0;
  while (n_0 < this_0.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2h(tmp, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.s3e(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2h(tmp_0, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.s3e(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2h(tmp_1, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2h(tmp_2, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_7));
        var sum = Companion_getInstance_1().n2w(l, c) + Companion_getInstance_1().n2w(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.i2l()};
        var prevPos = {_v: Vector2D.i2l()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance().f10_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_9().e3w(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_9().e3w(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.s3e(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.k2h(tmp_3, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.k2h(tmp_4, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.k2h(tmp_5, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance_1().n2w(l, c0) + Companion_getInstance_1().n2w(c0, c1) + Companion_getInstance_1().n2w(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.i2l()};
        var prevPos_0 = {_v: Vector2D.i2l()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance().f10_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.s3e(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        var p = i;
        out.s3e(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  return out;
}
function CircleShape2D$_init_$lambda_c1uoso(it) {
  return toVectorPath(it);
}
function BaseShape2D$cachedPath$delegate$lambda(this$0) {
  return function () {
    return this$0.l40_1(this$0.k40_1);
  };
}
function getPoints2List(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.m1();
  var current = {_v: new PointArrayList()};
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.i2l();
  var l = Vector2D.i2l();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.m3y_1;
  var n_0 = 0;
  while (n_0 < this_0.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2h(tmp, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (true) {
          getPoints2List$flush(current, out);
        }

        current._v.s3e(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2h(tmp_0, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.s3e(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2h(tmp_1, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2h(tmp_2, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_7));
        var sum = Companion_getInstance_1().n2w(l, c) + Companion_getInstance_1().n2w(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.i2l()};
        var prevPos = {_v: Vector2D.i2l()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance().f10_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_9().e3w(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_9().e3w(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.s3e(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.k2h(tmp_3, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.k2h(tmp_4, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.k2h(tmp_5, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance_1().n2w(l, c0) + Companion_getInstance_1().n2w(c0, c1) + Companion_getInstance_1().n2w(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.i2l()};
        var prevPos_0 = {_v: Vector2D.i2l()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance().f10_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_9().d3w(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.s3e(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        var p = i;
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.s3e(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  getPoints2List$flush(current, out);
  return out;
}
function toShape2D(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return new CircleShape2D(_this__u8e3s4);
}
function getPoints2List$flush(current, out) {
  if (!current._v.y2k())
    return Unit_instance;
  out.f(current._v);
  current._v = new PointArrayList();
}
function cachedPoints$delegate$lambda($this$PropertyThis) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return getPoints2($this$PropertyThis);
}
function cachedPoints$factory() {
  return getPropertyCallableRef('cachedPoints', 1, KProperty1, function (receiver) {
    return get_cachedPoints(receiver);
  }, null);
}
var properties_initialized__MathGeom_shape_kt_lonmli;
function _init_properties__MathGeom_shape_kt__uqeev8() {
  if (!properties_initialized__MathGeom_shape_kt_lonmli) {
    properties_initialized__MathGeom_shape_kt_lonmli = true;
    cachedPoints$delegate = new PropertyThis(VOID, cachedPoints$delegate$lambda);
  }
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_3;
function Companion_getInstance_13() {
  SliceRotation_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_13();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_13().i1(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert(insert_0(0, rotation.v3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_14().t40_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__flippedX_impl_m25zo9($this) {
  var tmp33_flipX = !_SliceOrientation___get_flipX__impl__lgb7bx($this);
  var tmp34_rotation = _SliceOrientation___get_rotation__impl__m65r0o($this).s40();
  return _SliceOrientation___init__impl__ewylib_0(tmp34_rotation, tmp33_flipX);
}
function SliceOrientation__flippedY_impl_mj7m2g($this) {
  var tmp35_flipX = !_SliceOrientation___get_flipX__impl__lgb7bx($this);
  var tmp36_rotation = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) ? _SliceOrientation___get_rotation__impl__m65r0o($this) : _SliceOrientation___get_rotation__impl__m65r0o($this).r40(2);
  return _SliceOrientation___init__impl__ewylib_0(tmp36_rotation, tmp35_flipX);
}
function SliceOrientation__rotatedRight_impl_m8di3g($this, offset) {
  return _SliceOrientation___init__impl__ewylib_0(_SliceOrientation___get_rotation__impl__m65r0o($this).r40(offset), _SliceOrientation___get_flipX__impl__lgb7bx($this));
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_14().u40_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_4;
function Companion_getInstance_14() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.e41_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_5;
function Companion_getInstance_15() {
  return Companion_instance_5;
}
function splitInRows(_this__u8e3s4, width, height) {
  return split(_this__u8e3s4, width, height, true);
}
function extract(_this__u8e3s4, offset, bits) {
  return (_this__u8e3s4 >>> offset | 0) & mask(bits);
}
function insert(_this__u8e3s4, value, offset) {
  var bits = 1 << offset;
  return value ? _this__u8e3s4 | bits : _this__u8e3s4 & ~bits;
}
function insert_0(_this__u8e3s4, value, offset, bits) {
  var mask_0 = mask(bits) << offset;
  var ovalue = value << offset & mask_0;
  return _this__u8e3s4 & ~mask_0 | ovalue;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.m43(i[0]), _this__u8e3s4.n43(i[0]), _this__u8e3s4.m43(i[1]), _this__u8e3s4.n43(i[1]), _this__u8e3s4.m43(i[2]), _this__u8e3s4.n43(i[2]), _this__u8e3s4.m43(i[3]), _this__u8e3s4.n43(i[3]));
}
function split(_this__u8e3s4, width, height, inRows) {
  var nheight = _this__u8e3s4.p41_1 / height | 0;
  var nwidth = _this__u8e3s4.o41_1 / width | 0;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.collections.arrayListOf' call
  var this_0 = ArrayList.m1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.slice.split.<anonymous>' call
  if (inRows) {
    var inductionVariable = 0;
    if (inductionVariable < nheight)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < nwidth)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_0.f(_this__u8e3s4.v42(imul(x, width), imul(y, height), width, height));
          }
           while (inductionVariable_0 < nwidth);
      }
       while (inductionVariable < nheight);
  } else {
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < nwidth)
      do {
        var x_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < nheight)
          do {
            var y_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            this_0.f(_this__u8e3s4.v42(imul(x_0, width), imul(y_0, height), width, height));
          }
           while (inductionVariable_2 < nheight);
      }
       while (inductionVariable_1 < nwidth);
  }
  return this_0;
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function _Item___init__impl__hhk1le(index) {
  return index;
}
function _Item___get_index__impl__lpanhd($this) {
  return $this;
}
function Item__toString_impl_d711m6($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p($this) {
  return $this;
}
function Item__equals_impl_qczid($this, other) {
  if (!(other instanceof Item))
    return false;
  if (!($this === (other instanceof Item ? other.b44_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
function _Item___init__impl__hhk1le_0(index) {
  return index;
}
function _Item___get_index__impl__lpanhd_0($this) {
  return $this;
}
function Item__toString_impl_d711m6_0($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p_0($this) {
  return $this;
}
function Item__equals_impl_qczid_0($this, other) {
  if (!(other instanceof Item_0))
    return false;
  if (!($this === (other instanceof Item_0 ? other.u44_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_7;
function Companion_getInstance_17() {
  return Companion_instance_7;
}
function toSegments(_this__u8e3s4, scale) {
  scale = scale === VOID ? 1 : scale;
  var segments = new FSegmentsInt();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
  var m = Vector2D.i2l();
  var l = Vector2D.i2l();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.m3y_1;
  var n_0 = 0;
  while (n_0 < this_0.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2h(tmp, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_1));
        m = it;
        l = it;
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2h(tmp_0, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0 = l;
        toSegments$emit(segments, scale, p0, it_0);
        l = it_0;
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.k2h(tmp_1, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.k2h(tmp_2, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_7));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0_0 = l;
        toSegments$emit_0(segments, scale, Bezier.p3w(p0_0, p1, p2));
        l = p2;
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.k2h(tmp_3, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.k2h(tmp_4, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.k2h(tmp_5, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_13));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0_1 = l;
        toSegments$emit_0(segments, scale, Bezier.q3w(p0_1, p1_0, p2_0, p3));
        l = p3;
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var equal = false ? l.vz(m) : l.equals(m);
        if (!equal) {
          // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call
          var p0_2 = l;
          var p1_1 = m;
          toSegments$emit(segments, scale, p0_2, p1_1);
        }

        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        break;
    }
  }
  return segments;
}
function segmentLookups($this, segments) {
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter' call
  var this_0 = segments.g45(SegmentIntToTrapezoidIntList$segmentLookups$lambda);
  // Inline function 'kotlin.also' call
  var this_1 = new FSegmentsInt();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable = 0;
  var last = this_0.j1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter.<anonymous>.<anonymous>' call
      var it = this_0.a45(n);
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      if (!(this_0.p45(it) === 0)) {
        this_1.y45(it, this_0);
      }
    }
     while (inductionVariable < last);
  var list = this_1;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_2 = fastArrayListOf([]);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_0 = 0;
  var last_0 = list.j1();
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      var it_0 = list.a45(n_0);
      var tmp$ret$3 = list.s45(it_0);
      this_2.f(tmp$ret$3);
    }
     while (inductionVariable_0 < last_0);
  var tmp = this_2;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_3 = fastArrayListOf([]);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_1 = 0;
  var last_1 = list.j1();
  if (inductionVariable_1 < last_1)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      var it_1 = list.a45(n_1);
      var tmp$ret$6 = list.t45(it_1);
      this_3.f(tmp$ret$6);
    }
     while (inductionVariable_1 < last_1);
  var allY = sortedArray(toIntArray(distinct(plus(tmp, this_3))));
  var tmp_0 = 0;
  var tmp_1 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = new FSegmentsInt();
    tmp_0 = tmp_0 + 1 | 0;
  }
  var initialSegmentsInY = toList_0(tmp_2);
  var tmp_3 = 0;
  var tmp_4 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_5 = fillArrayVal(Array(tmp_4), null);
  while (tmp_3 < tmp_4) {
    tmp_5[tmp_3] = new FSegmentsInt();
    tmp_3 = tmp_3 + 1 | 0;
  }
  var allSegmentsInY = toList_0(tmp_5);
  var listPivot = 0;
  var yPivot = 0;
  while (yPivot < allY.length && listPivot < list.j1()) {
    var currentY = allY[yPivot];
    var currentItem = list.a45(listPivot);
    // Inline function 'korlibs.math.geom.trapezoid.Item.use' call
    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
    if (list.s45(currentItem) === currentY) {
      initialSegmentsInY.i1(yPivot).y45(currentItem, list);
      listPivot = listPivot + 1 | 0;
    } else {
      yPivot = yPivot + 1 | 0;
    }
  }
  var inductionVariable_2 = 0;
  var last_2 = allY.length - 1 | 0;
  if (inductionVariable_2 <= last_2)
    do {
      var n_2 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_4 = initialSegmentsInY.i1(n_2);
      var inductionVariable_3 = 0;
      var last_3 = this_4.j1();
      if (inductionVariable_3 < last_3)
        do {
          var n_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
          var segment = this_4.a45(n_3);
          var inductionVariable_4 = n_2;
          var last_4 = allY.length;
          if (inductionVariable_4 < last_4)
            $l$loop: do {
              var m = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              var y = allY[m];
              if (!this_4.v45(segment, y) || this_4.t45(segment) === y)
                break $l$loop;
              allSegmentsInY.i1(m).y45(segment, this_4);
            }
             while (inductionVariable_4 < last_4);
        }
         while (inductionVariable_3 < last_3);
    }
     while (inductionVariable_2 <= last_2);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_4 = 0;
  while (n_4 < allSegmentsInY.j1()) {
    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
    var _unary__edvuaz = n_4;
    n_4 = _unary__edvuaz + 1 | 0;
    allSegmentsInY.i1(_unary__edvuaz).h45(SegmentIntToTrapezoidIntList$segmentLookups$lambda_0);
  }
  var inductionVariable_5 = 0;
  var last_5 = allY.length - 1 | 0;
  if (inductionVariable_5 <= last_5)
    do {
      var n_5 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_5 = allSegmentsInY.i1(n_5);
      var inductionVariable_6 = 0;
      var last_6 = this_5.j1();
      if (inductionVariable_6 < last_6)
        do {
          var n_6 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
          var segment_0 = this_5.a45(n_6);
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!this_5.v45(segment_0, allY[n_5])) {
            // Inline function 'kotlin.check.<anonymous>' call
            var message = 'Check failed.';
            throw IllegalStateException.m5(toString(message));
          }
        }
         while (inductionVariable_6 < last_6);
    }
     while (inductionVariable_5 <= last_5);
  return new Pair(allY, allSegmentsInY);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda($this$sortedBy, it) {
  return $this$sortedBy.s45(it.u44_1);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda_0($this$sortBy, it) {
  return $this$sortBy.r45(it.u44_1);
}
var SegmentIntToTrapezoidIntList_instance;
function SegmentIntToTrapezoidIntList_getInstance() {
  return SegmentIntToTrapezoidIntList_instance;
}
function det($this, x0, y0, x1, y1) {
  return imul(x0, y1) - imul(x1, y0) | 0;
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_19() {
  return Companion_instance_9;
}
function toSegments$emit(segments, $scale, p0, p1) {
  segments.f45(toIntRound(p0.i2h_1 * $scale), toIntRound(p0.j2h_1 * $scale), toIntRound(p1.i2h_1 * $scale), toIntRound(p1.j2h_1 * $scale));
}
function toSegments$emit_0(segments, $scale, bezier) {
  var len = coerceIn(toIntRound(bezier.a()), 2, 20);
  var oldPos = Vector2D.i2l();
  // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
  Companion_getInstance();
  var NS = len - 1 | 0;
  var NSd = NS;
  var start = true ? 0 : 1;
  var end = true ? NS : NS - 1 | 0;
  var inductionVariable = start;
  if (inductionVariable <= end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ratio = n / NSd;
      // Inline function 'korlibs.math.geom.trapezoid.toSegments.emit.<anonymous>' call
      var ratio_0 = toRatio(ratio);
      var p = bezier.l3t(ratio_0);
      if (Ratio__compareTo_impl_z2ienc(ratio_0, Companion_getInstance().f10_1) > 0) {
        toSegments$emit(segments, $scale, oldPos, p);
      }
      oldPos = p;
    }
     while (!(n === end));
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.wh();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.k47_1.r3e(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.t47(ax);
  var ibx = $this.t47(bx);
  var iay = $this.t47(ay);
  var iby = $this.t47(by);
  var edge = ay < by ? $this.e47_1.g39().u47(iax, iay, ibx, iby, 1) : $this.e47_1.g39().u47(ibx, iby, iax, iay, -1);
  $this.h47_1.f(edge);
  if (isHorizontal) {
    $this.g47_1.f(edge);
  } else {
    $this.f47_1.f(edge);
    $this.i47_1.a47(edge);
  }
  $this.d47_1 = BoundsBuilder__plus_impl_cz7f7x($this.d47_1, Vector2D.k2h(ax, ay));
  $this.d47_1 = BoundsBuilder__plus_impl_cz7f7x($this.d47_1, Vector2D.k2h(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
var Companion_instance_10;
function Companion_getInstance_20() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_21() {
  return Companion_instance_11;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.x48_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = toCurvesList(_this__u8e3s4);
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var list = toDashes(element, lineDash.i13(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.f1();
    while (tmp0_iterator_0.g1()) {
      var item = tmp0_iterator_0.h1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var tmp$ret$3 = toVectorPath_1(item);
      destination_0.f(tmp$ret$3);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.j1()) {
    // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.i1(_unary__edvuaz);
    temp.f4a(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.n3s_1, info.s3s_1, info.q3s_1, info.r3s_1, info.t3s_1, info.u3s_1, info.v3s_1, temp, outFill);
}
function t($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.j4a_1;
    if (this_0.n2i()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2h(this_0.d2n(p.i2h_1, p.j2h_1), this_0.g2n(p.i2h_1, p.j2h_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCacheVersion$delegate;
  var property = _curvesCacheVersion$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCacheVersion$delegate;
    var property = _curvesCacheVersion$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCache$delegate;
  var property = _curvesCache$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCache$delegate;
    var property = _curvesCache$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_12;
function Companion_getInstance_22() {
  return Companion_instance_12;
}
function ensureMoveTo($this, p) {
  if ($this.y2k())
    return false;
  $this.e3y(p);
  return true;
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.r3y_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.r3y_1);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.m1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>' call
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.m1()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.i2l();
    var l = Vector2D.i2l();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.m3y_1;
    var n_0 = 0;
    while (n_0 < this_1.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2h(tmp, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_1));
          m = it;
          l = it;
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2h(tmp_0, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_2 = current._v;
          var element = Bezier.o3w(p1, it_0);
          this_2.f(element);
          l = it_0;
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p1_0 = Vector2D.k2h(tmp_1, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.k2h(tmp_2, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_7));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_3 = current._v;
          var element_0 = Bezier.p3w(p1_1, p1_0, p2);
          this_3.f(element_0);
          l = p2;
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p1_2 = Vector2D.k2h(tmp_3, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p2_0 = Vector2D.k2h(tmp_4, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.k2h(tmp_5, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_13));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_3 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_4 = current._v;
          var element_1 = Bezier.q3w(p1_3, p1_2, p2_0, p3);
          this_4.f(element_1);
          l = p3;
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var equal = true ? l.vz(m) : l.equals(m);
          if (!equal) {
            // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call
            var p1_4 = l;
            var p2_1 = m;
            // Inline function 'kotlin.collections.plusAssign' call
            var this_5 = current._v;
            var element_2 = Bezier.o3w(p1_4, p2_1);
            this_5.f(element_2);
          }

          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          currentClosed._v = true;
          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
      }
    }
    getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function plus_0(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this$0) {
  return function () {
    return SegmentIntToTrapezoidIntList_instance.a46(this$0.r4b_1, Winding_EVEN_ODD_getInstance());
  };
}
function VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this$0) {
  return function () {
    return SegmentIntToTrapezoidIntList_instance.a46(this$0.r4b_1, Winding_NON_ZERO_getInstance());
  };
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_4().j2m_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.a1() && path.y2k()) {
    path.j4b(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.j1()) {
    // Inline function 'korlibs.math.geom.vector.with.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.i1(_unary__edvuaz).y3t_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.with.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.i1(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.l2j_1, bezier.u3w(transform)));
    }
  }
  return bb._v.l2j_1;
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.m3y_1;
  var n_0 = 0;
  while (n_0 < this_0.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
        _this__u8e3s4.e3y(it);
        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
        _this__u8e3s4.g3y(it_0);
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
        _this__u8e3s4.h3y(p1, p2);
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
        _this__u8e3s4.j3y(p1_0, p2_0, p3);
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        _this__u8e3s4.u6();
        break;
    }
  }
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.m1();
  var tmp0_iterator = curvesList.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.math.geom.vector.getCurves.<anonymous>' call
    var list = element.y3t_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.z3t_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.o2i()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.n3y_1.j1()), 2);
    var inductionVariable = progression.k2_1;
    var last = progression.l2_1;
    var step_0 = progression.m2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.applyTransform.<anonymous>' call
        var it = Vector2D.k2h(_this__u8e3s4.n3y_1.i1(n + 0 | 0), _this__u8e3s4.n3y_1.i1(n + 1 | 0));
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.n2i()) {
            tmp$ret$0 = it;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.k2h(m.d2n(it.i2h_1, it.j2h_1), m.g2n(it.i2h_1, it.j2h_1));
        }
        var p = tmp$ret$0;
        _this__u8e3s4.n3y_1.p32(n + 0 | 0, p.i2h_1);
        _this__u8e3s4.n3y_1.p32(n + 1 | 0, p.j2h_1);
      }
       while (!(n === last));
    _this__u8e3s4.r3y_1 = _this__u8e3s4.r3y_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurvesList$_anonymous_$flush_1e57i7(current, $out, currentClosed, $this_getCurvesList) {
  if (current._v.a1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>$flush.<anonymous>' call
  this_0.a3u_1 = $this_getCurvesList.q3y_1;
  $out.f(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.m1();
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$factory() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCacheVersion$factory_0() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCache$factory() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function _curvesCache$factory_0() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function trapezoidsEvenOdd$factory() {
  return getPropertyCallableRef('trapezoidsEvenOdd', 1, KProperty1, function (receiver) {
    return receiver.z4b();
  }, null);
}
function trapezoidsNonZero$factory() {
  return getPropertyCallableRef('trapezoidsNonZero', 1, KProperty1, function (receiver) {
    return receiver.a4c();
  }, null);
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_14;
function Companion_getInstance_24() {
  return Companion_instance_14;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_ROUND_getInstance() {
  LineJoin_initEntries();
  return LineJoin_ROUND_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineCap_ROUND_getInstance() {
  LineCap_initEntries();
  return LineCap_ROUND_instance;
}
function LineScaleMode_NONE_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NONE_instance;
}
function LineScaleMode_HORIZONTAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_HORIZONTAL_instance;
}
function LineScaleMode_VERTICAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_VERTICAL_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function MPoint$Companion$POOL$lambda(it) {
  it.r4c(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_27().l2m();
}
var Companion_instance_17;
function Companion_getInstance_27() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.n4d();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_18;
function Companion_getInstance_28() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_29() {
  return Companion_instance_19;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.wh();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_30().l2m();
}
var Companion_instance_20;
function Companion_getInstance_30() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function _MSize___init__impl__75ig0l(p) {
  return p;
}
function _MSize___get_p__impl__s4wlk0($this) {
  return $this;
}
var Companion_instance_21;
function Companion_getInstance_31() {
  return Companion_instance_21;
}
function _MSize___get_width__impl__pdw3p2($this) {
  return _MSize___get_p__impl__s4wlk0($this).p4c_1;
}
function _MSize___get_height__impl__p0y67b($this) {
  return _MSize___get_p__impl__s4wlk0($this).q4c_1;
}
function get_immutable(_this__u8e3s4) {
  return Size2D.k2t(_MSize___get_width__impl__pdw3p2(_this__u8e3s4), _MSize___get_height__impl__p0y67b(_this__u8e3s4));
}
function get_immutable_0(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get_mutable(_this__u8e3s4) {
  return new MMatrix(_this__u8e3s4.n2m_1, _this__u8e3s4.o2m_1, _this__u8e3s4.p2m_1, _this__u8e3s4.q2m_1, _this__u8e3s4.r2m_1, _this__u8e3s4.s2m_1);
}
function get_mutable_0(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.i2i_1, _this__u8e3s4.j2i_1, _this__u8e3s4.k2i_1, _this__u8e3s4.l2i_1);
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.n2i())
    return Companion_getInstance_7().s2p_1;
  return Companion_getInstance_7().e2q(_this__u8e3s4.n2m_1, _this__u8e3s4.p2m_1, 0.0, _this__u8e3s4.r2m_1, _this__u8e3s4.o2m_1, _this__u8e3s4.q2m_1, 0.0, _this__u8e3s4.s2m_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
var Companion_instance_22;
function Companion_getInstance_32() {
  return Companion_instance_22;
}
function bounds(_this__u8e3s4, target) {
  target = target === VOID ? Companion_getInstance_30().l2m() : target;
  var first = true;
  var left = 0.0;
  var right = 0.0;
  var top = 0.0;
  var bottom = 0.0;
  var _iterator__ex2g4s = _this__u8e3s4.f1();
  while (_iterator__ex2g4s.g1()) {
    var r = _iterator__ex2g4s.h1();
    if (first) {
      left = r.p2i();
      right = r.q2i();
      top = r.r2i();
      bottom = r.s2i();
      first = false;
    } else {
      // Inline function 'kotlin.math.min' call
      var a = left;
      var b = r.p2i();
      left = Math.min(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = right;
      var b_0 = r.q2i();
      right = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = top;
      var b_1 = r.r2i();
      top = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.max' call
      var a_2 = bottom;
      var b_2 = r.s2i();
      bottom = Math.max(a_2, b_2);
    }
  }
  return target.v4e(left, top, right, bottom);
}
var Companion_instance_23;
function Companion_getInstance_33() {
  return Companion_instance_23;
}
function get_immutable_1(_this__u8e3s4) {
  return Companion_getInstance_7().d2q(_this__u8e3s4.v4g_1);
}
function get_mutable_1(_this__u8e3s4) {
  return (new MMatrix4()).o4h(_this__u8e3s4.l2r(), 0);
}
function lineIntersectionPoint(_this__u8e3s4, l1, l2) {
  return l1.g4e(l2);
}
function projectedPoint(_this__u8e3s4, point) {
  return projectedPoint_0(Companion_instance_19, _this__u8e3s4.p3t_1, _this__u8e3s4.q3t_1, point);
}
function projectedPoint_0(_this__u8e3s4, v1, v2, point) {
  return projectedPoint_1(_this__u8e3s4, v1.i2h_1, v1.j2h_1, v2.i2h_1, v2.j2h_1, point.i2h_1, point.j2h_1);
}
function projectedPoint_1(_this__u8e3s4, v1x, v1y, v2x, v2y, px, py) {
  var e1x = v2x - v1x;
  var e1y = v2y - v1y;
  var e2x = px - v1x;
  var e2y = py - v1y;
  var valDp = Companion_getInstance_27().u4c(e1x, e1y, e2x, e2y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE1 = hypot(e1x, e1y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE2 = hypot(e2x, e2y);
  if (lenLineE1 === 0.0 || lenLineE2 === 0.0) {
    return Vector2D.k2h(px, py);
  }
  var cos = valDp / (lenLineE1 * lenLineE2);
  var projLenOfLine = cos * lenLineE2;
  return Vector2D.k2h(v1x + projLenOfLine * e1x / lenLineE1, v1y + projLenOfLine * e1y / lenLineE1);
}
function MBoundsBuilder$Companion$POOL$lambda(it) {
  it.z33();
  return Unit_instance;
}
function MBoundsBuilder$Companion$POOL$lambda_0(it) {
  return new MBoundsBuilder();
}
var Companion_instance_24;
function Companion_getInstance_34() {
  if (Companion_instance_24 === VOID)
    new Companion_24();
  return Companion_instance_24;
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.b2();
}
var _ALL_LIST$delegate;
function get__ALL() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL$delegate;
  _ALL$factory();
  return this_0.b2();
}
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.h4j_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance().f10_1))
    return p[0];
  if (equals(t, Companion_getInstance().i10_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance().i10_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].c2t(a).k4l(p[1].c2t(b)).k4l(p[2].c2t(c)).k4l(p[3].c2t(d));
}
function cubic(_this__u8e3s4, x1, y1, x2, y2, name) {
  name = name === VOID ? null : name;
  _init_properties_Easings_kt__swvzhy();
  return EasingCubic.l4l(x1, y1, x2, y2, name);
}
function get_EASE_CLAMP_START(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_CLAMP_START_getInstance();
}
function get_EASE_CLAMP_END(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_CLAMP_END_getInstance();
}
function get_EASE(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_getInstance();
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function get_EASE_IN(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_getInstance();
}
function get_ALL(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return get__ALL();
}
function get_EASE_IN_OUT(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_getInstance();
}
function get_EASE_OUT(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_OUT_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.wc(capacity);
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.u3_1;
    destination.r3(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
function _ALL$factory() {
  return getPropertyCallableRef('_ALL', 0, KProperty0, function () {
    return get__ALL();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function get_niceStr_1(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
function interpolate_4(_this__u8e3s4, l, r) {
  return Companion_getInstance_4().y2m(l, r, _this__u8e3s4);
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(StrokePointsMode, 'StrokePointsMode');
initMetadataForClass(StrokePointsBuilder, 'StrokePointsBuilder');
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
protoOf(ProjectedPoint).vz = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).vz = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.n3w, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(Result, 'Result');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(BVH2D, 'BVH2D', BVH2D);
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForClass(BaseShape2D, 'BaseShape2D');
initMetadataForClass(CircleShape2D, 'CircleShape2D');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).p2i = get_left;
protoOf(RectSlice).r2i = get_top;
protoOf(RectSlice).q2i = get_right;
protoOf(RectSlice).s2i = get_bottom;
protoOf(RectSlice).x2u = get_area;
protoOf(RectSlice).k43 = get_frameOffsetX;
protoOf(RectSlice).l43 = get_frameOffsetY;
protoOf(RectSlice).m43 = x;
protoOf(RectSlice).n43 = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_5);
protoOf(SliceCoordsImpl).k43 = get_frameOffsetX;
protoOf(SliceCoordsImpl).l43 = get_frameOffsetY;
protoOf(SliceCoordsImpl).m43 = x;
protoOf(SliceCoordsImpl).n43 = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectCoords).m43 = x;
protoOf(RectCoords).n43 = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(Item, 'Item');
initMetadataForClass(FTrapezoidsInt, 'FTrapezoidsInt', FTrapezoidsInt);
initMetadataForCompanion(Companion_7);
initMetadataForClass(SortOps_0, 'SortOps');
initMetadataForClass(Item_0, 'Item');
initMetadataForClass(FSegmentsInt, 'FSegmentsInt', FSegmentsInt);
initMetadataForObject(SegmentIntToTrapezoidIntList, 'SegmentIntToTrapezoidIntList');
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_10);
initMetadataForCompanion(Companion_11);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).l4a = line;
protoOf(VectorBuilder$transformed$1).m4a = arcTo;
protoOf(VectorBuilder$transformed$1).a1 = isEmpty;
protoOf(VectorBuilder$transformed$1).n4a = rect;
protoOf(VectorBuilder$transformed$1).o4a = rect_0;
protoOf(VectorBuilder$transformed$1).p4a = rect_1;
protoOf(VectorBuilder$transformed$1).q4a = roundRect;
protoOf(VectorBuilder$transformed$1).r4a = arc;
protoOf(VectorBuilder$transformed$1).s4a = arc$default;
protoOf(VectorBuilder$transformed$1).m3s = circle;
protoOf(VectorBuilder$transformed$1).t4a = lineToH;
protoOf(VectorBuilder$transformed$1).u4a = lineToV;
protoOf(VectorBuilder$transformed$1).v4a = rLineToH;
protoOf(VectorBuilder$transformed$1).w4a = rLineToV;
protoOf(VectorBuilder$transformed$1).x4a = rMoveTo;
protoOf(VectorBuilder$transformed$1).y4a = rLineTo;
protoOf(VectorBuilder$transformed$1).j2u = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_12);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).b48 = moveTo;
protoOf(VectorPath).c48 = lineTo;
protoOf(VectorPath).z4a = quadTo_0;
protoOf(VectorPath).l4a = line;
protoOf(VectorPath).m4a = arcTo;
protoOf(VectorPath).a1 = isEmpty;
protoOf(VectorPath).y2k = isNotEmpty;
protoOf(VectorPath).n4a = rect;
protoOf(VectorPath).o4a = rect_0;
protoOf(VectorPath).p4a = rect_1;
protoOf(VectorPath).q4a = roundRect;
protoOf(VectorPath).r4a = arc;
protoOf(VectorPath).s4a = arc$default;
protoOf(VectorPath).m3s = circle;
protoOf(VectorPath).t4a = lineToH;
protoOf(VectorPath).u4a = lineToV;
protoOf(VectorPath).v4a = rLineToH;
protoOf(VectorPath).f4b = rLineToH_0;
protoOf(VectorPath).w4a = rLineToV;
protoOf(VectorPath).g4b = rLineToV_0;
protoOf(VectorPath).x4a = rMoveTo;
protoOf(VectorPath).e4b = rMoveTo_0;
protoOf(VectorPath).y4a = rLineTo;
protoOf(VectorPath).d4b = rLineTo_0;
protoOf(VectorPath).j2u = transformed;
protoOf(VectorPath).h4b = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
initMetadataForClass(VectorPathTrapezoids, 'VectorPathTrapezoids');
protoOf(with$1).u6 = close;
protoOf(with$1).g3y = lineTo_0;
protoOf(with$1).h3y = quadTo_1;
protoOf(with$1).j3y = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_14);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_15);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_17);
protoOf(MPoint).vz = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_19);
initMetadataForClass(MLine, 'MLine', MLine.d4e);
initMetadataForCompanion(Companion_20);
protoOf(MRectangle).vz = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_21);
initMetadataForCompanion(Companion_22);
initMetadataForClass(MVector4, 'MVector4', MVector4);
initMetadataForCompanion(Companion_23);
initMetadataForClass(MMatrix4, 'MMatrix4', MMatrix4);
initMetadataForCompanion(Companion_24);
initMetadataForClass(MBoundsBuilder, 'MBoundsBuilder', MBoundsBuilder);
protoOf(Easings).yz = invoke;
protoOf(Easings).zz = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).yz = invoke;
protoOf(EasingCubic).zz = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
SegmentIntToTrapezoidIntList_instance = new SegmentIntToTrapezoidIntList();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
Companion_instance_14 = new Companion_14();
Companion_instance_15 = new Companion_15();
Companion_instance_16 = new Companion_16();
Companion_instance_19 = new Companion_19();
Companion_instance_21 = new Companion_21();
Companion_instance_22 = new Companion_22();
Companion_instance_23 = new Companion_23();
//endregion
//region block: exports
export {
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance8e3pzrc8s6ce,
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance2tae82ty68yvy,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstanceb57ygh36gdst,
  LineCap_ROUND_getInstance as LineCap_ROUND_getInstance29bkl1dpat5pj,
  LineCap_SQUARE_getInstance as LineCap_SQUARE_getInstancemqgc8h2k247o,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstance3doesgezxmixn,
  LineScaleMode_HORIZONTAL_getInstance as LineScaleMode_HORIZONTAL_getInstance3elygu0hslt3a,
  LineScaleMode_NONE_getInstance as LineScaleMode_NONE_getInstance2502q1le8nox0,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance349p0dssy4fun,
  LineScaleMode_VERTICAL_getInstance as LineScaleMode_VERTICAL_getInstance1y4ujr6379lzf,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstance2nlckv54zgzhj,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance2zsru2lm79i6x,
  arc$default as arc$default2o4ca59st3p6v,
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bxjxyk0h8ndav,
  SliceOrientation__flippedX_impl_m25zo9 as SliceOrientation__flippedX_impl_m25zo9238kxt6n8vuqd,
  SliceOrientation__flippedY_impl_mj7m2g as SliceOrientation__flippedY_impl_mj7m2g3ohocif0hlnub,
  SliceOrientation__hashCode_impl_7mjkdw as SliceOrientation__hashCode_impl_7mjkdw2ysf4kjaf6c21,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2xqbs5alo5x1q,
  _SliceOrientation___get_raw__impl__tj3u8w as _SliceOrientation___get_raw__impl__tj3u8w3gfaax2oun1df,
  SliceOrientation__rotatedRight_impl_m8di3g as SliceOrientation__rotatedRight_impl_m8di3ghw918f3d536q,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0o1742ytu7rgu88,
  SliceOrientation__toString_impl_tdph6r as SliceOrientation__toString_impl_tdph6rkheevwtbsa49,
  Companion_getInstance_9 as Companion_getInstance2yrgpxwoeu923,
  Companion_instance_1 as Companion_instance3s1b22cepz6i7,
  Companion_instance_5 as Companion_instance104pvig6e11lu,
  Companion_getInstance_14 as Companion_getInstance2cvx1jnjzsvrw,
  Companion_instance_15 as Companion_instance1s5n1f8qczy96,
  Companion_instance_14 as Companion_instancepc31xltlz6n5,
  Companion_instance_16 as Companion_instance2fenvsumzjhz2,
  Companion_getInstance_27 as Companion_getInstance2iuza9dwssjbj,
  Companion_getInstance_30 as Companion_getInstance266qhgy61dybo,
  Companion_instance_22 as Companion_instance1oet36wi14ql2,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  Bezier as Bezier1nrnsph9esuxa,
  get_isConvex as get_isConvex3nm4n5empqw0n,
  toBezier as toBezier1cphbqwqpx0d3,
  toStrokePointsList as toStrokePointsList2dojuc3rfktd4,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  BVH2D as BVH2D1qwjbargslfq8,
  toRectangle as toRectangle3rq2j924qufrq,
  get_cachedPoints as get_cachedPoints16ehjcv6uuio1,
  getPoints2List as getPoints2List1zux0vi6zk0wt,
  toShape2D as toShape2D2vgft60vvvqgq,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  splitInRows as splitInRows1cyiez6sz0yy1,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arcTo as arcTo1g4ivunekrrtg,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  ellipse as ellipse2rxvxxfaddo1k,
  isEmpty as isEmpty3b7xkdp0by4c8,
  lineToH as lineToHqj5ppmwlqa9l,
  lineToV as lineToV2af0qnj7t3mk2,
  lineTo as lineTo35eirmrqxz1l0,
  line as line3u2mk0n2uhnlh,
  moveTo as moveTo1v59p8psmu2yv,
  rLineToH as rLineToH2txnr065wfrbz,
  rLineToV as rLineToV3iwt0xj4dbrft,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_0 as rect31bppuugx2wch,
  rect_2 as rect31ka0uv7vbtav,
  rect_1 as rect3nqbmqh4a4l2a,
  roundRect as roundRect2sqmspzw5002d,
  roundRect_0 as roundRect3456nlcytya47,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus_0 as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MBoundsBuilder as MBoundsBuilder153gzhei3ukb0,
  MMatrix4 as MMatrix4250i8g1w6yxgo,
  MMatrix as MMatrix1y71lv7vv6y8t,
  MPoint as MPoint2sx5s6wh6byii,
  MVector4 as MVector42dr6dus5luca5,
  bounds as bounds3w4bgsrpsjcra,
  get_immutable_1 as get_immutable3bx5i4my5ro9n,
  get_immutable_0 as get_immutablepxpdoj6e54ll,
  get_mutable as get_mutable10c8ws0x48eez,
  get_mutable_0 as get_mutableqzgwrema46rx,
  get_mutable_1 as get_mutable3t5h9feuvhrnv,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_ALL as get_ALL2kw5hdxomut5y,
  get_EASE as get_EASElq2v0gsk9fz7,
  get_EASE_CLAMP_END as get_EASE_CLAMP_END2i469hpc6wipw,
  get_EASE_CLAMP_START as get_EASE_CLAMP_START3mw7sc31t8amo,
  get_EASE_IN as get_EASE_IN3dgilxucimnao,
  get_EASE_IN_OUT as get_EASE_IN_OUT1plt1ext4tf71,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  get_EASE_OUT as get_EASE_OUT38lbythvs83tj,
  cubic as cubic3uw6rftl1cilc,
  interpolate_4 as interpolate2729pk90l3f88,
  get_0 as getff2jwkktgke3,
  get as get28v0piq7i0vt,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
